import {
  DiscoveryCategoryResponse,
  DiscoveryPlaceResponse,
  DiscoveryPlaceSimpleResponse,
  DiscoveryResponse,
} from '~kup/models/Discovery.ts';

// Define categories
export const DISCOVERY_CATEGORIES: DiscoveryCategoryResponse[] = [
  {
    id: 'discovery-food',
    slug: 'discovery-food',
    name: 'Food',
    createdAt: '2024-10-02T08:58:50.301Z',
    updatedAt: '2024-10-02T08:58:50.301Z',
  },
  {
    id: 'discovery-beauty',
    slug: 'discovery-beauty',
    name: 'Beauty',
    createdAt: '2024-10-02T08:58:50.301Z',
    updatedAt: '2024-10-02T08:58:50.301Z',
  },
];

const PLACE_DETAILS: {
  [id: string]: DiscoveryPlaceResponse & DiscoveryPlaceSimpleResponse;
} = {
  // 홍대
  'fried-pigs-feet-a-crunch-above-the-rest': {
    id: 'fried-pigs-feet-a-crunch-above-the-rest',
    slug: 'fried-pigs-feet-a-crunch-above-the-rest',
    url: '/discovery/place/fried-pigs-feet-a-crunch-above-the-rest',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F72fe9b2b-ddb9-4c2a-a327-9d3d7f6f83fd?alt=media&token=966c3e78-ba28-4717-85b7-37414511baa5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F22c47738-86c8-490f-bff1-370d79eda3d5?alt=media&token=28bd6bf1-1d7e-4ed9-81af-28f2f6f74a4b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffb8de35c-87dc-413d-af42-270c2ff5b8e0?alt=media&token=ff2f9738-8966-497b-ac2f-09f226a326e5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fced0aa2a-5ffa-4d16-a201-05b76a5c0985?alt=media&token=dfdaf494-666e-4f22-b2df-ca55ab5f4779',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F81300c72-77a4-442e-96f9-7782095b1485?alt=media&token=1b0f89eb-6460-4332-a4ae-4abe2cd72f05',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe623b66d-e608-4514-af28-8b1a3d3f2b15?alt=media&token=f0ea9a0d-b926-49a6-81fa-26c57c4828b3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff0b0f206-1709-4fd1-9e31-adb96d9080cf?alt=media&token=31ebe34e-8a3b-4c3f-b990-dc0c3f783194',
    ],
    name: "Yeonnam Pig's Feet 1987",
    priceLevel: 3,
    tags: ['FriedPigsFeet', 'Korean'],
    location: {
      address: '222, Donggyo-ro, Mapo-gu, Seoul',
      area: 'Hongik University, Yeonnam ',
      latlng: [37.559937, 126.923976],
      subway: 'Line 2, GYEONGUI-JOUNGANG LINE, AIRPORT RAILROAD',
      nearBy: 'Hongik Univ. Station',
      googleMap: 'https://maps.app.goo.gl/mHHY5eGMw2YfRA7u9',
    },
    address: '222, Donggyo-ro, Mapo-gu, Seoul',
    latlng: [37.559937, 126.923976],
    information: [
      {
        label: 'Phone Number',
        value: '070-7760-1086',
      },
      {
        label: 'Business Hours',
        value: '12:00 - 24:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '족발튀김 한상',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff0b0f206-1709-4fd1-9e31-adb96d9080cf?alt=media&token=31ebe34e-8a3b-4c3f-b990-dc0c3f783194',
        name: '족발튀김 한상',
        subheader: "Fried Pig's Feet",
        description:
          "Fried Pig's Feet + 11 Side Dishes + Sundae Soup + Wrap Vegetables + Tasting Buckwheat Noodles",
        price: 'KRW49,000',
      },
    ],
    html: '<h1>Yeonnam Pig\'s Feet 1987 연남족발 1987</h1><p><br></p><p>Today, I’m excited to share a hidden gem in <strong>Hongdae</strong>, Seoul, specializing in fried pig\'s feet! Yes, you heard that right! This isn’t your typical pig\'s feet place;<strong> it’s all about the fried ones!</strong> You’ve either never tried them or can’t get enough! I was curious and decided to give them a shot, and I fell in love! Now I think about that delicious bite every day, and my only regret is not trying them sooner!</p><p><br></p><p><strong style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Highlight:</strong><span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);"> The fried pig\'s trotters are drizzled with sweet mayonnaise, making them irresistibly soft and chewy! Their signature dish is the big pork knuckle, perfectly sliced—not too thick, not too thin—with crispy edges. The first bite had me nearly in tears; it’s just that good! Crispy on the outside, juicy on the inside—simply perfect!</span></p><p><br></p><p><strong>Location:</strong> Approximately 200 meters from Exit 3 of Hongik Univ. Station</p><p><br></p><p><strong>Note:</strong> Reservations are accepted via Naver to avoid wait times.</p>',
    description:
      "Specializing in fried pig's feet drizzled with sweet mayonnaise and perfectly sliced pork knuckle.",
    createdAt: '',
    updatedAt: '2024-10-16T23:51:26.436Z',
  },
  'suragan-home-cooked-korean-comfort-taste-the-love': {
    id: 'suragan-home-cooked-korean-comfort-taste-the-love',
    slug: 'suragan-home-cooked-korean-comfort-taste-the-love',
    url: '/discovery/place/suragan-home-cooked-korean-comfort-taste-the-love',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faf3f3bb8-4ccb-4802-9904-a8ece3632901?alt=media&token=dde19bdd-a0e0-48cb-9d85-fc38794f022e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3673cf4e-5bf4-46b8-8a92-5e90a4f0b792?alt=media&token=80f930ab-6ce6-4458-aaf7-88c567066861',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F73b73283-7d73-4477-b46f-e32628f39b84?alt=media&token=2dfd6b4b-b4d7-444f-94ff-5c789d1e42ed',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8f753a06-ade7-406a-9ce0-338d69664475?alt=media&token=6ec749f8-dd14-470a-bf61-cc262a552d43',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2e5e11c4-4d11-4943-b6c1-6e3cbe476e32?alt=media&token=c642b687-b4c6-4de5-8709-6c081faf3b56',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4e53c7c9-0b8e-436b-b85f-d966f9fa7fc2?alt=media&token=d336d7bc-2367-4e76-ba34-3afc6cb76af8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc4fcf75f-4c94-4071-a215-ed2dd12bb33f?alt=media&token=328bdee7-a298-4496-a2ee-02795092fbc4',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa50f19ee-f186-4332-b519-c00165785b76?alt=media&token=777c81bc-8ebe-475c-b046-80052b1ed1b8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c4e14ed-5ea6-476f-a88b-42b865303df8?alt=media&token=82a3d6a9-ed96-46f0-8e3a-1e8d4b21cad1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6b63c57c-10aa-4a18-9265-142bfc18611e?alt=media&token=c7520ac8-5e7c-48c1-8750-6730c4a8ff5f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F16036374-e79f-4cc5-a17a-3b4602fc1262?alt=media&token=fe2ceb17-250a-463a-a98d-4340fa0b9f68',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F722a8dd4-e88f-4da9-a282-cde3105c7d63?alt=media&token=462af301-5cb3-44d4-a84e-0b902f37acc3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9755563d-5d08-415e-bc16-c4fdf61f05d0?alt=media&token=9963ea6c-c23e-4ba8-a631-1216eec3e5fd',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F89bdcb9b-9485-4be7-a616-f80bb7c16ce9?alt=media&token=595d5e8c-7b04-491f-8836-fa34c7c7cbf3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1deb81c5-6520-4c5e-a943-f31f771382fd?alt=media&token=ac502882-0504-41fa-a07d-7cefc8586374',
    ],
    name: 'Suragan',
    priceLevel: 2,
    tags: ['Korean', 'Homemade'],
    location: {
      address: '3, Donggyo-ro 38an-gil, Mapo-gu, Seoul',
      area: 'Hongik University, Yeonnam ',
      latlng: [37.56478, 126.922752],
      subway: 'Line 2, GYEONGUI-JOUNGANG LINE, AIRPORT RAILROAD',
      nearBy: 'Hongik Univ. Station',
      googleMap: 'https://maps.app.goo.gl/Xoa1TVY2vKUvZ9Gy7',
    },
    address: '3, Donggyo-ro 38an-gil, Mapo-gu, Seoul',
    latlng: [37.56478, 126.922752],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1330-4335',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'Tuesday',
      },
      {
        label: 'Break Time',
        value: '15:30 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '닭볶음탕, 감자전, 명란계란말이, 왕새우부추 ',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c4e14ed-5ea6-476f-a88b-42b865303df8?alt=media&token=82a3d6a9-ed96-46f0-8e3a-1e8d4b21cad1',
        name: '닭볶음탕 ',
        subheader: 'Spicy Korean Chicken Stew',
        description:
          ' Spicy Korean chicken stew made with tender chicken pieces, potatoes, carrots, and onions, all simmered in a flavorful gochujang-based sauce that’s both savory, spicy and slightly sweet.',
        price: 'KRW32,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F89bdcb9b-9485-4be7-a616-f80bb7c16ce9?alt=media&token=595d5e8c-7b04-491f-8836-fa34c7c7cbf3',
        name: '감자전',
        subheader: 'Korean Potato Pancakes',
        description:
          'A Korean potato pancake made from grated potatoes, pan-fried until golden and crispy, and served with a flavorful soy-based dipping sauce.',
        price: 'KRW15,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1deb81c5-6520-4c5e-a943-f31f771382fd?alt=media&token=ac502882-0504-41fa-a07d-7cefc8586374',
        name: '명란계란말이',
        subheader: 'Korean Rolled Omelette',
        description: 'A Korean rolled omelette filled with savory cod roe',
        price: 'KRW17,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2e5e11c4-4d11-4943-b6c1-6e3cbe476e32?alt=media&token=c642b687-b4c6-4de5-8709-6c081faf3b56',
        name: '왕새우부추전 ',
        subheader: 'Shrimp and Chives Korean Pancakes',
        description:
          'A Korean savory pancake made with plump king prawns and fragrant chives, pan-fried until crispy and golden for a delightful blend of flavors and textures.',
        price: 'KRW21,000',
      },
    ],
    html: '<h1>Suragan 수라간</h1><p><br></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">I’m excited to share another hidden gem with you all! Today, I’m introducing a Korean restaurant located near to Hongik University! </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">This place aims to give guests the feeling of enjoying home-cooked meals like Mom used to make—warm and delicious!</span></p><p><br></p><p><strong>Location:</strong> Approximately 462 meters from Exit 3 of Hongik Univ. Station.</p><p><br></p><p><strong>Note:</strong> <span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">The restaurant has fewer than 7 tables and is quite popular, so expect to wait during peak hours. When you take a number to queue, the staff will inform you of the approximate waiting time, and they are very friendly, especially towards foreigners!</span></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">The menu is available in both English and Korean, with hand-drawn illustrations of the recommended dishes, making it very simple and clear.</span></p>',
    description:
      'A charming Korean restaurant near Hongik University that offers the warmth and deliciousness of home-cooked meals.',
    createdAt: '',
    updatedAt: '2024-10-17T00:39:55.713Z',
  },
  'pul-tteunneun-pig-redefines-bbq-experience-the-freshness-of-pork-and-minari': {
    id: 'pul-tteunneun-pig-redefines-bbq-experience-the-freshness-of-pork-and-minari',
    slug: 'pul-tteunneun-pig-redefines-bbq-experience-the-freshness-of-pork-and-minari',
    url: '/discovery/place/pul-tteunneun-pig-redefines-bbq-experience-the-freshness-of-pork-and-minari',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F34458718-c625-4f5c-8674-adfb7f13fc3d?alt=media&token=6af21b3f-5193-4af3-a8c4-690cef7455d5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbc9f1a53-ecc9-4858-8736-3d09eb5426f4?alt=media&token=99f4da6e-839f-443a-88eb-1e47e5c5a3d0',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe2c7ddc2-b770-4673-82af-68b6d17cfd20?alt=media&token=8760439e-2a04-4e9d-8736-3597bea0d41e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F542ebb8f-c6e8-4782-a2e2-ac7cbc5b29d0?alt=media&token=2cae046b-2e9a-4a19-8ecf-419289db9abc',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F320836aa-5a77-45a6-93da-064d864d162d?alt=media&token=d7ed3911-236d-4d82-b991-71fd71e4bc09',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6caa1d8b-427c-49f0-a7d7-9eea318ba759?alt=media&token=25f1fde1-efac-410c-9e3d-e74af54eb862',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe43bca24-753b-4318-b3a6-64225d2aedbc?alt=media&token=a81047ec-8976-4a1a-9ed3-b25ff3743988',
    ],
    name: 'Pul Tteunneun Pig',
    priceLevel: 3,
    tags: ['KoreanBBQ', 'Minari'],
    location: {
      address: '7, Donggyo-ro 32-gil, Mapo-gu, Seoul',
      area: 'Hongik University, Yeonnam ',
      latlng: [37.560899, 126.924723],
      subway: 'Line 2, GYEONGUI-JOUNGANG LINE, AIRPORT RAILROAD',
      nearBy: 'Hongik Univ. Station',
      googleMap: 'https://maps.app.goo.gl/Bkuc8aHgYZbxmQPz5',
    },
    address: '7, Donggyo-ro 32-gil, Mapo-gu, Seoul',
    latlng: [37.560899, 126.924723],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1343-1690',
      },
      {
        label: 'Business Hours',
        value: '12:00 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '미나리삼겹살, 생삼겹살, 미나리전 ',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F320836aa-5a77-45a6-93da-064d864d162d?alt=media&token=d7ed3911-236d-4d82-b991-71fd71e4bc09',
        name: '미나리삼겹살',
        subheader: '',
        description: 'Korea domestic fresh pork belly paired perfectly with fragrant minari',
        price: 'KRW15,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe43bca24-753b-4318-b3a6-64225d2aedbc?alt=media&token=a81047ec-8976-4a1a-9ed3-b25ff3743988',
        name: '생삼겹살',
        subheader: '',
        description: 'Fresh, thick slices of pork belly',
        price: 'KRW13,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6caa1d8b-427c-49f0-a7d7-9eea318ba759?alt=media&token=25f1fde1-efac-410c-9e3d-e74af54eb862',
        name: '미나리전',
        subheader: '',
        description:
          'A Korean savory pancake made with fresh minari (water parsley) mixed into a batter and pan-fried until crispy, offering a unique, earthy flavor and delightful texture.',
        price: 'KRW9,000',
      },
    ],
    html: '<h1>Pul Tteunneun Pig 풀뜬는돼지</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">If you’re seeking a barbecue experience that breaks the mold, look no further than </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Pul Tteunneun Pig</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">! I was initially skeptical about pairing grilled pork with Korean watercress, or 미나리 (minari), but this combo is a game-changer! </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">The fresh, slightly peppery crunch of minari beautifully balances the rich, high-quality pork, creating a delicious flavor explosion. Each bite showcases their creativity and dedication to fresh ingredients. And don’t miss their minari Korean pancakes; they’re the perfect sidekick to this feast. For a barbecue adventure that’s both rich and refreshing, Pul Tteunneun Pig is an absolute must-visit!</span></p><p><br></p><p><strong>Location:</strong> 325 meters from Exit 3 of Hongik Univ. Station</p>',
    description:
      'Specializes in a unique barbecue experience with high-quality grilled pork paired with fresh, peppery minari.',
    createdAt: '',
    updatedAt: '2024-10-17T01:17:29.474Z',
  },
  'solsot-where-traditional-korean-flavors-come-to-life': {
    id: 'solsot-where-traditional-korean-flavors-come-to-life',
    slug: 'solsot-where-traditional-korean-flavors-come-to-life',
    url: '/discovery/place/solsot-where-traditional-korean-flavors-come-to-life',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F90df9029-1506-47a5-86b7-69505df25677?alt=media&token=cb69c887-2c0c-4a6e-ab62-5681786d6674',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F171d3073-d876-4b53-9c29-55e8e22409c7?alt=media&token=f34d6e6d-425c-47cd-806b-ecb669344fab',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F65fd090e-720d-4a5d-897b-4f0590c4f32d?alt=media&token=76a15e3e-1f2a-4486-a30f-3c1cacaa4409',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F87149348-a605-4b6e-ab5a-75608081e5e0?alt=media&token=ed31ebcc-5cd0-4c98-b790-a14a5e2e8cc1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F66e93003-a718-4e73-8e13-6c21dc343edb?alt=media&token=faf0fab3-c1fe-4ea8-b485-f1583f12930d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7720049a-759e-43c7-8d89-b9215f8522a8?alt=media&token=d70c2c74-4249-4be7-a48a-3b41e0304e0f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6823b3be-d5be-46a8-a178-3123eba01fd3?alt=media&token=2c4de16a-9db4-40e6-ad6b-cdce0ac0d608',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F44c03139-8826-438e-b4f0-8a763d5b3d3d?alt=media&token=2c9b8ac6-0b4d-438d-9c95-0ea23c3c739d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0521d4d1-9ba6-4fa1-99f8-86ac632afdc7?alt=media&token=ac401140-c75f-4a40-8a36-35909cdeb6fa',
    ],
    name: 'Solsot ',
    priceLevel: 2,
    tags: ['IronaPot', 'Korean'],
    location: {
      address: '35, Donggyo-ro 38-gil, Mapo-gu, Seouㅣ',
      area: 'Hongik University, Yeonnam ',
      latlng: [37.563025, 126.924984],
      subway: 'Line 2, GYEONGUI-JOUNGANG LINE, AIRPORT RAILROAD',
      nearBy: 'Hongik Univ. Station',
      googleMap: 'https://maps.app.goo.gl/zdMToAHnjASvWHaz9',
    },
    address: '35, Donggyo-ro 38-gil, Mapo-gu, Seouㅣ',
    latlng: [37.563025, 126.924984],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1340-5846',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '스테이크 솥밥, 도미관자솥밥, 민물장어 솥밥, 전 솥밥',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F87149348-a605-4b6e-ab5a-75608081e5e0?alt=media&token=ed31ebcc-5cd0-4c98-b790-a14a5e2e8cc1',
        name: '스테이크 솥밥',
        subheader: 'Steak',
        description:
          'Premium marinated beef steak, bursting with juices and paired with wagyu sauce.',
        price: 'KRW18,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0521d4d1-9ba6-4fa1-99f8-86ac632afdc7?alt=media&token=ac401140-c75f-4a40-8a36-35909cdeb6fa',
        name: '도미관자솥밥',
        subheader: 'Scallop, Sea Bream',
        description:
          'Premium rice dish topped with fresh sea bream and tender scallops, delivering a delightful ocean flavor.',
        price: 'KRW18,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F66e93003-a718-4e73-8e13-6c21dc343edb?alt=media&token=faf0fab3-c1fe-4ea8-b485-f1583f12930d',
        name: '민물장어 솥밥',
        subheader: 'Eel',
        description:
          ' Top-quality eel rice bowl made with carefully sourced freshwater eel, grilled, steamed, and grilled again for a nourishing, revitalizing dish.',
        price: 'KRW26,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F44c03139-8826-438e-b4f0-8a763d5b3d3d?alt=media&token=2c9b8ac6-0b4d-438d-9c95-0ea23c3c739d',
        name: '전복 솥밥',
        subheader: 'Abalone',
        description:
          'Abalone rice dish, featuring the deep flavor of whole abalone combined with its innards sauce and enriched with butter for a rich and delightful taste.',
        price: 'KRW18,000',
      },
    ],
    html: '<h1 class="ql-align-justify">Solsot 솔솥</h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Welcome to Solsot, a charming spot in South Korea where traditional Korean flavors meet a modern twist! Solsot’s menu skillfully merges traditional Korean flavors with modern twists, providing diners with a fresh perspective on classic dishes. </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">One standout feature is their rice, cooked in a heavy iron pot called a “솥” (sot). This method ensures that the grains at the bottom form a crispy, golden crust known as “누룽지” (nurungji), adding a delightful texture to the meal. This method imparts a rich flavor and fluffy texture to the rice, setting it apart from typical rice preparations.</span></p><p><br></p><p><strong>Location:</strong> 428 meters from Exit 3 of Hongik Univ. Station.</p>',
    description:
      'Specializes in blending traditional Korean flavors with modern twists, featuring rice cooked in an iron pot for a crispy texture.',
    createdAt: '',
    updatedAt: '2024-10-17T00:14:55.453Z',
  },
  'amazing-nongkhai-authentic-thai-flavors-straight-from-thailand': {
    id: 'amazing-nongkhai-authentic-thai-flavors-straight-from-thailand',
    slug: 'amazing-nongkhai-authentic-thai-flavors-straight-from-thailand',
    url: '/discovery/place/amazing-nongkhai-authentic-thai-flavors-straight-from-thailand',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F222541ac-fdae-4b68-85b4-232bda485cc7?alt=media&token=1377ddc9-d8ec-4a04-85aa-2189f9dc5c9a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbe48fdb2-0d32-4eb5-adde-b7f1dea80725?alt=media&token=7bb36ef6-9c6b-4ee0-8639-7c81b366d72a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe798087a-ee66-46bb-be63-866153e9ee45?alt=media&token=7e4f8e82-b44a-4059-90e9-acb73f7df4be',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F961042d5-ddba-474b-b653-7bb4b1bbc28c?alt=media&token=8ca6d094-63c7-445d-b804-7f5115ec153b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F038499a3-c419-4c15-b48b-d8eb665373d9?alt=media&token=7fdc2a70-f9f2-4b44-b1e0-8579c1241f23',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe341495a-e2d9-4fab-9c2f-7737f73d08b8?alt=media&token=69e0a5b9-4dbd-4d7d-a352-2f201fbc4d90',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F746ec110-1984-4dc6-bb15-362cc880fd5f?alt=media&token=1f71a87b-bf5b-4696-95e7-59b70ffbb0b1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F14e247b3-b0b6-4562-b893-f3e8fa8665f8?alt=media&token=5bec81c6-8ed2-45ae-9344-95ae12311127',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9135bacb-c6ed-4c95-97c6-d71a54dec6c8?alt=media&token=db49e0cf-1b72-4357-9f36-2c332ed6ab7f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd894137b-5522-4489-a6cc-c8d0e2cdabc2?alt=media&token=e294891c-5c9b-4577-8cde-6ac5daae0098',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F48bf66b4-460b-4598-89a2-4198d4b093e6?alt=media&token=7e0c47cb-6ec1-4f83-b709-5b8d99b0e055',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2db52683-47a0-47de-8a93-561fd6d78f2f?alt=media&token=b572b21f-14ed-4e43-9f44-16a89fb7f9cd',
    ],
    name: 'Amazing Nongkhai',
    priceLevel: 2,
    tags: ['Thai', 'Tomyum'],
    location: {
      address: '156-11, Donggyo-ro, Mapo-gu, Seoul',
      area: 'Hongik University',
      latlng: [37.555318, 126.919895],
      subway: 'Line 2, GYEONGUI-JOUNGANG LINE, AIRPORT RAILROAD',
      nearBy: 'Hongik Univ. Station',
      googleMap: 'https://maps.app.goo.gl/ogtob49MG3dMz7USA',
    },
    address: '156-11, Donggyo-ro, Mapo-gu, Seoul',
    latlng: [37.555318, 126.919895],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1498-0567',
      },
      {
        label: 'Business Hours',
        value: 'Mon to Wed 11:30 - 20:30/ Fri to Sun 11:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:20 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '똠염꿍, 파인애플 붂음밥, 뿌팟퐁커리, 팟타이 ',
      },
    ],
    recommendations: [
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe798087a-ee66-46bb-be63-866153e9ee45?alt=media&token=7e4f8e82-b44a-4059-90e9-acb73f7df4be',
        name: '똠염꿍',
        subheader: 'TomYum',
        description: 'Spicy and tangy Tom Yum Goong flavored with lemongrass and galangal.',
        price: 'KRW14,000',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F48bf66b4-460b-4598-89a2-4198d4b093e6?alt=media&token=7e0c47cb-6ec1-4f83-b709-5b8d99b0e055',
        name: '파인애플 붂음밥',
        subheader: 'Pineapple Fried Rice',
        description: 'Thai-style pineapple fried rice.',
        price: 'KRW13,000',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2db52683-47a0-47de-8a93-561fd6d78f2f?alt=media&token=b572b21f-14ed-4e43-9f44-16a89fb7f9cd',
        name: '뿌팟퐁커리',
        subheader: 'Soft Shelled Crab',
        description: 'Creamy scrambled eggs with crispy fried curry fish cakes ',
        price: 'KRW26,000',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd894137b-5522-4489-a6cc-c8d0e2cdabc2?alt=media&token=e294891c-5c9b-4577-8cde-6ac5daae0098',
        name: '팟타이 ',
        subheader: 'Thai Rice Noodle',
        description: 'Stir-fried spicy-sweet rice noodles with Pad Thai flavors and shrimp.',
        price: 'KRW14,000',
      },
    ],
    html: '<h1>Amazing Nongkhai 어메이징농카이</h1><p><br></p><p class="ql-align-justify"><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Amazing Nongkhai</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Hongik University, Seoul</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is a vibrant Thai restaurant where the owner, staff, and chef are all from Thailand, ensuring an authentic dining experience. They serve the most genuine Thai food in the area, and it’s no surprise that many Thai people frequent this restaurant. With dishes that truly capture the flavors of Thailand, Amazing Nongkhai is a must-visit for anyone craving real Thai cuisine!</span></p><p><br></p><p><strong>Highlight: </strong>Amazing Nongkhai prides itself on its authentic Thai cuisine, with ingredients sourced directly from Thailand to ensure every dish reflects the true flavors of the region. From aromatic curries to fresh herbs and spices, each meal is crafted by a passionate team of Thai chefs, making it a favorite among locals and Thai expatriates alike.</p><p><br></p><p><strong>Location:</strong> Approximately 360 meters from Exit 1 of Hongik Univ. Station.</p>',
    description:
      'An authentic Thai dining experience, featuring dishes crafted by a team of Thai chefs using ingredients sourced directly from Thailand.',
    createdAt: '',
    updatedAt: '2024-10-17T01:03:23.136Z',
  },

  //명동
  'bantienyao-kaowi-chinese-fried-fish-hotpot': {
    id: 'bantienyao-kaowi-chinese-fried-fish-hotpot',
    slug: 'bantienyao-kaowi-chinese-fried-fish-hotpot',
    url: '/discovery/place/bantienyao-kaowi-chinese-fried-fish-hotpot',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2b2cb3b1-029d-401e-8c90-3a1c573ef2e0?alt=media&token=2b638a55-4069-49ad-9345-faa3509f3ede',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5a3fd68c-8b13-46df-be0a-1d801924bcbe?alt=media&token=d094f1cc-de6a-4664-9413-473c44d9abf7',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9fd6121b-4d32-4569-af9d-26262bb49563?alt=media&token=a94caaf1-bf26-443b-acb2-e800c070bdee',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F230831d2-e531-43c1-a641-812c4949a1a7?alt=media&token=cdf3e406-4620-4e23-963a-d129feb1bed9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F14772554-944c-49da-8558-dd7d067ecf20?alt=media&token=dfad900c-b37a-4a73-81ab-b143d074335f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Feb4d3bf6-5efd-4fa1-b469-d9c0d46f39d3?alt=media&token=b2ba3243-f7e2-471b-9513-606c73e51c1e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F150765aa-141b-42d9-a5d0-5b3a7eee6a73?alt=media&token=f8908d89-a494-4573-b489-33bc03728376',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5401077b-0f85-4e6f-82a5-f0134d3b67d9?alt=media&token=a7db9911-0bcf-4728-80e9-34c9a3e0c31f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F58ea0703-3640-4c0b-bd42-16ccd3486531?alt=media&token=90a3c8f4-309b-408a-92e7-5c191b3f3489',
    ],
    name: 'Bantienyao Kaowi Myeongdong Branch',
    priceLevel: 3,
    tags: ['FriedFish', 'HotpotFish'],
    location: {
      address: '13, Myeongdong 7-gil, Jung-gu, Seoul',
      area: 'Myeongdong',
      latlng: [37.564387, 126.983752],
      subway: 'Line 2 ',
      nearBy: 'Euljiro 1(il)-ga Station',
      googleMap: 'https://maps.app.goo.gl/CYyRnQsShZ4KhPq8A',
    },
    address: '13, Myeongdong 7-gil, Jung-gu, Seoul',
    latlng: [37.564387, 126.983752],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1371-4566',
      },
      {
        label: 'Business Hours',
        value: '12:00 - 23:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000',
      },
      {
        label: 'Signature Menu',
        value: '마라 키오위, 칭화지아오 카오위, 마늘향 카오위',
      },
    ],
    recommendations: [
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F14772554-944c-49da-8558-dd7d067ecf20?alt=media&token=dfad900c-b37a-4a73-81ab-b143d074335f',
        name: '칭화지아오 카오위',
        subheader: 'Cheongyang PeppersFried Fish Hot Pot',
        description:
          'Signature dish features fresh domestic Cheongyang peppers and a spicy mala broth, creating a truly exceptional flavor.',
        price: 'KRW43,000',
      },
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F58ea0703-3640-4c0b-bd42-16ccd3486531?alt=media&token=90a3c8f4-309b-408a-92e7-5c191b3f3489',
        name: '마늘향 카오위',
        subheader: 'Garlic Flavoured Fried Fish Hotpot ',
        description:
          "For a healthy meal with a familiar garlic flavor that's perfect for those who can’t handle spice.",
        price: 'KRW40,000',
      },
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F150765aa-141b-42d9-a5d0-5b3a7eee6a73?alt=media&token=f8908d89-a494-4573-b489-33bc03728376',
        name: '마라 키오위',
        subheader: 'Spicy Sichuan Fried Fish Hotpot',
        description:
          'Grilled fish stewed in the bold flavors of spicy Sichuan, highlighting the essence of this renowned region',
        price: 'KRW43,000',
      },
    ],
    html: '<h1><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Bantienyao Kaowi Myeongdong Branch 반티엔야오 카오위</strong></h1><p><br></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Do you love Chinese hotpot? And how about fish? What if I told you that you could combine two of your favorite foods? The restaurant is located in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Myeongdong</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. </span></p><p><br></p><p><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Highlight: T</strong>he perfectly fried fish sizzles in a hotpot! You can enjoy it like a traditional hotpot, where the fish absorbs the rich, savory broth, creating an explosion of flavor in every bite.</p><p><br></p><p><strong>Location:</strong> Approximately 221 meters from Exit 5 of Euljiro 1(il)-ga Station.</p><p><br></p><p><strong>Note:</strong> Reservations are accepted through Naver to avoid waiting times</p><p><br></p><p><br></p>',
    description:
      'The perfect combination of crispy fried fish and flavorful Chinese hotpot—an ideal spot for group dining!',
    createdAt: '2024-10-11T08:58:50.301Z',
    updatedAt: '2024-10-11T08:58:50.301Z',
  },
  'chinese-lanzhou-ramen': {
    id: 'chinese-lanzhou-ramen',
    slug: 'chinese-lanzhou-ramen',
    url: '/discovery/place/chinese-lanzhou-ramen',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fae0a1b00-19fd-4b69-bb16-a12e1410a0f7?alt=media&token=71e03721-b544-4f9f-80d6-a091f127a0fa',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0bd9e307-d0aa-466d-a461-33c849469a58?alt=media&token=5b7c48fe-0b78-4e39-9dd0-4b83ca9b29ce',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F366b8b39-6129-46ea-913d-4f76505596fc?alt=media&token=43f5336b-6379-4879-bc1c-b57ee023e560',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3fe993cd-a677-4784-93e3-e33285ea7689?alt=media&token=83c5fb72-fe33-49d9-91e8-3df88f0299c4',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1f64a2c4-2b82-4990-819d-166651514be5?alt=media&token=aab637bf-b882-4b5d-bb51-9e9af5cb4c79',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1a16b476-08c5-44a6-a32a-ed584d3cd2ab?alt=media&token=17b7738b-e9fa-43fb-be58-10b17632e58c',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F276bd3a0-7f4d-4ea7-b51a-75290cc64aff?alt=media&token=94e44590-bb03-4287-906b-d8604ed60e80',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe9d04f1b-e73b-4d6c-8f33-62e6d6d4eda4?alt=media&token=fb213842-8f62-4895-b020-7854555c6070',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5528a39e-09d6-44d3-87e1-83191c6ca87c?alt=media&token=7154bd33-9752-4423-9a68-72c73480491c',
    ],
    name: 'Ranju Ramian',
    priceLevel: 1,
    tags: ['Lanzhou', 'ChineseNoodleSoup'],
    location: {
      address: '64, Sogong-ro, Jung-gu, Seoul',
      area: 'Myeongdong ',
      latlng: [37.561028, 126.982151],
      subway: 'Line 4 ',
      nearBy: 'Myeongdong Station',
      googleMap: 'https://maps.app.goo.gl/D2oza2P7vuUC5HaYA',
    },
    address: '64, Sogong-ro, Jung-gu, Seoul',
    latlng: [37.561028, 126.982151],
    information: [
      {
        label: 'Phone Number',
        value: 'N/A',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 21:30 ',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '삼선해물짬봉자도삭면, 해산물볶음도삭면, 쯔란 양고기 도삭',
      },
    ],
    recommendations: [
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbcf93f70-9a3d-4844-9b76-b51476143ce8?alt=media&token=dbfbee9c-caf8-4578-96da-3aaf009fe5cb',
        name: '삼선해물짬봉도삭면',
        subheader: 'Seafood Noodle Soup',
        description: 'Spicy Seafood Noodle. It is hand made starting from the dough',
        price: 'KRW10,000',
      },
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9fe7e7fc-9a6f-49df-8847-2b6214bc6c02?alt=media&token=3b766ca5-b384-4c4e-b5ac-aff4d8abe197',
        name: '해산물볶음도삭면 Stirfried Seafood Hand-sliced Noodle',
        subheader: 'Stirfried Seafood Noodle',
        description: 'Stirfried Seafood Noodle. It is hand made starting from the dough',
        price: 'KRW11,000',
      },
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3fe993cd-a677-4784-93e3-e33285ea7689?alt=media&token=83c5fb72-fe33-49d9-91e8-3df88f0299c4',
        name: '쯔란 양고기 도삭면',
        subheader: 'Cumin Lamb Noodle',
        description: 'Lamb hand-sliced noodle seasoned with cumin. It is hand made from the dough',
        price: 'KRW13,000',
      },
    ],
    html: '<h1 class="ql-align-justify"><strong>Ranju Ramian 란주칼면</strong></h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Are you a fan of Chinese noodle soup? If so, you’re in for a treat! This restaurant is located in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Myeongdong</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. Dive into a bowl of comforting, hand-pulled noodles that perfectly capture the essence of this beloved dish. With their chewy texture and rich broth, these noodles are a satisfying delight that will warm your soul. </span></p><p class="ql-align-justify"><br></p><p><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Highlight</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">: </span>Topped with fresh vegetables, tender meats, and flavorful sauces, each bite of this authentic Lanzhou Noodle Soup celebrates flavor and tradition. If you’re craving something hearty, this dish is a must-try!</p><p><br></p><p><strong>Location</strong>: Approximately 257 meters from Exit 5 of Myeongdong Station.</p><p><br></p><p><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Note:</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> This place is really famous in the area, so expect a wait—usually around 30 minutes—but it’s definitely worth it!</span></p>',
    description:
      'Authentic Chinese Lanzhou Noodle Soup, renowned for its hand-pulled noodles and rich, flavorful broth.',
    createdAt: '2024-10-11T08:58:50.301Z',
    updatedAt: '2024-10-11T08:58:50.301Z',
  },
  'donugak-korean-beef-bbq': {
    id: 'donugak-korean-beef-bbq',
    slug: 'donugak-korean-beef-bbq',
    url: '/discovery/place/donugak-korean-beef-bbq',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc034c5e0-ef60-460c-923f-721c4562b189?alt=media&token=00a3d18d-5305-448c-9e0e-92bbb6da46e2',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F562800a5-6e30-43be-b266-2c7fe22289e7?alt=media&token=deece5ae-6915-4b10-940b-3d92db9b9e6c',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc1bf6614-79e6-40ba-8436-b2ea16a8f697?alt=media&token=3ab3513d-5399-442f-8cae-a76a544d3439',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F69e0da48-372e-42f0-8aea-5dfaf0a4361f?alt=media&token=1f922bd5-9c71-4339-92be-1d512520fdf9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fac00cf4b-8781-4362-86bd-16a450ff57cb?alt=media&token=eceae567-bd22-4b89-bddb-8b31aca63589',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd443c69d-672e-4046-9bb7-74e12e249e64?alt=media&token=2f6df0ed-8862-4cd7-90cd-95c2619f172f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6d836d6d-9b9c-41fa-a10f-b910c4e37d53?alt=media&token=9457e96c-2a2c-4cfd-ab5b-f4ade836e57b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff6377a36-6d3a-43b9-992d-e5f165f7e520?alt=media&token=2e760beb-7e04-4614-aad5-5477f2343b00',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3e5b3728-3b5c-4291-850e-1d58fa602cda?alt=media&token=4f0a0a38-a039-4084-aca1-b3987e97275e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc12264a0-7fdc-4cc8-aacf-9ba744223150?alt=media&token=2d78a250-8bf3-4021-9a85-515ea8c82372',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff46c1a38-0272-4fcf-b2bf-ffd2cf2d17b0?alt=media&token=8a513d7f-fbaa-47d9-b7b8-8cc0f2beebd1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4f75209c-19c4-4d5f-9ec9-3d42acfd385c?alt=media&token=9f0c59ec-96f4-4c23-811e-f006c4177734',
    ],
    name: 'Donugak',
    priceLevel: 3,
    tags: ['Korean BBQ'],
    location: {
      address: '18, Namdaemun-ro 1-gil, Jung-gu, Seoul',
      area: 'Myeongdong ',
      latlng: [37.561885, 126.977518],
      subway: 'Line 1, Line 2',
      nearBy: 'City Hall Station',
      googleMap: 'https://maps.app.goo.gl/M27Q1TfNDj9EkqCa9',
    },
    address: '18, Namdaemun-ro 1-gil, Jung-gu, Seoul',
    latlng: [37.561885, 126.977518],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1366-3628',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '한우꽃등심, 소 생갈비살, 보성녹돈 삼겹살, 수제 돼지갈비',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3e5b3728-3b5c-4291-850e-1d58fa602cda?alt=media&token=4f0a0a38-a039-4084-aca1-b3987e97275e',
        name: '한우꽃등심 Korean Beef Ribeye',
        subheader: 'Korean Beef Ribeye',
        description: 'Highest Grade 1++ Korean Beef',
        price: 'KRW55,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc12264a0-7fdc-4cc8-aacf-9ba744223150?alt=media&token=2d78a250-8bf3-4021-9a85-515ea8c82372',
        name: '소 생갈비살 Beef Short Rib',
        subheader: 'Korean Beef Short Rib',
        description: 'Premium Beef Short Rib',
        price: 'KRW21,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff46c1a38-0272-4fcf-b2bf-ffd2cf2d17b0?alt=media&token=8a513d7f-fbaa-47d9-b7b8-8cc0f2beebd1',
        name: '보성녹돈 삼겹살 Boseong Green Pork Belly',
        subheader: 'Boseong Green Tea Pork Belly',
        description: 'Premium Boseong Green Tea Pork Belly, it has a delicate hint of green tea',
        price: 'KRW19,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4f75209c-19c4-4d5f-9ec9-3d42acfd385c?alt=media&token=9f0c59ec-96f4-4c23-811e-f006c4177734',
        name: '수제 돼지갈비 Handmade Pork Rib',
        subheader: 'Handmade Pork Rib',
        description: 'This pork rib is marinated for 36 hours in 100% homemade marinade.',
        price: 'KRW19,000',
      },
    ],
    html: '<h1>Donugak 도누각</h1><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">When we talk about Korean food, barbecue is definitely a must-try! I want to tell you about an awesome charcoal barbecue spot in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Myeongdong, Korea</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. The great thing is that their menu is in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">English</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, so you won’t have any trouble ordering. The staff are super friendly and always check on you while you’re there! They’ll help you grill the meat and suggest some tasty dishes. Plus, they’re really generous with refills on side dishes and sauces!</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Highlights: </strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">This place focuses on pork belly and Korean beef, and the chef even graduated from Le Cordon Bleu, so you know the quality is top-notch! Honestly, the meat just tastes so much better when the staff helps you grill it. It’s a really fun experience!&nbsp;</span></p><p><br></p><p><strong>Location</strong>: Approximately 325 meters from Exit 7 of City Hall Station.</p><p><br></p><p><br></p><p><br></p>',
    description:
      'Determined to serve the highest quality of meat. A hidden gem for the best Korean beef BBQ',
    createdAt: '2024-10-11T08:58:50.301Z',
    updatedAt: '2024-10-11T08:58:50.301Z',
  },
  'jangin-spicy-stir-fried-chicken': {
    id: 'jangin-spicy-stir-fried-chicken',
    slug: 'jangin-spicy-stir-fried-chicken',
    url: '/discovery/place/jangin-spicy-stir-fried-chicken',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F27dc73ee-334f-4e54-9bb9-e1089a6675b1?alt=media&token=bf0680a4-8369-4266-8b23-08c3230b36e6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F39572d57-40fd-42b5-9930-bd910f912b7d?alt=media&token=b41f6068-0e0a-42d9-9d03-21608aeac2e3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffc5f6697-b387-4bb4-acb9-55d15f0a15b9?alt=media&token=2c702537-494a-463e-b7c3-ff1836d144bf',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fdc0ce23f-28a3-4589-972c-51ebad1dc9b3?alt=media&token=b58817da-d700-49d4-894b-fdaa8fa63112',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F027105c3-93ef-47dc-991e-307d44e55a24?alt=media&token=083d22a4-44f9-4326-b240-4ca6e3c69c8d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F03c0aa0f-617a-42b8-a2ba-4c3f1a71aa57?alt=media&token=a2648872-93b0-4cd4-996b-ed2a206fb4e8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb163082e-7922-47d3-839c-d5a96c0429ce?alt=media&token=6b8f6f92-a1f5-47d6-919b-3b9835041259',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F41775651-03b5-4a77-97cd-415bcdc3a421?alt=media&token=91561577-a647-4db2-8ea1-f6b8f822f482',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F85b04127-f9fd-46f4-b05a-2aa83805ca18?alt=media&token=21c35ab2-1697-4f8a-8fbe-fd5bb9c6931d',
    ],
    name: 'Jangin Spicy Stir-fried Chicken',
    priceLevel: 2,
    tags: ['SpicyStirfriedChicken', 'Korean', 'HotPlate'],
    location: {
      address: '15, Myeongdong 9-gil, Jung-gu, Seoul',
      area: 'Myeongdong ',
      latlng: [37.564558, 126.984698],
      subway: 'Line 2',
      nearBy: 'Euljiro 1(il)-ga Station',
      googleMap: 'https://maps.app.goo.gl/zDyDcTBXDWRxZnDF6',
    },
    address: '15, Myeongdong 9-gil, Jung-gu, Seoul',
    latlng: [37.564558, 126.984698],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1378-9256',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 23:00 ',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '장인닭갈비, 치즈닭갈비, 장인볶음밥',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F39572d57-40fd-42b5-9930-bd910f912b7d?alt=media&token=b41f6068-0e0a-42d9-9d03-21608aeac2e3',
        name: '장인닭갈비',
        subheader: '',
        description:
          'Signature menu: Experience the combination of locally sourced chicken and our homemade secret sauce.',
        price: 'KRW12,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F03c0aa0f-617a-42b8-a2ba-4c3f1a71aa57?alt=media&token=a2648872-93b0-4cd4-996b-ed2a206fb4e8',
        name: '치즈닭갈비',
        subheader: '',
        description:
          'The perfect combination of nutty, chewy natural mozzarella cheese and sweet-spicy dak galbi.',
        price: 'KRW14,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F85b04127-f9fd-46f4-b05a-2aa83805ca18?alt=media&token=21c35ab2-1697-4f8a-8fbe-fd5bb9c6931d',
        name: '장인볶음밥',
        subheader: '',
        description:
          'Stir-fried on a hot plate for a delightful texture, the fried rice is served after the stir-fried chicken.',
        price: 'KRW3,000',
      },
    ],
    html: '<h1 class="ql-align-justify">Jangin Spicy Stir-friend Chicken 장인닭갈비</h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Do you like chicken? What about cheese? If I told you that in Korea you can find the perfect combination of cheese and chicken? </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Jangin Spicy Stir-fried Chicken</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is located in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Myeongdong</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, a popular Korean dish made with marinated chicken stir-fried with various vegetables, usually including cabbage, sweet potato, and onion. </span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Highlight</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">: The chicken is typically marinated in a spicy sauce made from gochujang (Korean red chili paste), soy sauce, garlic, and other seasonings, giving it a flavorful and slightly spicy kick. It’s often cooked on a hot plate at the table, making it a fun and interactive dining experience.</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Location</strong>: Approximately 260 meters from Exit 5 of Euljiro 1(il)-ga Station.</p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Note: </strong>Reservations are accepted through Naver to avoud waiting times. Group dining are welcome in store</p><p><br></p>',
    description: 'The perfect blend of 100% locally sourced dak galbi and pure mozzarella cheese.',
    createdAt: '2024-10-11T08:58:50.301Z',
    updatedAt: '2024-10-11T08:58:50.301Z',
  },
  'michelin-seoul-cold-noodle': {
    id: 'michelin-seoul-cold-noodle',
    slug: 'michelin-seoul-cold-noodle',
    url: '/discovery/place/michelin-seoul-cold-noodle',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb43b2b84-fab7-44c1-b484-920c5168e037?alt=media&token=0c44f869-a6a4-46a5-b6b1-2ed4eb7dab0f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fac5a2c6d-4842-4522-933f-b9225894f7cc?alt=media&token=fba41542-d3fc-4216-813c-5f9b9473b78a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff77a0815-a9b7-42eb-8228-0098ab9e25c2?alt=media&token=4aaf09ff-a0e0-4997-876f-fe67f6d62366',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc0cc7eee-8351-45f5-b464-d2ae9ba45b96?alt=media&token=1f708b30-737e-466c-a45e-0abc4ff4b34f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F54d7be83-e5ae-46c1-9e59-115d55d0bbc0?alt=media&token=c67ad6a9-4341-4511-90f9-14a26f446aec',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fcc10b139-c5d2-4d83-9871-61cfef8444bb?alt=media&token=9a1d380b-1f29-4870-80ee-227a2ce2ef66',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F388891f5-d4ae-4a1e-8503-1ba9d961eaa2?alt=media&token=a892f705-16b9-4504-921a-a54637802526',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3d87e06d-d7a9-4fb7-b6a4-be6077091436?alt=media&token=25722614-05ac-4e9d-8622-c0440d817b8f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F68c23150-e35b-4dd4-a2b9-f73bc6498c1b?alt=media&token=6f9dd9ab-3d70-4ae9-9bcd-49ec438e67d3',
    ],
    name: 'Nampo Myeonok',
    priceLevel: 2,
    tags: ['MichelinSeoul', 'ColdNoodle', 'NorthKoreanDish'],
    location: {
      address: '24, Eulji-ro 3-gil, Jung-gu, Seoul',
      area: 'Myeongdong ',
      latlng: [37.567106, 126.98158],
      subway: 'Line 2',
      nearBy: 'Euljiro 1(il)-ga Station',
      googleMap: 'https://maps.app.goo.gl/YrBsyWduBpZv1wdy7',
    },
    address: '24, Eulji-ro 3-gil, Jung-gu, Seoul',
    latlng: [37.567106, 126.98158],
    information: [
      {
        label: 'Phone Number',
        value: '02-777-2269',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 22:00 (Sat, Sun 11:30 - 21:00)',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '냉면, 갈비탕',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb43b2b84-fab7-44c1-b484-920c5168e037?alt=media&token=0c44f869-a6a4-46a5-b6b1-2ed4eb7dab0f',
        name: '냉면 Cold Noodle ',
        subheader: 'Cold Noodle ',
        description: 'Served with clear chilled broth and buckwheat noodles.',
        price: 'KRW15,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3d87e06d-d7a9-4fb7-b6a4-be6077091436?alt=media&token=25722614-05ac-4e9d-8622-c0440d817b8f',
        name: '갈비탕 Korean Beef Short Rib Soup',
        subheader: 'Beef Short Rib Soup',
        description: 'Rich beef short rib soup with tender meat and savory broth.',
        price: 'KRW15,000',
      },
    ],
    html: '<h1 class="ql-align-justify">Nampo Myeonok 남포면옥</h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Nampo Myeonok</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> has been recognized by the </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Michelin Guide Seoul</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> from </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">2018 to 2024</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, totaling </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">seven years</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> of acclaim. Where is located in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Myeongdong</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. </span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Famous for its </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">naengmyeon</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, this dish has roots in North Korean cuisine, specifically from </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Pyongyang</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. It’s perfect for hot summer days, offering a refreshing blend of flavors and textures. Additionally, it’s a favored dining spot for many South Korean presidents and politicians.</span></p><p class="ql-align-justify"><br></p><p><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Highlight:</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> The restaurant is known for its buckwheat noodles served in a chilled broth, topped with slices of beef, cucumbers, and a boiled egg. </span></p><p><br></p><p>Location: Approximately 152 meters from Exit 1-1 of Euljiro 1(il)-ga Station.</p>',
    description:
      'A longtime favorite for its authentic Pyeongyang cold buckwheat noodles and beef hot pot, Nampo Myeonok delights patrons of all ages with consistently good food and friendly service.',
    createdAt: '2024-10-11T08:58:50.301Z',
    updatedAt: '2024-10-11T08:58:50.301Z',
  },

  //성수
  'seongsu-darak-the-expert-in-pasta-and-omurice': {
    id: 'seongsu-darak-the-expert-in-pasta-and-omurice',
    slug: 'seongsu-darak-the-expert-in-pasta-and-omurice',
    url: '/discovery/place/seongsu-darak-the-expert-in-pasta-and-omurice',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1ca57bd4-3eba-444d-aae0-3459efc50827?alt=media&token=4152cb67-9108-4821-b0d9-737550be38c1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F73974738-4aea-46c1-96d6-747da50e9bad?alt=media&token=7baccd4e-9ac3-49eb-be78-5146253ca418',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff02ce62c-2a5a-4c48-8ac3-6bd2662c6c46?alt=media&token=428f4645-fe91-46ab-9a65-04e01cdbdd6f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F789e4ec2-6204-477b-b1ee-0cf4b1d0add9?alt=media&token=3d3b4241-b1e7-49f7-84c2-330c48c3a113',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffa932851-c7fd-43cd-b889-0973a7339d7c?alt=media&token=feebfd9e-f938-45a1-b259-c2f63acf2848',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe9c36c99-f190-4e2c-aad2-14c70396ab17?alt=media&token=48694100-cdd7-432e-81b0-5dc927f91083',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5dc8e357-0c3a-42d7-b56c-7c22b4b02019?alt=media&token=33c5e2a9-bc60-467c-82c8-f62574c5c094',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe3295819-2b17-4476-993e-1d47bd1c1eec?alt=media&token=97ed1398-acfe-41ac-a37a-4ff90994edac',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe1b8e1c9-b4de-4aaf-9194-f24e646c8e54?alt=media&token=6d8e5893-36e6-4941-8083-79c1f74f81f6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0f75e8dc-d3be-4b1a-8b7e-99e204b0a1a4?alt=media&token=78e63a55-3b9a-4033-ae57-77022e884bce',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F16a79835-7f43-4ac8-8377-c2769107a57e?alt=media&token=dbfa8555-2fea-497c-a482-2fb1f4ec00c5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F19c2b0f9-2983-4038-bed6-29921f98962b?alt=media&token=e63d47d8-c6da-4b7f-bdbd-30ab90079021',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1467a086-7623-4257-9dbe-2803e9a930a0?alt=media&token=884f7eb4-2197-4e13-b842-b82ab189f54a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa330ba8b-767d-441a-ac89-c79c62574770?alt=media&token=1b2e4a02-60c2-4719-80c7-2b286fb39f36',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4ac0825a-7c39-402d-a401-43c5e16ac283?alt=media&token=f136be5d-a14c-4f3f-95f5-47212413b894',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fdfd59d02-7f62-484f-9c1f-eb81edcaf301?alt=media&token=3203b9ae-9779-4c8b-8606-6b3222380f63',
    ],
    name: 'Seoungsu Darak',
    priceLevel: 2,
    tags: ['Pasta', 'Omurice', 'Risotto'],
    location: {
      address: '20, Ttukseom-ro 9-gil, Seongdong-gu, Seoul',
      area: 'Seongsu ',
      latlng: [37.540051, 127.056154],
      subway: 'Line 2',
      nearBy: 'Seongsu Station',
      googleMap: 'https://maps.app.goo.gl/5jmxGHkxzF1Scjh98',
    },
    address: '20, Ttukseom-ro 9-gil, Seongdong-gu, Seoul',
    latlng: [37.540051, 127.056154],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1349-9197',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:15',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value:
          '다락오므라이스, 다락로제파스타, 찹목살스테이크, 게살매콤리조또, 가츠산도, 옥수수뇨끼',
      },
    ],
    recommendations: [
      {
        category: 'Japanese ',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1ca57bd4-3eba-444d-aae0-3459efc50827?alt=media&token=4152cb67-9108-4821-b0d9-737550be38c1',
        name: '다락오므라이스',
        subheader: 'Omurice Fried Rice',
        description: 'European-style fried rice, soft Japanese omelet, and homemade Omurice sauce.',
        price: 'KRW16,000',
      },
      {
        category: 'Western',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F73974738-4aea-46c1-96d6-747da50e9bad?alt=media&token=7baccd4e-9ac3-49eb-be78-5146253ca418',
        name: '다락로제파스타',
        subheader: 'Rose Pasta',
        description:
          'Pasta with spicy homemade meat sauce, sweet fresh cream, and Grana Padano cheese.',
        price: 'KRW18,000',
      },
      {
        category: 'Western',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff02ce62c-2a5a-4c48-8ac3-6bd2662c6c46?alt=media&token=428f4645-fe91-46ab-9a65-04e01cdbdd6f',
        name: '찹목살스테이크',
        subheader: 'Pork Steak ',
        description: 'Grilled pork neck, grilled vegetables, mashed potatoes, and steak sauce.',
        price: 'KRW22,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F789e4ec2-6204-477b-b1ee-0cf4b1d0add9?alt=media&token=3d3b4241-b1e7-49f7-84c2-330c48c3a113',
        name: '게살매콤리조또',
        subheader: 'Risotto',
        description: 'Risotto flavored with vegetables sautéed in chili oil and fresh crab meat.',
        price: 'KRW18,000',
      },
      {
        category: 'Japanese ',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffa932851-c7fd-43cd-b889-0973a7339d7c?alt=media&token=feebfd9e-f938-45a1-b259-c2f63acf2848',
        name: '가츠산도',
        subheader: 'Pork Cutlet Sandwich',
        description: 'Japanese sandwich made with juicy tonkatsu',
        price: 'KRW12,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F16a79835-7f43-4ac8-8377-c2769107a57e?alt=media&token=dbfa8555-2fea-497c-a482-2fb1f4ec00c5',
        name: '옥수수뇨끼',
        subheader: 'Corn Gnocchi',
        description: 'Italian-style handmade dumplings flavored with homemade corn cream.',
        price: 'KRW18,000',
      },
    ],
    html: '<h1 class="ql-align-justify">Seongsu Darak 성수다락</h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">These days, </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Seongsu</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is the go-to spot for trendy restaurants and cafes, and </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Seongsu Darak</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is a standout! With locations in Gangnam and Euljiro (Eulji Darak), this popular eatery has taken social media by storm. </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Known for its delectable </span><strong style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Omurice</strong><span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);"> and </span><strong style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Spicy Cream Pasta</strong><span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">, Seongsu Darak specializes in pasta with vibrant flavors and creative presentations. Whether you\'re a local or just visiting, this restaurant promises a memorable dining experience you won\'t want to miss!</span></p><p><br></p><p>Location: Approximately 576 meters from Exit 3 of Seongsu Station.</p><p><br></p>',
    description: 'Specializes in authentic omerice and pasta. ',
    createdAt: '2024-10-14T00:12:56.782Z',
    updatedAt: '2024-10-14T00:12:56.782Z',
  },
  'somun-nan-seongsu-gamjatang-pork-spine-soup': {
    id: 'somun-nan-seongsu-gamjatang-pork-spine-soup',
    slug: 'somun-nan-seongsu-gamjatang-pork-spine-soup',
    url: '/discovery/place/somun-nan-seongsu-gamjatang-pork-spine-soup',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F164aebad-f601-4a23-97e7-f864bb03228d?alt=media&token=51417bfe-6ba6-4e5b-9716-76e46e97e0de',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb0c0fd7e-ef59-434d-993a-ddfdd297197d?alt=media&token=dcb2332f-57a8-4ac4-bb47-e7335b078b4e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fed49deda-252b-4163-9297-10958779fc89?alt=media&token=a1ba398a-4099-4c1e-9c9f-bca44a9a9d89',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F44a3c764-0c01-4563-ba5c-46b9ab8c6771?alt=media&token=56a1007d-06bb-40c2-9d46-6e6317a506b8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb3445d15-b3df-47be-9736-084eff3ae305?alt=media&token=38c198ab-41c5-4f3f-9111-b98cbd214306',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb9f01a94-9c15-4491-b78b-7305453b8d90?alt=media&token=955a1fc5-4af5-4844-bd51-124228e557d5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F37262d28-f960-49ef-8cbe-fbd0e3995b02?alt=media&token=220d5f59-5439-4c0c-bfa9-16e8c04d208f',
    ],
    name: 'Somun Nan Seongsu Gamjatang ',
    priceLevel: 2,
    tags: ['PorkSpineSoup', 'FriedRice'],
    location: {
      address: '45, Yeonmujang-gil, Seongdong-gu, Seoul',
      area: 'Seongsu ',
      latlng: [37.543003, 127.054352],
      subway: 'Line 2 ',
      nearBy: 'Seongsu Station',
      googleMap: 'https://maps.app.goo.gl/oAURpwgdjpmeazVH7',
    },
    address: '45, Yeonmujang-gil, Seongdong-gu, Seoul',
    latlng: [37.543003, 127.054352],
    information: [
      {
        label: 'Phone Number',
        value: '02-465-6580',
      },
      {
        label: 'Business Hours',
        value: '24Hours',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '감자탕',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb0c0fd7e-ef59-434d-993a-ddfdd297197d?alt=media&token=dcb2332f-57a8-4ac4-bb47-e7335b078b4e',
        name: 'Gamjatang',
        subheader: 'Pork Spine Soup',
        description:
          'Gamjatang is a hearty Korean soup made with pork spine and potatoes, simmered in a flavorful broth with garlic, green onions, and gochugaru.',
        price: 'KRW29,000',
      },
    ],
    html: '<h1 class="ql-align-justify">Somun Nan Seongsu Gamjatang 소문난성수감자탕 </h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">소문난 성수 감자탕 (Somun Nan Seongsu Gamjatang)</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">  is one of the hot place located in the heart of </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Seongsu</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, which also has appeared on local TV shows, solidifying its reputation as a beloved dining destination. It’s a favorite among many celebrities, including members of NCT, SuJu, NCT Chenle, and the renowned chef Baek Jong-won. </span></p><p><br></p><p>Highlight: S<span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">pecializes in gamjatang, a rich and flavorful pork bone soup. Each bowl is made with slow-cooked pork bones, tender potatoes, and a colorful assortment of fresh vegetables, all simmered to perfection for a truly satisfying meal. </span></p><p><br></p><p>Location: Approximately 266 meters from Exit 4 of Seongsu Station. </p><p><br></p>',
    description:
      'Specializes in Gamjatang, a hearty Korean soup made with pork spine and potatoes. ',
    createdAt: '2024-10-14T00:28:04.805Z',
    updatedAt: '2024-10-14T00:28:04.805Z',
  },
  'jojo-noodle-soup-with-fresh-clams-and-noodles': {
    id: 'jojo-noodle-soup-with-fresh-clams-and-noodles',
    slug: 'jojo-noodle-soup-with-fresh-clams-and-noodles',
    url: '/discovery/place/jojo-noodle-soup-with-fresh-clams-and-noodles',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F84e2d53d-a6b6-4c11-bac6-0f71b8182210?alt=media&token=208e8244-1640-40e4-a1e7-f7cb82103922',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F32bd4d87-9f27-4ea3-bc62-762ea7749006?alt=media&token=22ed0a5c-4e84-4a47-8ddc-eec4ffa68e46',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5bfa30bb-da73-4bbc-b403-aa16807df739?alt=media&token=116775a2-cbfd-4b1f-9e7b-39384624fc93',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff43ceebf-30c4-4568-8f67-14532b3f3550?alt=media&token=dbb57077-a19e-42ea-8cbc-95194333a8a1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F45cad6d6-3914-4c4c-9e64-5ae0ac72caf4?alt=media&token=9e05fda7-a5f6-4fdb-8565-695add7ddd10',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c770580-675f-4f7c-afea-30bd851d9d90?alt=media&token=58a1aadc-8344-4c2f-bead-f98e4533b5f9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F88030c20-57d8-484c-86a6-4d683585939f?alt=media&token=fe38f7ae-49ab-41fd-815a-6eaf946ba521',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F79c28fef-dfd9-4fea-ab90-d599c973414f?alt=media&token=2cb16b46-4667-4b61-b207-81f1fcc34ee5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fec74df84-4d86-45f5-9457-c09c6007b7a7?alt=media&token=806f747e-595d-451a-8f02-ca6fb002e176',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb408d373-7ea5-4c28-a121-6004c84bea9e?alt=media&token=4af7ef9a-e1d7-4c96-a2c8-03ec89a86233',
    ],
    name: 'Jojo Noodle Soup ',
    priceLevel: 1,
    tags: ['Seafood', 'NoodleSoup', 'ClamSoup'],
    location: {
      address: '55, Seongsuil-ro 8-gil, Seongdong-gu, Seoul',
      area: 'Seongsu ',
      latlng: [37.546056, 127.056798],
      subway: 'Line 2',
      nearBy: 'Seongsu Station',
      googleMap: 'https://maps.app.goo.gl/EQvyAPo7Mp3nSLgx6',
    },
    address: '55, Seongsuil-ro 8-gil, Seongdong-gu, Seoul',
    latlng: [37.546056, 127.056798],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1472-4334',
      },
      {
        label: 'Business Hours',
        value: '10:00 - 21:30',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '동죽칼국수, 낙지해물파전, 물총조개탕 ',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c770580-675f-4f7c-afea-30bd851d9d90?alt=media&token=58a1aadc-8344-4c2f-bead-f98e4533b5f9',
        name: '동죽칼국수',
        subheader: 'Korean Noodle Soup',
        description:
          'Dongjuk kalguksu made with live clams, fresh vegetables, and handmade noodles',
        price: 'KRW9,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fec74df84-4d86-45f5-9457-c09c6007b7a7?alt=media&token=806f747e-595d-451a-8f02-ca6fb002e176',
        name: '낙지해물파전',
        subheader: 'Korean Seafood Pancake ',
        description:
          'Nakji seafood pancake is loaded with octopus, squid, and shrimp, crispy on the outside and moist on the inside.',
        price: 'KRW13,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F79c28fef-dfd9-4fea-ab90-d599c973414f?alt=media&token=2cb16b46-4667-4b61-b207-81f1fcc34ee5',
        name: '물총조개탕 ',
        subheader: 'Clam Soup',
        description:
          'Refreshing dongjuk clam soup filled with fresh live clams, featuring a clear broth and plump clam meat',
        price: 'KRW12,000',
      },
    ],
    html: '<h1>Jojo Noodle Soup Seongsu Branch 조조칼국수</h1><p><br></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">If you’re in Seoul and craving a warm, comforting bowl of noodles, look no further than </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">조조칼국수 (Jojo Kalguksu)</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">! This hidden gem is famous for its mouthwatering handmade kalguksu (Korean Noodle Soup), paired with a rich clam soup that’s simply irresistible. </span></p><p><br></p><p><strong>Highlight</strong>: <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">The noodles are crafted fresh daily, giving each bowl a delightful chewiness that will keep you coming back for more. And let’s not forget their crispy Korean pancakes—golden, savory bites that are perfect for sharing (or not!). With its cozy vibe and hearty dishes, Jojo Kalguksu invites you to indulge in an authentic taste of Korean comfort food that feels just like home.</span></p><p><br></p><p><strong>Location:</strong> Approximately 111 meters from Exit 2 of Seongsu Station</p>',
    description: 'Specializes in Korean Noodle Soup and Clam Soup. ',
    createdAt: '2024-10-14T00:47:50.998Z',
    updatedAt: '2024-10-14T00:47:50.998Z',
  },
  'elder-burger-the-best-burger-in-seoungsu': {
    id: 'elder-burger-the-best-burger-in-seoungsu',
    slug: 'elder-burger-the-best-burger-in-seoungsu',
    url: '/discovery/place/elder-burger-the-best-burger-in-seoungsu',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0a254d5a-f1d0-4d77-bf3a-5ea6afb54a3d?alt=media&token=74ba5e77-ea2f-4dc0-a492-252c7e6b856f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8b7f6fac-1956-48ba-97aa-86c9ca510520?alt=media&token=4f11843c-0b6d-4018-a50a-e99af5e80c27',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F17280234-39b6-44ec-b723-9fe0fde33810?alt=media&token=ade37728-107e-4399-9d27-18a4946621e9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa3a11976-d460-4b6c-a9ee-0ba3cd62b2fb?alt=media&token=37ecdec5-5f00-4976-831b-a0ec04c77de6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F711a29d9-bb20-4a7d-b67f-ba8fadcec5a0?alt=media&token=53a6604c-f13f-49e1-bab0-4ad964ac750d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F96c73d16-4dd3-4a6c-8291-2cc2479c7675?alt=media&token=15bdf8fc-2350-4874-b8df-74cfbcdb2a07',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F61614bfe-0be5-47a7-a3c2-ec8d5f384c3e?alt=media&token=b71e9023-91bf-4a42-9c06-b3e131f7331e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb8909918-0c57-4120-9362-85994f934416?alt=media&token=281b38e6-05a9-49a2-9c45-6c73a44121e8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd6aa2af2-51bf-45b1-8b3f-e6d2974562e3?alt=media&token=17304c0f-9676-495c-8277-1604f94e9e28',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F089e9161-dc9a-4c9d-bb90-90c965da4468?alt=media&token=e67c1065-e669-4615-8d66-2f8fb7b1c005',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff55b2445-2937-44fc-88d3-2ab6b83baa69?alt=media&token=7b51351b-30a7-4b35-aefc-7a7799fbeaf4',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb2b3ae57-0fbe-4424-9a51-2080324038e6?alt=media&token=f694ffcf-723a-47a9-9567-6f574ace0f6b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fac82bf7e-196e-4e3c-b59c-b640066dff06?alt=media&token=e76710c4-1e57-474b-aee7-57827f5b8ee9',
    ],
    name: 'Elder Burger',
    priceLevel: 2,
    tags: ['AmericanBurgers', 'HandmadeBurgers', 'HandmadePatties'],
    location: {
      address: '40-7, Seoulsup 2-gil, Seongdong-gu, Seoul',
      area: 'Seoul Forest',
      latlng: [37.546286, 127.043015],
      subway: 'SUIN-BUNDANG LINE',
      nearBy: 'Seoul Forest Station',
      googleMap: 'https://maps.app.goo.gl/ojc9bABazuFExatT9',
    },
    address: '40-7, Seoulsup 2-gil, Seongdong-gu, Seoul',
    latlng: [37.546286, 127.043015],
    information: [
      {
        label: 'Phone Number',
        value: '02-462-5612',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 20:30',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '엘더클래식, 뉴클래식, 베이컨치즈버거',
      },
    ],
    recommendations: [
      {
        category: 'American',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0a254d5a-f1d0-4d77-bf3a-5ea6afb54a3d?alt=media&token=74ba5e77-ea2f-4dc0-a492-252c7e6b856f',
        name: '엘더클래식',
        subheader: 'Classic Beef Burger',
        description:
          'Top-grade US prime beef patty / butterhead lettuce / onion / tomato / elder sauce / American cheese.',
        price: 'KRW10,900',
      },
      {
        category: 'American',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8b7f6fac-1956-48ba-97aa-86c9ca510520?alt=media&token=4f11843c-0b6d-4018-a50a-e99af5e80c27',
        name: '뉴클래식',
        subheader: 'Beef Burger',
        description:
          'Top-grade US prime beef patty / arugula / onion marmalade / grilled tomato / gouda cheese',
        price: 'KRW13,900',
      },
      {
        category: 'American',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fac82bf7e-196e-4e3c-b59c-b640066dff06?alt=media&token=e76710c4-1e57-474b-aee7-57827f5b8ee9',
        name: '베이컨치즈버거',
        subheader: 'Bacon Beef Burger',
        description:
          'Top-grade US prime beef patty / bacon / butterhead lettuce / onion / tomato / elder sauce / American cheese.',
        price: 'KRW13,900',
      },
    ],
    html: '<h1 class="ql-align-justify">Elder Burger 엘더버거 성수</h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">If you’re a burger lover, </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Elder Burger</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is an essential stop that guarantees a fantastic dining experience. Their diverse menu caters to various dietary needs, featuring delicious vegetarian and vegan options, so there’s truly something for everyone. Each burger is made to order, ensuring freshness and top-notch quality with every bite. Recognized as one of the best burger spots in Seoul on </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Restaurant Guru 2024</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, 엘더버거 (Elder Burger) is not to be missed!</span></p><p><br></p><p>Highlight: <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Each burger is made to order, ensuring freshness and top-notch quality with every bite. </span>The bread, another crucial element of our burgers, is baked fresh every morning and presented to our customers. With a crispy exterior and a soft interior, this bread enhances the richness of our burgers. <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Recognized as one of the best burger spots in Seoul on </span><strong style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Restaurant Guru 2024</strong><span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">, 엘더버거 (Elder Burger) is not to be missed!</span></p><p><br></p><p>Location: Approximately 367 meters from Exit 5 of Seoul Forest Station.</p><p><br></p><p><br></p>',
    description:
      "'Elder Burger Seongsu,' a hidden gem in Seongsu-dong that has opened a new horizon for handmade burgers.",
    createdAt: '2024-10-13T23:08:56.964Z',
    updatedAt: '2024-10-13T23:08:56.964Z',
  },
  'salladaeng-a-taste-of-french-and-thai': {
    id: 'salladaeng-a-taste-of-french-and-thai',
    slug: 'salladaeng-a-taste-of-french-and-thai',
    url: '/discovery/place/salladaeng-a-taste-of-french-and-thai',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F066d510a-59f3-4492-b5c6-ef67ea762007?alt=media&token=fe80ee7a-e05c-48dd-afe9-2652bb47ac18',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fde363e8d-003c-4441-8b35-099eb40593a4?alt=media&token=ef234159-246a-4f1d-8cdf-2b46f3a8cd87',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F78a694f0-b8d1-45e3-bcfa-7194daa94cbe?alt=media&token=b0278501-d48c-4bf7-81a2-35151f4f4bbc',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faf5eca32-9b25-4e5e-a93d-2dd5c5523146?alt=media&token=8fb6ac6c-cb10-4b0a-9004-fe5702839f15',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd087b0cc-9dd6-430b-930e-328aa06a5e8f?alt=media&token=955a982f-14ef-4d3e-ac90-bebb9ef4f4dc',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F912b03cd-c219-4e55-93cf-69775487e8ae?alt=media&token=2c98f49c-d31c-41bf-8171-81e2f04018b9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F48c9be58-8cd9-41ce-a035-0d79f540d72b?alt=media&token=7f63fb8b-09a7-41af-ac72-bdebb2f2c93f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff81198e3-9dad-4a05-b7b0-936b50619fb0?alt=media&token=7b320053-7b1a-45c7-a513-787cf2bed5d3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb73cdefa-3fdf-40b0-bb6e-ea6a198434f2?alt=media&token=3726906e-d806-45e7-9a55-589880045dff',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe04ea565-ad55-45e4-9141-fa2d0dfa21d4?alt=media&token=8c3adb6a-7e54-4c08-9316-3caec531e62b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F47dbb1c9-76bf-473a-a684-a27252d48262?alt=media&token=f1363ed8-1cb9-493e-9c86-5ea7dbfd3a76',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa65e4f32-f9a2-4de5-9c2e-cfcf44068fd8?alt=media&token=5ea2a2a5-0c62-45bb-a5b6-5616652d4389',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa0f0f13c-61a7-42eb-8e50-bd9f7693b3ae?alt=media&token=b9482a07-27a7-4c19-965e-fae00b0dc189',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F85ce8f17-5484-4b2e-a6fb-7b55390ff59d?alt=media&token=4baea722-7c4c-4b27-b6a4-7f919f391b7c',
    ],
    name: 'Salladaeng',
    priceLevel: 4,
    tags: ['Thai', 'Temple', 'PadThai'],
    location: {
      address: '32, Seongsui-ro 16-gil, Seongdong-gu, Seoul',
      area: 'Seongsu',
      latlng: [37.540132, 127.059752],
      subway: 'Line 2 ',
      nearBy: 'Seongsu Station',
      googleMap: 'https://maps.app.goo.gl/tTHfkTGPKKSw8qoW6',
    },
    address: '32, Seongsui-ro 16-gil, Seongdong-gu, Seoul',
    latlng: [37.540132, 127.059752],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1359-2289',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 22:30',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '카오카무, 이베리코 포크 스테이크, 푸팟퐁커리, 템플 코코넛 치킨 팟타이',
      },
    ],
    recommendations: [
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5bc4da36-fc7f-4737-984a-b3acc6bd24ad?alt=media&token=701d9739-72a3-4fa4-8fda-a39f438cac4e',
        name: '카오카무',
        subheader: 'Braised Pork Belly',
        description:
          'Kao Kham is a Thai dish of braised pork belly, slow-cooked until tender and flavorful, typically served with rice and various side dishes.',
        price: 'KRW33,000',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb758347b-e843-48d4-b758-504acc61e726?alt=media&token=1aa34d94-7f1c-42a4-b619-f0a19a875ec9',
        name: '이베리코 포크 스테이크',
        subheader: 'Pork Steak',
        description:
          'Iberico pork steak is a tender, flavorful cut from Iberico pigs, known for its marbling and acorn diet.',
        price: 'KRW44,000',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb76e60ca-5d0c-4779-bfaa-9697c7617965?alt=media&token=234f9d88-ce44-4acd-be32-419e5ca2f1fc',
        name: '푸팟퐁커리',
        subheader: 'Curry with Crab',
        description:
          'Poo Pad Pong Curry is a Thai dish of stir-fried crab meat and eggs in a rich curry sauce.',
        price: 'KRW39,000',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F089d345d-7e93-4027-a89e-7a0badcf36c4?alt=media&token=09be466a-39af-4d65-abec-5fa7987fdec9',
        name: '템플 코코넛 치킨 팟타이',
        subheader: 'Pad Thai',
        description:
          'A Thai dish featuring stir-fried rice noodles with coconut milk, chicken, and traditional Pad Thai flavors.',
        price: 'KRW28,000',
      },
    ],
    html: '<h1>Salladaeng 살라댐템플</h1><p><br></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Calling all foodies! If you\'re craving a burst of vibrant Thai flavors in the heart of Seoul, 살라댕템플 (Salladaeng Temple) is the place to be! </span>This spot is a feast for both your stomach and your eyes, with a highly Instagrammable interior that takes you straight to the authentic temples of Thailand.</p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Alongside classic favorites like Pad Thai and Tom Yum soup, they offer creatively modernized Thai fusion dishes that will excite your taste buds. </span>Each dish is expertly crafted with fresh ingredients from Thailand and bold flavors, ensuring a memorable dining experience that will leave you craving more.</p><p><br></p><p><strong>Note: </strong></p><ol><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>Reservations are accepted through CatchTable to avoid waiting times.</li><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>Special dishes like the Salladang Family Set and Elbon Steak can be pre-ordered when making a reservation by specifying the time and number of guests.</li></ol><p><br></p>',
    description:
      'A French-Thai fusion restaurant set within a mysterious temple created by Glow Seoul.',
    createdAt: '2024-10-13T23:48:36.386Z',
    updatedAt: '2024-10-13T23:48:36.386Z',
  },

  //건대
  'jungmyeon-noodles-from-the-heart': {
    id: 'jungmyeon-noodles-from-the-heart',
    slug: 'jungmyeon-noodles-from-the-heart',
    url: '/discovery/place/jungmyeon-noodles-from-the-heart',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2e3ac065-5706-4db0-a6a3-347ea1ce8d21?alt=media&token=44c76ab7-8bb4-471a-83d1-515864c28c53',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9327bfdd-5334-4d59-8f8e-411afcd1d99f?alt=media&token=dc8ea31e-c6f5-4457-8e43-636d484cf096',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd82df89f-a085-4a70-815b-dfa3c8181fac?alt=media&token=9f7ce901-952b-4a19-806f-906305dd8b49',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5d0e1d6e-86df-4cd8-9f06-9ebfe794e426?alt=media&token=67b17cb7-bb1a-430a-8692-c4e3e018a7f9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F04936ab4-a153-45a3-885a-472602cc2dd5?alt=media&token=0f477bbe-f3d4-4495-ae48-d28dc8b70907',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbf26cdbf-8b04-4f25-8ecc-f36c21f0dfd6?alt=media&token=d5da41c1-2adc-432d-9b0a-2e889556447a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faee76033-2078-406e-84aa-f1c54600f9e0?alt=media&token=a7047e63-fd72-4663-adab-76b8ff5ca89b',
    ],
    name: 'Jungmyeon',
    priceLevel: 1,
    tags: ['NoodleSoup', 'Korean'],
    location: {
      address: '88, Neungdong-ro 13-gil, Gwangjin-gu, Seoul',
      area: 'Konkuk University',
      latlng: [37.545611, 127.06866],
      subway: 'Line 2, Line 7',
      nearBy: 'Konkuk Univ. Station',
      googleMap: 'https://maps.app.goo.gl/q91vRTG92cVEH3Kt9',
    },
    address: '88, Neungdong-ro 13-gil, Gwangjin-gu, Seoul',
    latlng: [37.545611, 127.06866],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1401-3592',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '14:50 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW1 ~ KRW10,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '백면, 홍면, 단호박 식혜',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9327bfdd-5334-4d59-8f8e-411afcd1d99f?alt=media&token=dc8ea31e-c6f5-4457-8e43-636d484cf096',
        name: '백면',
        subheader: 'Clear Broth Noodle Soup',
        description:
          'Baekmyeon, characterized by the rich aroma of tender pork neck and a clean, deep broth.',
        price: 'KRW9,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F04936ab4-a153-45a3-885a-472602cc2dd5?alt=media&token=0f477bbe-f3d4-4495-ae48-d28dc8b70907',
        name: '홍면',
        subheader: 'Spicy Noodle Soup',
        description:
          'Hongmyeon, characterized by a spicy broth that lingers behind its deep flavor.',
        price: 'KRW9,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2e3ac065-5706-4db0-a6a3-347ea1ce8d21?alt=media&token=44c76ab7-8bb4-471a-83d1-515864c28c53',
        name: '단호박 식혜',
        subheader: 'Sweet Pumpkin Rice Drink',
        description:
          'Made in limited quantities each day, it features a taste that is not overly sweet and is pleasantly mild.',
        price: 'KRW3,500',
      },
    ],
    html: '<h1>Jungmyeon 정면</h1><p><br></p><p class="ql-align-justify"><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Jung (情)</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> signifies a deep emotional bond or affection between people, while </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Myeon (面)</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> translates to noodles. This charming noodle shop reflects the chef\'s heartfelt intentions. The restaurant is also recognized by Michelin Guide Seoul in 2023 &amp; 2024. </span></p><p><br></p><p><strong>Highlight:</strong> F<span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">ocusing solely on their signature noodle soup that provides comfort and warmth in every bowl. Although the menu centers around this dish, customers can select either spicy or non-spicy options to suit their preferences.</span></p><p><br></p><p><strong>Location:</strong> Approximately 602 meters from Exit 4 of Children\'s Grand Park Station.</p>',
    description: 'Specializes solely in noodle soup. ',
    createdAt: '2024-10-16T06:42:02.228Z',
    updatedAt: '2024-10-16T06:42:02.228Z',
  },
  'songhwa-sansi-dosangmyeon-brings-the-taste-shanxi-to-you': {
    id: 'songhwa-sansi-dosangmyeon-brings-the-taste-shanxi-to-you',
    slug: 'songhwa-sansi-dosangmyeon-brings-the-taste-shanxi-to-you',
    url: '/discovery/place/songhwa-sansi-dosangmyeon-brings-the-taste-shanxi-to-you',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc13ac82c-486c-4850-859f-e126dbcaf063?alt=media&token=c20973a2-cb97-4d07-870f-b9d3124b9993',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faf2ff89c-804d-4c2e-a6cf-b73d813de56b?alt=media&token=98d869a3-4e64-4102-8f0a-8a0b62f85ce7',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F347140b8-a254-44c1-bc40-fd30c641115b?alt=media&token=67fbf38a-bd35-45f3-b515-691300a00aeb',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe4696916-c44f-42f8-bb3c-d7954a57b3cd?alt=media&token=caaa9866-99f7-49c8-ac1c-7475e2f38551',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3d28a684-038a-4e33-a88c-3a9a6cc77154?alt=media&token=e771d672-ff2d-4338-a07e-5ee5ce52f7f8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F66bfc1b4-c714-4e26-919a-9a57bbc36864?alt=media&token=39da4780-34ab-4380-ac5a-250b614fbfca',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd70a90f9-d9df-4eaa-8a3b-dceb6366657b?alt=media&token=4f250a0f-0644-4470-aadd-a66d54ffc60a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd3241fc3-d0cf-4a77-a2fd-bdbcae06b56f?alt=media&token=96bab4f3-8b80-4063-bc23-6e5a9be80b96',
    ],
    name: 'Songhwa Sansi Dosangmyeon',
    priceLevel: 1,
    tags: ['Knife-cutNoodle', 'Shanxi'],
    location: {
      address: '33, Achasan-ro 30-gil, Gwangjin-gu, Seoul',
      area: 'Konkuk University',
      latlng: [37.53821, 127.066342],
      subway: 'Line 2, Line 7',
      nearBy: 'Konkuk Univ. Station',
      googleMap: 'https://maps.app.goo.gl/KWVqDoYMPHKgQ68s6',
    },
    address: '33, Achasan-ro 30-gil, Gwangjin-gu, Seoul',
    latlng: [37.53821, 127.066342],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1476-7832',
      },
      {
        label: 'Business Hours',
        value: '12:00 - 23:30',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:00 - 16:00',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '쇼마이, 호박볼, 쇼롱포오, 도삭면',
      },
    ],
    recommendations: [
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd3241fc3-d0cf-4a77-a2fd-bdbcae06b56f?alt=media&token=96bab4f3-8b80-4063-bc23-6e5a9be80b96',
        name: '쇼마이',
        subheader: 'Siaomai, Shumai',
        description:
          'Shumai is a steamed Chinese dumpling filled with ground meat and shrimp, featuring a delicate wrapper.',
        price: 'KRW9,000',
      },
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F347140b8-a254-44c1-bc40-fd30c641115b?alt=media&token=67fbf38a-bd35-45f3-b515-691300a00aeb',
        name: '도삭면',
        subheader: 'Hand-shaved Noodle',
        description:
          'Dao Xiao Mian is a type of Chinese hand-shaved noodle known for its thick, chewy texture and is often served in a savory broth or with various stir-fried ingredients.',
        price: 'KRW9,000',
      },
      {
        category: 'Chinese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F66bfc1b4-c714-4e26-919a-9a57bbc36864?alt=media&token=39da4780-34ab-4380-ac5a-250b614fbfca',
        name: '쇼롱포오',
        subheader: 'Xiao Long Bao',
        description:
          'Xiao Long Bao is a type of Chinese soup dumpling filled with seasoned pork and a rich, savory broth, typically steamed in a small bamboo basket.',
        price: 'KRW8,000',
      },
    ],
    html: '<h1>Songhwa Sansi Dosangmyeon 송화산시도삭면 </h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Located in the vibrant area of </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Konkuk University</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, Songhwa Sansi Dosangmyeon offers an authentic taste of China with its renowned Shanxi knife-cut noodles and delicious Hong Kong-style dim sum. This popular spot attracts both local Koreans and Chinese international students, so be prepared for a wait! What sets them apart is their commitment to quality.</span></p><p><br></p><p><strong>Highlight:</strong> E<span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">verything is made from scratch, starting with the dough, making it a must-visit for any noodle and dim sum lover seeking true Chinese flavors.</span></p><p><br></p><p><strong>Location:</strong> Approximately 491 meters from Exit 6 of Konkuk Univ. Station</p><p><br></p>',
    description: 'Specializes in Shanxi Dao Xiao Mian and dim sum, made just like in China. ',
    createdAt: '2024-10-16T07:01:54.084Z',
    updatedAt: '2024-10-16T07:01:54.084Z',
  },
  'drawing-recipe-the-authentic-homemade-pizza': {
    id: 'drawing-recipe-the-authentic-homemade-pizza',
    slug: 'drawing-recipe-the-authentic-homemade-pizza',
    url: '/discovery/place/drawing-recipe-the-authentic-homemade-pizza',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea5c1738-a011-4adf-b3f1-963b4345c9d3?alt=media&token=ca188847-c8d6-44d5-beb5-fc95ee85f8b5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6b583bf2-1fbf-489f-bfb4-d4f8da060e18?alt=media&token=061476f6-cb7e-431a-ba01-cf3a7c94968b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F961e8a37-e7f2-48d3-a93e-4e96b7bd65db?alt=media&token=f80fbdb3-4cf4-4b04-9f84-fdf98a98bcde',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4a918f58-7912-48cc-84fe-b0a1115e9d52?alt=media&token=27c5b232-9098-4743-8d5d-4aa2193dfa72',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8abbc83a-22db-48f3-b5f3-1cf0c2c5836a?alt=media&token=55b2984f-7c4a-4e1f-a121-5da89830a0b3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fafbc596c-3bee-4cb1-90ed-1cb32e448e6b?alt=media&token=33b69d81-6570-468b-a55d-57ca4e509782',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa2d82ebb-f008-438c-a39a-b8e263927198?alt=media&token=91c89a11-664b-4064-8ab2-42a87c272386',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faa0c886d-ff2d-4d96-ab61-fb72a706e470?alt=media&token=af669700-46ea-4b5c-8083-8144e0c8e52b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb6dcc759-4684-4fcb-82e6-6ca01841c011?alt=media&token=2ddf6fea-2fdf-4574-b486-9e40fc089905',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6ddd8af3-5d4d-4439-be82-21fe1d121168?alt=media&token=1b681342-29ee-4859-9aba-392a2078b661',
    ],
    name: 'Drawing Recipe',
    priceLevel: 3,
    tags: ['Pizza', 'Pasta'],
    location: {
      address: '45, Ttukseom-ro 33-gil, Gwangjin-gu, Seoul',
      area: 'Konkuk University ',
      latlng: [37.537167, 127.070004],
      subway: 'Line 2, Line 7',
      nearBy: 'Konkuk Univ. Station',
      googleMap: 'https://maps.app.goo.gl/jtKdGokm5PsxZ1S97',
    },
    address: '45, Ttukseom-ro 33-gil, Gwangjin-gu, Seoul',
    latlng: [37.537167, 127.070004],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1412-5334',
      },
      {
        label: 'Business Hours',
        value: '12:00 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:30',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '드로앙 샐러드, 매드 포 치즈, 게토 뉴욕, 드로일 피자, 갈릭 쉬림프, 드로잉까르보나라',
      },
    ],
    recommendations: [
      {
        category: 'Italian ',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faa0c886d-ff2d-4d96-ab61-fb72a706e470?alt=media&token=af669700-46ea-4b5c-8083-8144e0c8e52b',
        name: '드로앙 샐러드',
        subheader: 'Salad',
        description:
          'Fresh mixed vegetables, tangy dressing, Grana Padano, burrata cheese, and Shine Muscat grapes.',
        price: 'KRW14,500',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6b583bf2-1fbf-489f-bfb4-d4f8da060e18?alt=media&token=061476f6-cb7e-431a-ba01-cf3a7c94968b',
        name: '매드 포 치즈 (스몰)',
        subheader: 'Cheese Pizza',
        description: ' Mozzarella cheese, Grana Padano, Gorgonzola, cheddar cheese, and honey',
        price: 'KRW17,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6ddd8af3-5d4d-4439-be82-21fe1d121168?alt=media&token=1b681342-29ee-4859-9aba-392a2078b661',
        name: '게토 뉴욕 (스몰)',
        subheader: 'Tomato Bacon Pizza',
        description:
          'Tomato sauce, mozzarella cheese, beef, bacon, American cheese, sun-dried tomatoes, and dill pickles.',
        price: 'KRW17,500',
      },
      {
        category: 'Italian ',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa2d82ebb-f008-438c-a39a-b8e263927198?alt=media&token=91c89a11-664b-4064-8ab2-42a87c272386',
        name: '드로일 피자 (스몰)',
        subheader: 'Bacon and Pepperoni Pizza',
        description:
          'Beef, bacon, pepperoni, pineapple, roasted bell peppers, red onion, and jalapeños.',
        price: 'KRW18,500',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea5c1738-a011-4adf-b3f1-963b4345c9d3?alt=media&token=ca188847-c8d6-44d5-beb5-fc95ee85f8b5',
        name: '갈릭 쉬림프',
        subheader: 'Garlic Shrimp Pasta',
        description: 'Homemade herb butter, garlic, shrimp, clams, lemon, and green onions.',
        price: 'KRW21,500',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F961e8a37-e7f2-48d3-a93e-4e96b7bd65db?alt=media&token=f80fbdb3-4cf4-4b04-9f84-fdf98a98bcde',
        name: '드로잉까르보나라',
        subheader: 'Carbonara',
        description: 'Canadian bacon, bacon, egg yolk, Grana Padano, and black pepper.',
        price: 'KRW18,500',
      },
    ],
    html: '<h1>Drawing Recipe 드로잉레시</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Drawing Recipe is a must-visit pizza place near Konkuk University, renowned for its delicious, made-to-order pizzas. This restaurant has received notable recognition from the Blue Ribbon Survey, simultaneously earning the Red Ribbon distinction—an honor given to only 600 establishments nationwide. </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">At Drawing Recipe, the chef crafts everything from scratch, starting with the dough, ensuring each pizza is fresh and flavorful.&nbsp;Every pizza is made to order!</span></p><p><br></p><p><strong>Location:</strong> Approximately 403 meters from Exit 5 of Konkuk Univ. Station.</p><p><br></p><p><strong>Note:</strong> Reservations are accepted via Catchtable and Naver to avoid wait times. </p><p><br></p><p><br></p>',
    description:
      'Specializes in pasta and pizza, with pizzas made to order using freshly prepared dough.',
    createdAt: '2024-10-16T06:09:16.353Z',
    updatedAt: '2024-10-16T06:09:16.353Z',
  },
  'dodo-grilled-tripe-discover-the-best-in-grilled-tripe-flavors': {
    id: 'dodo-grilled-tripe-discover-the-best-in-grilled-tripe-flavors',
    slug: 'dodo-grilled-tripe-discover-the-best-in-grilled-tripe-flavors',
    url: '/discovery/place/dodo-grilled-tripe-discover-the-best-in-grilled-tripe-flavors',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc1ac7b42-1288-4cc6-ada2-668d3cb695c1?alt=media&token=bd56c3f3-5131-4708-b9c6-0f3c1aea92f0',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F94a0d485-fa76-4e0a-9b04-d924c2d37ef3?alt=media&token=eef87fbb-5be8-409b-8cc0-ee80147e4ee3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F03205149-a44b-44d0-bca4-1334125cccd5?alt=media&token=39ec64d2-deb5-431a-9645-03bf05f910de',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3cc13d5c-a3b7-4cf5-a9d0-93c26b0d833b?alt=media&token=40f8a013-1415-439b-8591-e5d5d2073b51',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F63b91dae-4e11-47aa-a2a4-888d106748ff?alt=media&token=998bbf24-a610-4f20-b521-342b12a016ef',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F62caef14-bd15-41c6-891f-ee05bf65565a?alt=media&token=9dc806c3-ad4c-4522-a7cc-23287ba72de9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1e5af1ec-584b-44ec-97e4-332f4ea83ba5?alt=media&token=9a7504aa-ef9e-4d36-a6a6-d3504d0a60fc',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F56f8154a-ddec-49f8-af09-df3432df4ff8?alt=media&token=f7f89755-658c-407c-b58c-9ebd82e9014c',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6b3a053c-2062-4482-891c-f50ca04d6e84?alt=media&token=76c5d246-095e-4791-9378-4972ab089950',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2ba4859a-4c89-4eb4-a6e5-bd26081b4bfd?alt=media&token=1cdbae7f-b5b1-4227-b19c-ca3f2b5e380a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffd45d3a5-d7d2-4619-966e-7ccc7d39012c?alt=media&token=7fbbbc10-32a6-4126-82d6-7567bbc6732b',
    ],
    name: 'Dodo Grilled Tripe Konkuk Univ. Main Branch',
    priceLevel: 3,
    tags: ['KoreanBeef', 'Intestines', 'BBQ'],
    location: {
      address: '18, Achasan-ro 34-gil, Gwangjin-gu, Seoul',
      area: 'Konkuk University',
      latlng: [37.539356, 127.069306],
      subway: 'Line 2, Line 7',
      nearBy: 'Konkuk Univ. Station',
      googleMap: 'https://maps.app.goo.gl/VSSzoQsCwJW4TCvYA',
    },
    address: '18, Achasan-ro 34-gil, Gwangjin-gu, Seoul',
    latlng: [37.539356, 127.069306],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1325-7797',
      },
      {
        label: 'Business Hours',
        value: '16:00 - 23:30',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '한우곱창, 세트 2, 세트 5, 치즈야채곱창 ',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6b3a053c-2062-4482-891c-f50ca04d6e84?alt=media&token=76c5d246-095e-4791-9378-4972ab089950',
        name: '한우곱창',
        subheader: 'Korean Beef',
        description:
          'Fresh refrigerated Korean beef intestines, delivered daily from Hoengseong and Eumseong, known for their juicy richness and exceptional flavor!',
        price: 'KRW23,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2ba4859a-4c89-4eb4-a6e5-bd26081b4bfd?alt=media&token=1cdbae7f-b5b1-4227-b19c-ca3f2b5e380a',
        name: '세트 2 (Set 2)',
        subheader: 'Salted Korean Beef Intestines',
        description:
          'Korean beef intestines, seasoned salt intestines, and cheesy vegetable intestines all in one dish.',
        price: 'KRW50,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffd45d3a5-d7d2-4619-966e-7ccc7d39012c?alt=media&token=7fbbbc10-32a6-4126-82d6-7567bbc6732b',
        name: '세트 5 (Set 5)',
        subheader: 'Salted Small Intestines, Large Intestines',
        description:
          'Korean beef intestines, salted small intestines, and large intestines all on one plate! A special set menu dedicated to those who love beef!',
        price: 'KRW64,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F56f8154a-ddec-49f8-af09-df3432df4ff8?alt=media&token=f7f89755-658c-407c-b58c-9ebd82e9014c',
        name: '치즈야채곱창',
        subheader: 'Cheesy Vegetable Intestines ',
        description:
          'You can order one serving of each menu item (e.g., 1 serving of seasoned small intestines + 1 serving of cheesy vegetable intestines = 2 servings). If you want to enjoy multiple dishes together, choosing a set menu will allow you to enjoy them at a better price.',
        price: 'KRW17,000',
      },
    ],
    html: '<h1 class="ql-align-justify">Dodo Grilled Tripe 도도곱창 </h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">도도곱창 (Dodo Grilled Tripe) is a popular spot for anyone craving delicious grilled tripe.  It is so famous that even celebrities like MOMO from TWICE have visited.</span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">With a focus on gobchang (beef small intestines) and makchang (beef large intestines), the restaurant offers a selection of dishes that are expertly marinated and grilled to perfection, producing rich, smoky flavors.</span></p><p><br></p><p><strong>Location:</strong> Approximately 142 meters from Exit 5 of Gunja Station.</p><p><br></p><p><strong>Note:</strong> Reservations are accepted via Catchtable to avoid wait times. </p>',
    description:
      'Dodo Gopchang in Gunja is a premier destination for enjoying high-quality beef and pork intestines, crafted through years of research and perfected with a unique broth that ensures rich flavor and savory goodness.',
    createdAt: '2024-10-16T05:39:01.671Z',
    updatedAt: '2024-10-16T05:39:01.671Z',
  },
  'qua-the-taste-of-hanoi': {
    id: 'qua-the-taste-of-hanoi',
    slug: 'qua-the-taste-of-hanoi',
    url: '/discovery/place/qua-the-taste-of-hanoi',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7eae9518-40d4-4836-932f-e040ea73aa56?alt=media&token=4aed61d6-7ab3-4c24-a96e-12c146cf2d58',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F39b69b60-1a70-4cdb-ac37-a3d6956dd036?alt=media&token=d6863af3-200a-4400-a714-8e53c2ed8fbf',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbe1715af-4108-4517-a242-99e06398321e?alt=media&token=db5bec83-4eeb-47a2-bb97-527b3930a10a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F94cece91-9695-475a-9ec3-e30bcb72bc22?alt=media&token=5572c44f-6217-439a-88c8-f3f3da88cadd',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd01e4552-fd5c-4b89-b80f-15b03aaf2242?alt=media&token=cd262596-b4da-4887-9f11-b3ac07a238da',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5aea2dd7-c9c7-4dd0-8367-1b62fdec21cf?alt=media&token=59778839-68d9-45ce-9a2c-7bfbf7e287c6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F765c63e8-29a0-437e-bf35-6d720c3db167?alt=media&token=44533a04-5594-46d6-bac3-3d5aeacb0e4b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Febb4de15-f86b-44ba-b904-c01a7a31f940?alt=media&token=189cf551-f0ad-40c0-9273-8842d4e9618f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F977de8c6-ef3c-4c8a-9823-63cb2f8fdfdd?alt=media&token=fbe5e2e9-a425-4679-a8a2-43ac44a7fcdf',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9542f50f-07b4-44e7-b7f6-01cbdc210107?alt=media&token=b9473256-2954-4efa-80ae-9ecb2562797a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8a6f2453-a634-4be7-a954-f8b8a101b287?alt=media&token=b91da380-1f3b-48e9-a299-2e8dd685dc9e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F94785f50-90a1-41b1-9e8f-c8585975f1dd?alt=media&token=96e25d4a-b6da-47e3-b94d-66f919811eed',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F95d16659-f702-41e5-8f74-dcd7a86ac02b?alt=media&token=333cc170-9b69-4aac-9479-c120ae75ebd3',
    ],
    name: 'QUÃ',
    priceLevel: 2,
    tags: ['Vietnamese', 'RiceNoodleSoup', 'Hanoi'],
    location: {
      address: '9, Gunja-ro 3-gil, Gwangjin-gu, Seoul',
      area: 'Konkuk University',
      latlng: [37.544734, 127.070881],
      subway: 'Line 7',
      nearBy: "Children's Grand Park Station",
      googleMap: 'https://maps.app.goo.gl/gp8sncy2Ab5iSxtT9',
    },
    address: '9, Gunja-ro 3-gil, Gwangjin-gu, Seoul',
    latlng: [37.544734, 127.070881],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1395-5468',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '고기듬뿍쌀국수, 왕갈비 쌀국수, 분짜, 분보남보, 쉬림프라이스롤, 넴',
      },
    ],
    recommendations: [
      {
        category: 'Vietnam',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8a6f2453-a634-4be7-a954-f8b8a101b287?alt=media&token=b91da380-1f3b-48e9-a299-2e8dd685dc9e',
        name: '고기듬뿍쌀국수',
        subheader: 'Vietnamese Rice Noodle Soup',
        description: 'Flavorful rice noodle soup loaded with tender, juicy meat.',
        price: 'KRW13,000',
      },
      {
        category: 'Vietnam',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd01e4552-fd5c-4b89-b80f-15b03aaf2242?alt=media&token=cd262596-b4da-4887-9f11-b3ac07a238da',
        name: '왕갈비 쌀국수',
        subheader: 'Short Rib Noodle Soup',
        description: 'Rice noodle soup with big and tender beef short ribs.',
        price: 'KRW15,000',
      },
      {
        category: 'Vietnam',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5aea2dd7-c9c7-4dd0-8367-1b62fdec21cf?alt=media&token=59778839-68d9-45ce-9a2c-7bfbf7e287c6',
        name: '분짜',
        subheader: 'Wrap',
        description: 'Grilled pork and rice noodle bowl served with fresh herbs and dipping sauce.',
        price: 'KRW18,000',
      },
      {
        category: 'Vietnam',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9542f50f-07b4-44e7-b7f6-01cbdc210107?alt=media&token=b9473256-2954-4efa-80ae-9ecb2562797a',
        name: ' 분보남보',
        subheader: 'Vietnamese Noodle Soup',
        description:
          'Vermicelli noodles topped with grilled beef, fresh herbs, and a flavorful sauce.',
        price: 'KRW12,000',
      },
      {
        category: 'Vietnam',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F94785f50-90a1-41b1-9e8f-c8585975f1dd?alt=media&token=96e25d4a-b6da-47e3-b94d-66f919811eed',
        name: '쉬림프라이스롤',
        subheader: 'Shrimp Rice Rolls',
        description: 'Shrimp rice rolls with fresh shrimp wrapped in delicate rice paper.',
        price: 'KRW7,000',
      },
      {
        category: 'Vietnam',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F95d16659-f702-41e5-8f74-dcd7a86ac02b?alt=media&token=333cc170-9b69-4aac-9479-c120ae75ebd3',
        name: '넴',
        subheader: 'Vietnamese Fried Spring Rolls',
        description:
          'Vietnamese spring rolls filled with savory pork and fresh vegetables, served with a tangy dipping sauce.',
        price: 'KRW8,000',
      },
    ],
    html: '<h1>QUÃ 꾸아 </h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">QU</span>Ã<span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is a Vietnamese restaurant featured on the tvN variety show </span><span style="background-color: rgb(255, 255, 255); color: rgb(60, 62, 64);">“The Must-Try Restaurants"</span><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. Known for its Vietnamese rice noodle soup, it authentically replicates the flavors of Hanoi\'s most famous pho.</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify">Highlight: <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);"> The broth is simmered for more than 10 hours, providing a rich, deep meat flavor and a clean, refreshing taste. Experience the true essence of Hanoi, setting it apart from ordinary pho!</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify">Location: Approximately 452 meters from Exit 4 of Children’s Grand Park Station.</p><p><br></p>',
    description:
      'Specializing in Vietnamese rice noodle soup, with a particular emphasis on the flavors of Hanoi.',
    createdAt: '2024-10-16T05:17:10.738Z',
    updatedAt: '2024-10-16T05:17:10.738Z',
  },

  //이태원
  'troika-the-taste-of-russia': {
    id: 'troika-the-taste-of-russia',
    slug: 'troika-the-taste-of-russia',
    url: '/discovery/place/troika-the-taste-of-russia',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6eeb6386-93b6-4e96-95b8-e83ca6a5e735?alt=media&token=2225dc7b-2ec2-408e-9043-41f25e8e8b6b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F29bdbe33-4718-4ff7-8bb5-97d09ca2b7dd?alt=media&token=129b3c90-f310-488f-810e-80b3d0c9c928',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4e486d3a-a406-43aa-97f2-505b7c284c7d?alt=media&token=959f8efe-5bcc-45fd-ae5d-a5dcfc0e4df5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F08c77803-4e33-4f92-9760-69188c35b682?alt=media&token=f27ceda4-5474-4007-881c-20a258f03724',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F379ba1fc-9a15-4060-ac75-e956e4aded67?alt=media&token=ddb5110b-f129-4a52-928b-82e25525c0c1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F623e313c-f67b-4b08-9680-e11e757274c7?alt=media&token=f9698381-a706-4a2a-8452-27a4ee252c4d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F266e250f-755c-4027-b8b7-a5fe9cb5afe5?alt=media&token=e0544e87-eb5f-4d9d-bb4f-93feff5f9e90',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F03ec2a4c-cccf-4c09-ae6c-7961710924ec?alt=media&token=f048810c-a159-41ba-82f3-d5a3b2d6fb50',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2e3f15c7-f217-47be-919f-9278e45e8ced?alt=media&token=ef191656-6a87-4f49-a230-65d091433379',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F43cb47a1-e4cc-4bc8-902a-cb9d5327d117?alt=media&token=6a2d1b27-0b1d-426d-950d-53f1d9f087a0',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3ad0ed05-ff60-4614-b822-02217abe0b08?alt=media&token=60f90679-29f7-490d-b90b-590ebfa37b55',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7dc86636-3d3a-47ca-a117-128300f49223?alt=media&token=57d4d6b7-f740-4f8b-9d48-679f23b0f696',
    ],
    name: 'Troika',
    priceLevel: 3,
    tags: ['Russian', 'Troika', ''],
    location: {
      address: '164-1, Itaewon-ro, Yongsan-gu, Seoul',
      area: 'Itaewon',
      latlng: [37.534188, 126.992462],
      subway: 'Line 6',
      nearBy: 'Itaewon Station',
      googleMap: 'https://maps.app.goo.gl/fk93n6bYEjP4FzkE7',
    },
    address: '164-1, Itaewon-ro, Yongsan-gu, Seoul',
    latlng: [37.534188, 126.992462],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1400-7724',
      },
      {
        label: 'Business Hours',
        value: '12:00 - 23:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '텔랴티나 브 고스셔취케, 골굽쯔, 비프스트로가노프, 체부레키',
      },
    ],
    recommendations: [
      {
        category: 'Russian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7dc86636-3d3a-47ca-a117-128300f49223?alt=media&token=57d4d6b7-f740-4f8b-9d48-679f23b0f696',
        name: '텔랴티나 브 고스셔취케',
        subheader: 'Mushroom, Beef',
        description: 'Mushrooms and veal slow-cooked in a clay pot.',
        price: 'KRW23,000',
      },
      {
        category: 'Russian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3ad0ed05-ff60-4614-b822-02217abe0b08?alt=media&token=60f90679-29f7-490d-b90b-590ebfa37b55',
        name: '골굽쯔',
        subheader: 'Cabbage wrap',
        description: 'Succulent beef wrapped in tender cabbage, served with rice.',
        price: 'KRW19,000',
      },
      {
        category: 'Russian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F379ba1fc-9a15-4060-ac75-e956e4aded67?alt=media&token=ddb5110b-f129-4a52-928b-82e25525c0c1',
        name: '비프스트로가노프',
        subheader: 'Beef, Mashed potatoes',
        description:
          'Juicy beef paired with a smooth cream sauce and served alongside creamy mashed potatoes.',
        price: 'KRW22,000',
      },
      {
        category: 'Russian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6eeb6386-93b6-4e96-95b8-e83ca6a5e735?alt=media&token=2225dc7b-2ec2-408e-9043-41f25e8e8b6b',
        name: '체부레키',
        subheader: 'Russian fried dumplings',
        description: 'Homemade Russian fried dumplings filled with seasoned beef.',
        price: 'KRW13,000',
      },
    ],
    html: '<h1>Troika 트로이카</h1><p><br></p><p class="ql-align-justify"><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Itaewon</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is well-known not only for its vibrant drinking culture but also for its rich cultural diversity. If you’re seeking traditional Russian cuisine, Troika is an excellent choice.</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">This family-run restaurant, operated by a Russian family, serves authentic dishes that bring the flavors of Russia to Seoul, all within a warm and inviting atmosphere. You can savor classic meals like sote, carmen, and telkyatina v gorshochke, all made with the love of a Russian mother.</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Location:</strong> Approximately 162 meters from Exit 4 of Itaewon Station.</p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><br></p><p><br></p>',
    description:
      'Troika, run by Russian locals, offers authentic Lake Baikal-inspired cuisine that perfectly caters to Korean tastes.',
    createdAt: '',
    updatedAt: '2024-10-16T04:43:40.753Z',
  },
  'osteria-orzo-the-italian-korean-fusion-restaurant': {
    id: 'osteria-orzo-the-italian-korean-fusion-restaurant',
    slug: 'osteria-orzo-the-italian-korean-fusion-restaurant',
    url: '/discovery/place/osteria-orzo-the-italian-korean-fusion-restaurant',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F62c272a7-986a-4fba-b57f-5649de0e6fd1?alt=media&token=27a3d53c-d335-4bb8-838e-6b9eb892ba63',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1ad09845-c093-47b9-8d4d-b7339463c465?alt=media&token=efb103e2-d4c0-4d2c-aa01-637f2e04dfa5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fac667653-0353-4d05-9ebb-82db9b448343?alt=media&token=99be98b9-63c6-472d-8177-e33c5eb0aee0',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc3a279f6-dc54-44d8-92f0-8da39bb4ffb2?alt=media&token=a8ad51f2-51db-43ff-9a64-3c34bbe1f2ba',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F47cb165f-5cee-42d9-bee5-38d611fc5592?alt=media&token=df8f9443-d067-4fb8-b29a-b3bd5382f2c2',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1a36607e-083f-48fc-afb5-8b47f467d260?alt=media&token=221ea955-cebe-47e0-8b56-5a99c580a964',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F17cc3544-2bd7-4ca6-bb8c-cf72624f2892?alt=media&token=43b46d89-35a7-4115-b332-18cac965918e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fcbb95203-b48f-493d-93e6-68524bb52fb8?alt=media&token=90703141-5d35-43dd-a4ef-ba7407a36be3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa2ac6885-26c6-4539-9458-e65be05b5363?alt=media&token=68bed598-78f0-44d0-92a9-a66b658f210f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F04678886-06bd-41e2-98c9-2b6da74389bf?alt=media&token=a3cfd4ac-2ece-47e6-9ce9-750b0da849a4',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea68892d-5de3-416c-b21f-cc41cc731f6b?alt=media&token=03ff4e62-a710-4162-b9d2-8e5ebac1a0f6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F130cb036-849b-4556-ac8b-feb11d2f1814?alt=media&token=cb848084-7103-4634-9608-7d6dff796b7e',
    ],
    name: 'Osteria Orzo ',
    priceLevel: 4,
    tags: ['Italian', 'Fusion', 'Wine'],
    location: {
      address: '47, Hannam-daero 20-gil, Yongsan-gu, Seoul',
      area: 'Hannam',
      latlng: [37.534978, 127.009359],
      subway: 'Gyeongui-joungang Line',
      nearBy: 'Hannam Station',
      googleMap: 'https://maps.app.goo.gl/pZwhZMhYNQucfRLw9',
    },
    address: '47, Hannam-daero 20-gil, Yongsan-gu, Seoul',
    latlng: [37.534978, 127.009359],
    information: [
      {
        label: 'Phone Number',
        value: '010-6361-0801',
      },
      {
        label: 'Business Hours',
        value: '12:00 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:30',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW40,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '투뿔한우안심카르피치오, 문어와 감자메쉬, 튀긴가지와 토마토살사, 카프레제',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F47cb165f-5cee-42d9-bee5-38d611fc5592?alt=media&token=df8f9443-d067-4fb8-b29a-b3bd5382f2c2',
        name: '투뿔한우안심카르치오',
        subheader: 'Korean Beef ',
        description:
          'Carcio is a Korean-Italian fusion dish that features marinated Korean beef combined with Italian flavors and ingredients.',
        price: 'KRW29,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea68892d-5de3-416c-b21f-cc41cc731f6b?alt=media&token=03ff4e62-a710-4162-b9d2-8e5ebac1a0f6',
        name: '문어와 감자메쉬',
        subheader: 'Octopus, Mashed Potatoes',
        description: 'Tender octopus served alongside creamy mashed potatoes.',
        price: 'KRW24,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc3a279f6-dc54-44d8-92f0-8da39bb4ffb2?alt=media&token=a8ad51f2-51db-43ff-9a64-3c34bbe1f2ba',
        name: '스파이시크랩리조또',
        subheader: 'Crab, Risotto',
        description: 'Made with creamy Arborio rice, fresh crab meat, and a kick of spice.',
        price: 'KRW27,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F130cb036-849b-4556-ac8b-feb11d2f1814?alt=media&token=cb848084-7103-4634-9608-7d6dff796b7e',
        name: '카프레',
        subheader: 'Italian Salad',
        description:
          'Italian salad made with fresh mozzarella cheese, ripe tomatoes, and basil, drizzled with olive oil and balsamic vinegar.',
        price: 'KRW19,000',
      },
    ],
    html: '<h1>Osteria Orzo 오스테리아 오르조</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Osteria Orzo is a beloved Italian restaurant located in the heart of Itaewon, Seoul, and is featured in the Michelin Guide. Renowned for its authentic cuisine and casual dining atmosphere!</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify">Highlight: <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);"> The restaurant offers a menu filled with fresh pasta, risottos, and classic Italian dishes. Each dish pairs perfectly with a glass of wine, and the offerings truly reflect the essence of traditional Italian cooking, making for an unforgettable dining experience. Be sure to make a reservation before your visit to secure your table!</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify">Location: Approximately 821 meters from Exit 1 of Hannam Station.</p><p class="ql-align-justify"><br></p><p class="ql-align-justify">Note: Reservations are accepted via Catchtable to avoid wait times.</p><p><br></p>',
    description:
      'A best spot to enjoy delicious Italian food and drinks, the restaurant aims to offer the perfect dishes that pair with wine.',
    createdAt: '',
    updatedAt: '2024-10-16T04:20:04.628Z',
  },
  'sulkkoma-the-perfect-drinking-spot-in-itaewon': {
    id: 'sulkkoma-the-perfect-drinking-spot-in-itaewon',
    slug: 'sulkkoma-the-perfect-drinking-spot-in-itaewon',
    url: '/discovery/place/sulkkoma-the-perfect-drinking-spot-in-itaewon',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0cf1ec9f-4556-4df3-a1c5-35df9ffa2731?alt=media&token=80af059c-0749-4756-a147-4952d176a1fd',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Feae11db1-246d-480f-93d5-f2eb9b834c56?alt=media&token=63c3467a-00fe-4312-b055-ca4a4bb7a190',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F25be148f-fc43-4e59-ae99-c5bd62fdada8?alt=media&token=2bee64e4-b6d4-4bbf-8b97-2abfc44d8878',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffb47e53c-bafa-4d47-a192-4c924ec80ed3?alt=media&token=94bb590e-aea0-4d06-af91-68ccc4f8be58',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F285f854a-7791-4a09-97de-bbb3f9cbff84?alt=media&token=6cb0f286-cd0c-429a-beb1-16783bacf13b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0679dc91-2cb8-4732-858d-f8a5a703acda?alt=media&token=6311bbf7-ad98-45be-a110-d988f11b3ea9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fddeeb14c-88cb-428a-9184-b9c5f37fb209?alt=media&token=35fe76e7-b3c9-44c7-a039-13d93fcd6670',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4db39117-2391-4c2d-a0c0-8a242c5629fb?alt=media&token=bc473d07-8081-4738-84d9-6b7d50e55fad',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4598d3e2-07f9-483d-91da-bfea3b6dcc6e?alt=media&token=ccfbabfd-6ae9-441c-a06e-431ed752cc99',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F91c48ba7-2a42-40f9-851f-cc17963ba8a6?alt=media&token=f5b22097-56de-4463-ac5c-0e1fe4ea1de6',
    ],
    name: 'Sulkkoma ',
    priceLevel: 3,
    tags: ['KoreanDrinkingCulture', 'Makgeolli', 'Itaewon', 'Bar'],
    location: {
      address: '59-1, Noksapyeong-daero 40-gil, Yongsan-gu, Seoul',
      area: 'Itaewon',
      latlng: [37.534566, 126.989266],
      subway: 'Line 6',
      nearBy: 'Noksapyeong Station',
      googleMap: 'https://maps.app.goo.gl/eWfXZmgvnsaajBsTA',
    },
    address: '59-1, Noksapyeong-daero 40-gil, Yongsan-gu, Seoul',
    latlng: [37.534566, 126.989266],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1349-6517',
      },
      {
        label: 'Business Hours',
        value: 'Fri, Sat 16:30 - 02:00/ Sun 16:30 - 23:00/ Mon, Tue, Wed, Thu 16:30 - 24:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '떡갈비 김치치즈 토마토 스튜, 부추아보카도전, 카펠리니골뱅이 비빔면, 들기름막국수',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F91c48ba7-2a42-40f9-851f-cc17963ba8a6?alt=media&token=f5b22097-56de-4463-ac5c-0e1fe4ea1de6',
        name: '떡갈비 김치치즈 토마토 스튜',
        subheader: 'Korean grilled short rib patties',
        description: "After enjoying the tteokgalbi, it's recommended to add noodles and bread.",
        price: 'KRW23,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4db39117-2391-4c2d-a0c0-8a242c5629fb?alt=media&token=bc473d07-8081-4738-84d9-6b7d50e55fad',
        name: '부추아보카도전',
        subheader: 'Avocado Korean Pancake',
        description: 'barley shrimp for a savory flavor, topped with creamy avocado.',
        price: 'KRW22,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Feae11db1-246d-480f-93d5-f2eb9b834c56?alt=media&token=63c3467a-00fe-4312-b055-ca4a4bb7a190',
        name: '카펠리니골뱅이 비빔면',
        subheader: 'Korean bibimmyeon',
        description:
          'Spicy and tangy capellini whelk bibimmyeon that will bring back your lost appetite',
        price: 'KRW20,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F25be148f-fc43-4e59-ae99-c5bd62fdada8?alt=media&token=2bee64e4-b6d4-4bbf-8b97-2abfc44d8878',
        name: '들기름막국수',
        subheader: 'Korean cold noodle',
        description:
          'Nutty perilla oil cold buckwheat noodles, perfect for slurping up in the summer.',
        price: 'KRW20,000',
      },
    ],
    html: '<h1>Sulkkoma 술꼬마 </h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">When people head to Itaewon, they\'re often looking for a vibrant spot to enjoy drinks and a lively atmosphere, and Liquor Kkoma (술꼬마) is just the place! Whether you\'re kicking off your night or winding down, Liquor Kkoma offers the perfect setting for a fun evening in the heart of Itaewon!</span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Known for its energetic vibe, this bar serves delicious food that pairs perfectly with traditional Korean alcohol, especially 막걸리 (makgeolli). With a menu featuring crispy chives, avocado Korean pancakes, tender tteokgalbi, spicy kimchi, cheesy tomato stew, and savory seafood ramen, you’ll find plenty of tasty options to complement your drinks. </span></p><p><br></p><p><strong>Location:</strong> Approximately 342 meters from Exit 3 of Noksapyeong Station.</p><p><br></p><p><strong>Note</strong>: Reservations are accepted via Naver, Catchtable or Instagram (@sulkkoma)</p>',
    description:
      'Specializes in traditional Korean rice alcohol, offering a unique selection of makgeolli paired the perfect Korean snacks.',
    createdAt: '',
    updatedAt: '2024-10-14T02:26:09.776Z',
  },
  'buddhas-belly-your-thai-food-destination': {
    id: 'buddhas-belly-your-thai-food-destination',
    slug: 'buddhas-belly-your-thai-food-destination',
    url: '/discovery/place/buddhas-belly-your-thai-food-destination',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff09a5c22-be1b-4ead-8f08-bee0657abb95?alt=media&token=0e5c5d44-ffda-4ce5-a288-a843e5e69fc6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0e90d389-d3dd-47c0-b77e-3c49418fb918?alt=media&token=c83c0cb0-ce68-4f42-8588-abd555d578c1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9103ba0f-16a7-44d0-b99e-84cdc30c78bd?alt=media&token=ec046288-79db-43b4-8f71-d450edfd315f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0a392f0a-f57c-42e8-9719-f01cf3989945?alt=media&token=1baac4f0-ec03-427e-b2c4-53d46e0be2b5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff61a9d7a-b84f-4414-b203-cbb50f96fcc4?alt=media&token=33666f56-a2c7-4500-8e36-983b7640f8a4',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd558cc60-1f39-48f0-bb5b-94ba477c43c5?alt=media&token=bc49eefa-a9f0-4f7b-a8ce-a5298c5123a7',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa899e796-fc7e-43fc-8e88-1b0c575319c1?alt=media&token=d841ec7c-2116-4e3c-91c1-cdcdd5a26949',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff1d679f2-a52a-4bfc-84ef-f515adeeeaa9?alt=media&token=fda42f8d-94c1-4d0f-8546-4a9871276fd6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F49898724-de02-4f50-90e7-4fae0651d14c?alt=media&token=c5411783-2aa7-46ed-a8e9-313613112834',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd7515214-3af1-4829-947c-7e479317dc19?alt=media&token=da683d16-26aa-45cd-bfd9-a8a01b053d6d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F89b88de7-02a2-4519-95be-cfdf1ee87518?alt=media&token=fcb74769-3b3a-4d5f-99b4-607d573d784f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa11c9b34-9ba7-4946-b5bf-dcd810ffe09c?alt=media&token=e885ebb5-1272-48f9-a0b1-6dd74f116f87',
    ],
    name: "Buddha's Belly ",
    priceLevel: 3,
    tags: ['Thai', 'Itaewon'],
    location: {
      address: '48, Noksapyeong-daero 40-gil, Yongsan-gu, Seoul',
      area: 'Itaewon',
      latlng: [37.534579, 126.98831],
      subway: 'Line 6',
      nearBy: 'Noksapyeong Station',
      googleMap: 'https://maps.app.goo.gl/LDphuHr9QHMqYfBcA',
    },
    address: '48, Noksapyeong-daero 40-gil, Yongsan-gu, Seoul',
    latlng: [37.534579, 126.98831],
    information: [
      {
        label: 'Phone Number',
        value: '1666-2753',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 23:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:00 - 16:30',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW40,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '쏨땀, 얌운센 딸레, 뿌 님 팟 풍 커리, 타이 파스타',
      },
    ],
    recommendations: [
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd7515214-3af1-4829-947c-7e479317dc19?alt=media&token=da683d16-26aa-45cd-bfd9-a8a01b053d6d',
        name: '쏨땀',
        subheader: 'Papaya Salad',
        description: 'Spicy green papaya salad',
        price: 'KRW16,500',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa11c9b34-9ba7-4946-b5bf-dcd810ffe09c?alt=media&token=e885ebb5-1272-48f9-a0b1-6dd74f116f87',
        name: '얌운센 딸레',
        subheader: 'Seafood Salad',
        description: 'Spicy seafood salad with glass noodles in a tangy sauce',
        price: 'KRW26,400',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F49898724-de02-4f50-90e7-4fae0651d14c?alt=media&token=c5411783-2aa7-46ed-a8e9-313613112834',
        name: '뿌 님 팟 풍 커리',
        subheader: 'Soft shell crap curry',
        description: 'Stir-fried soft shell crab with yellow curry & egg',
        price: 'KRW28,600',
      },
      {
        category: 'Thai',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F89b88de7-02a2-4519-95be-cfdf1ee87518?alt=media&token=fcb74769-3b3a-4d5f-99b4-607d573d784f',
        name: '타이 파스타',
        subheader: 'Spicy Pasta',
        description: 'Pasta with chili paste sauce',
        price: 'KRW18,700',
      },
    ],
    html: '<h1>Buddha\'s Belly 부다스벨리 </h1><p><br></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Buddha\'s Belly is one of just 8 restaurants that received the highest rating among the 32 locations certified by Thai Select in South Korea. With a fully Thai kitchen staff, it offers an authentic taste of Thailand right in the heart of Itaewon. </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">The menu features standout dishes like the rich green curry, perfectly balanced pad Thai, and aromatic tom yum soup. Known as a hot spot in Korea, Buddha\'s Belly attracts both locals and visitors eager to experience genuine Thai cuisine in a vibrant atmosphere. Whether you\'re looking for a casual meal or a special dining experience, this restaurant promises a delightful culinary journey.</span></p><p><br></p><p><strong>Location:</strong> Approximately 249 meters from Exit 1 of Noksapyeong Station.</p><p><br></p><p><strong>Note: </strong></p><ol><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>Each person must order one menu item </li><li data-list="ordered"><span class="ql-ui" contenteditable="false"></span>Reservations are accepted via Naver</li></ol><p><br></p><p><br></p>',
    description: 'The authentic Thai hotspot dedicated to delivering the true flavors of Thailand.',
    createdAt: '',
    updatedAt: '2024-10-14T01:54:31.986Z',
  },
  'little-neck-brings-new-york-to-you': {
    id: 'little-neck-brings-new-york-to-you',
    slug: 'little-neck-brings-new-york-to-you',
    url: '/discovery/place/little-neck-brings-new-york-to-you',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa15562c0-49cc-4e6c-b053-4b20d4a2f238?alt=media&token=69d0d34b-9fb1-4036-a851-8c48ce1ce455',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3b94c42e-5b2b-4367-8dc3-1323c5ed0f3b?alt=media&token=3f644f3d-5fd0-439b-836c-0ce75f0fc7ee',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9a430783-4887-4895-ac4a-542fba9f951f?alt=media&token=883668ca-0c97-45d1-9c1f-e1fb768fabed',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff469ae87-e937-4f0a-977f-c118df427778?alt=media&token=ebe1b0fd-964e-4513-99e7-c2293468ac4f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffd78b02c-f245-4675-9320-49633090b5a2?alt=media&token=8b9a7152-46ec-4419-8555-ae7972e9d96e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F36742374-7481-4a05-b272-7a2ac8a9cfe6?alt=media&token=290d07e2-0fb3-4438-bd00-5511ba166dc4',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd38ae335-36ca-4cbc-b6da-60926301c97a?alt=media&token=e22cefd2-bb22-4bda-832f-6c412e35211b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faa3aa8e7-82f5-45d1-9a4a-2d0782db443a?alt=media&token=4c7601a9-d051-48ee-9fa9-c60971f1e4eb',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2418b1be-99db-42ad-8db7-b947ab3fe25a?alt=media&token=a26dc555-780c-454c-9de7-b9e7e770d8e9',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1e68c7f2-483c-43cb-9b43-b68156f1b8d8?alt=media&token=f5c93847-d159-4699-ae07-7ae01c840b0f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0a266aa5-6f37-427e-97c2-bc40113b40a9?alt=media&token=16401883-d6d8-43c7-bbdf-32cf38567079',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6073cbb2-9494-481e-80f6-c728d4a2a75c?alt=media&token=48fa00ab-bb89-40c8-993f-2067e588789f',
    ],
    name: 'Little Neck',
    priceLevel: 4,
    tags: ['ItalianCuisine', 'Wine', 'Brunch'],
    location: {
      address: '66, Hannam-daero 27-gil, Yongsan-gu, Seoul',
      area: 'Itaewon ',
      latlng: [37.540146, 127.002696],
      subway: 'Line 6',
      nearBy: 'Hangangjin Station',
      googleMap: 'https://maps.app.goo.gl/cupbe5UUw1RZvGHcA',
    },
    address: '66, Hannam-daero 27-gil, Yongsan-gu, Seoul',
    latlng: [37.540146, 127.002696],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1340-9499',
      },
      {
        label: 'Business Hours',
        value: '10:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '하와이안 연어 포케, 명란 크림 파스타, 하우스 스테이크, 비프 머쉬룸 리조또',
      },
    ],
    recommendations: [
      {
        category: 'Hawaiian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6073cbb2-9494-481e-80f6-c728d4a2a75c?alt=media&token=48fa00ab-bb89-40c8-993f-2067e588789f',
        name: '하와이안 연어 포케',
        subheader: 'Hawaiian Poke',
        description:
          'Sauce: Spicy Sriracha Mayo Toppings: Fresh Tuna, Avocado, Spicy Crab Salad, Fish Roe Base: Brown Rice, Mixed Greens, Veggies',
        price: 'KRW14,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9a430783-4887-4895-ac4a-542fba9f951f?alt=media&token=883668ca-0c97-45d1-9c1f-e1fb768fabed',
        name: '명란 크림 파스타',
        subheader: 'Cream Pasta',
        description: '(Cream Sauce) Cod Roe, Grana Padano, Pepperoncino.',
        price: 'KRW20,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa15562c0-49cc-4e6c-b053-4b20d4a2f238?alt=media&token=69d0d34b-9fb1-4036-a851-8c48ce1ce455',
        name: '하우스 스테이크',
        subheader: 'House Steak',
        description:
          '200g of ribeye, served with mashed potatoes and green basil sauce. Medium-rare is recommended',
        price: 'KRW38,000',
      },
      {
        category: 'Italian',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0a266aa5-6f37-427e-97c2-bc40113b40a9?alt=media&token=16401883-d6d8-43c7-bbdf-32cf38567079',
        name: '비프 머쉬룸 리조또',
        subheader: 'Beef Mushroom Risotto',
        description:
          '(Cream Sauce) Porcini mushrooms and two other types of mushrooms, ribeye steak, rice, and black pepper.',
        price: 'KRW24,000',
      },
    ],
    html: '<h1>Little Neck 리틀넥</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Little Neck is located in between Itaewon and Hannam and specializes in both authentic and modernized Italian cuisine. </span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Highlight</strong>: <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Little Neck\'s menu primarily features a variety of steaks, risottos, pastas, and poke. This restaurant is considered one of the best places in Hannam for brunch, offering a delightful selection of dishes in a warm and inviting atmosphere.&nbsp;</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Location</strong>: Approximately 162 meters from Exit 3 of Hangangjin Station.</p><p class="ql-align-justify"><br></p><p class="ql-align-justify">Note: Reservations are only accepted on weekdays via Naver to avoid wait times</p><p class="ql-align-justify"><br></p><p><br></p>',
    description:
      "An all-day brunch restaurant that brings 'Little New York' to Seoul, that specializes in Italian cuisine.",
    createdAt: '',
    updatedAt: '2024-10-14T01:13:52.144Z',
  },

  //광화문
  'taste-the-best-traditional-samgyetang-at-tosokchon': {
    id: 'taste-the-best-traditional-samgyetang-at-tosokchon',
    slug: 'taste-the-best-traditional-samgyetang-at-tosokchon',
    url: '/discovery/place/taste-the-best-traditional-samgyetang-at-tosokchon',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F438e46cf-0dbb-4724-b0a2-310e3ee9198c?alt=media&token=ad49966f-e263-48a8-925d-9818e0307dc7',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffc3300eb-87d5-4f5a-9b89-409dd4e38bc9?alt=media&token=81e76def-c2f0-40e4-8076-9ac19ce845d3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbdf44336-ba8e-4edf-96d7-1d3788fe37a6?alt=media&token=e4e7d3b7-a64a-4b57-9074-f7c6ee3f38b3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbf4eb2b7-8698-4a26-8fe6-0eb0e8a4f857?alt=media&token=5e3c8f49-0d66-481b-84a5-327ab3b6dc59',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc367662b-14f8-4a5d-8f54-a1f88b8b1d25?alt=media&token=17a8b02e-833c-4a19-a514-4ed131840be2',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7d3fba4d-da0b-41d6-8efa-3c2fcf83ea5b?alt=media&token=3d332e41-996b-4fd1-a4b8-a3333bc60d12',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1f74a51a-9e42-452e-92ae-94fe73b397d9?alt=media&token=063c96fd-a847-4b39-8a4a-f3bc57254998',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0d7f8261-851e-4159-95d7-d6b94a8e9fcd?alt=media&token=04f99cf9-7303-413f-8b4b-f317d9a1e362',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F599529b6-25fe-4712-a996-408701ff3583?alt=media&token=da58cb4e-92d2-48dc-8196-c08e711f1daf',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F862879dd-713e-4652-b00a-afebe9e11e6c?alt=media&token=1b6f8b30-8fc1-4e90-881a-980815c61c48',
    ],
    name: 'Tosokchon Samgyetang',
    priceLevel: 3,
    tags: ['Samgyetang', 'ChickenSoup', 'Korean'],
    location: {
      address: '5, Jahamun-ro 5-gil, Jongno-gu, Seoul',
      area: 'Gyeongbokgung Palace',
      latlng: [37.577966, 126.971569],
      subway: 'Line 3',
      nearBy: 'Gyeongbokgung Station',
      googleMap: 'https://maps.app.goo.gl/2JMJeqCiC5ZbBAPY8',
    },
    address: '5, Jahamun-ro 5-gil, Jongno-gu, Seoul',
    latlng: [37.577966, 126.971569],
    information: [
      {
        label: 'Phone Number',
        value: '02-737-7444',
      },
      {
        label: 'Business Hours',
        value: '10:00 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '토속촌 삼계탕, 옻계탕 ',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F599529b6-25fe-4712-a996-408701ff3583?alt=media&token=da58cb4e-92d2-48dc-8196-c08e711f1daf',
        name: '토속촌 삼계탕',
        subheader: 'Ginseng Chicken',
        description:
          'A traditional Korean chicken soup made with a whole young chicken stuffed with glutinous rice, ginseng, garlic, and various herbs.',
        price: 'KRW20,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F862879dd-713e-4652-b00a-afebe9e11e6c?alt=media&token=1b6f8b30-8fc1-4e90-881a-980815c61c48',
        name: '옻계탕 ',
        subheader: 'Ginseng Free-range Chicken',
        description:
          'Made with native or free-range chickens, known as "native chicken" (토종닭, tojongdak) in Korea. These chickens are often preferred for their richer flavor and firmer texture compared to standard broiler chickens.',
        price: 'KRW20,000',
      },
    ],
    html: '<h1><span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Tosokchon Samgyetang</span> 토속촌 삼계탕 </h1><p><br></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Located near </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Gyeongbokgung Palace</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, 토속촌 삼계탕 (Tosokchon Samgyetang) is famous for its authentic </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">ginseng chicken soup</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, or samgyetang.  Samgyetang is especially popular in summer and winter for its restorative qualities. </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">The restaurant excels in traditional recipes, using whole chickens stuffed with glutinous rice, ginseng, garlic, and jujubes. Slow-cooked to achieve a rich, nourishing broth. With a rustic decor and welcoming atmosphere, it offers an inviting dining experience, and its reputation as a celebrity favorite adds to its charm. For a true taste of Korean comfort food, 토속촌 삼계탕 is a must-visit!삼계탕 is a must-visit!</span></p><p><br></p><p><strong>Location:</strong> Approximately 174 meters from Exit 2 of Gyeongbokgung Station.</p>',
    description:
      'Specializing in ginseng chicken soup, Tosokchon Samgyetang serves tender chickens stuffed with glutinous rice and herbs for a comforting dining experience.',
    createdAt: '2024-10-17T02:58:44.388Z',
    updatedAt: '2024-10-17T02:58:44.388Z',
  },
  'savor-the-seas-best-at-keunkiwajip': {
    id: 'savor-the-seas-best-at-keunkiwajip',
    slug: 'savor-the-seas-best-at-keunkiwajip',
    url: '/discovery/place/savor-the-seas-best-at-keunkiwajip',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea2f5b23-9119-4fd0-8506-93702504b102?alt=media&token=eb68c1e8-9295-4e4c-a6ef-dbdb0ec49e5f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F331a9977-c935-44e9-b065-a6dbcd1cdc24?alt=media&token=1a6a3230-4d21-4c3d-b7eb-9e7c31107e90',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F30011012-e98b-4605-b9dd-2e809d3d4b63?alt=media&token=7fc40902-9cf6-41b4-a54e-b49fe33b07a5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F29abf3b6-7f97-4f53-bd09-ee135a7265f8?alt=media&token=d1224816-19a6-40d7-8eab-a7b7402b9cc6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F056720f6-46a0-4674-a2f4-3e983d9a4454?alt=media&token=19ca4801-73f0-40f3-ba79-008aabf6ffb5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4727a7e2-95ed-4d88-9ef8-6e259ffad9e2?alt=media&token=366fd512-2603-4bd0-bede-1437135d7b2a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faf5ddff5-aa47-4488-b46a-54294f2cf5a7?alt=media&token=8bf6f24b-27c8-4299-aac0-9f7008f8ebf2',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F345afe48-62fb-465c-91a7-fc1dd959d3f6?alt=media&token=d7a69e76-23ff-437c-ab20-121eb637ce69',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F601244b3-f3db-4aee-bf40-f313b259b9fc?alt=media&token=a8281c57-1a64-4f6e-b232-d02cb595397a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F15008da8-34af-4d63-8d4e-d2bfee0fd70d?alt=media&token=ddfb0da6-346b-4422-9d93-604b3b7f3119',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5a60590b-4ce0-466c-a694-756d8ea45288?alt=media&token=dc274d6d-1256-4234-9238-bc8a89f71e18',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F543390d7-0ba9-46c5-a0f8-678eec82f927?alt=media&token=6890e8c9-3a0b-458f-8946-48bc8b1ab2c1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7c73543d-b844-4fa9-90ce-15d70a4c6ce8?alt=media&token=06e40968-33b6-43e7-9fb8-fb1f14c1daf6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fce9f8784-f753-44ca-8c2e-77e568776943?alt=media&token=67f780c8-a062-42a4-90e3-4a5b1df052a6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9a50edda-2052-4b7d-9832-426a4c9eda10?alt=media&token=124f8e4d-84cb-435b-871c-18f2771bdad5',
    ],
    name: 'Keunkiwajip',
    priceLevel: 4,
    tags: ['MarinatedRawCrab', 'Seafood', 'MichelinOneStar'],
    location: {
      address: '22, Bukchon-ro, Jongno-gu, Seoul',
      area: 'Anguk',
      latlng: [37.579263, 126.985129],
      subway: 'Line 3',
      nearBy: 'Anguk Station',
      googleMap: 'https://maps.app.goo.gl/X6EYsmpXjkfDBAicA',
    },
    address: '22, Bukchon-ro, Jongno-gu, Seoul',
    latlng: [37.579263, 126.985129],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1448-9032',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:30',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW40,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '간장게장, 양념게장, 게장 비빔밥, 인삼 갈비찜',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F29abf3b6-7f97-4f53-bd09-ee135a7265f8?alt=media&token=d1224816-19a6-40d7-8eab-a7b7402b9cc6',
        name: '간장게장',
        subheader: 'Korean Soy Sauce Raw Crab',
        description:
          'A traditional Korean dish made with fresh crab marinated in a savory soy sauce, resulting in tender, flavorful meat that can be enjoyed with rice or as a side dish.',
        price: 'KRW59,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F331a9977-c935-44e9-b065-a6dbcd1cdc24?alt=media&token=1a6a3230-4d21-4c3d-b7eb-9e7c31107e90',
        name: '양념게장',
        subheader: 'Korean Spicy Gochujang Sauce Raw Crab',
        description:
          'A Korean dish featuring fresh crab marinated in a spicy and sweet sauce, creating a bold and flavorful experience that pairs perfectly with rice.',
        price: 'KRW42,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F056720f6-46a0-4674-a2f4-3e983d9a4454?alt=media&token=19ca4801-73f0-40f3-ba79-008aabf6ffb5',
        name: '게장 비빔밥',
        subheader: 'Korean Marinated Raw Crab Bibimbap',
        description:
          'A vibrant Korean dish that combines steamed rice topped with marinated crab, fresh vegetables, and a spicy gochujang sauce, creating a delightful mix of flavors and textures.',
        price: 'KRW37,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea2f5b23-9119-4fd0-8506-93702504b102?alt=media&token=eb68c1e8-9295-4e4c-a6ef-dbdb0ec49e5f',
        name: '인삼 갈비찜',
        subheader: 'Korean Braised Beef Short Ribs',
        description:
          'A flavorful Korean dish featuring tender braised beef short ribs infused with ginseng, providing a rich and aromatic taste that highlights the unique health benefits of the herb.',
        price: 'KRW40,000',
      },
    ],
    html: '<h1>Keun Kiwa Jip 큰기와집</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Nestled in the heart of the city, 큰기와집 (Kkeun Kiwa Jip) is a must-visit for seafood lovers, celebrated for its </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Michelin-starred</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> raw crab dishes, especially the ganjang gejang (soy sauce marinated crab). The elegant ambiance enhances the experience, while the fresh, succulent crabs marinated to perfection showcase the restaurant\'s commitment to quality. </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">The restaurant uses seasonal ingredients and traditional techniques, skilled chefs create visually stunning dishes that reflect Korea\'s culinary heritage. Attentive staff provide exceptional service, making every meal memorable. Whether you’re a seafood aficionado or seeking a unique dining experience, 큰기와집 promises an unforgettable culinary adventure.</span></p><p><br></p><p><strong>Location:</strong> Approximately 178 meters from Exit 2 of Anguk Station. </p>',
    description:
      'A Michelin one-star gem, 큰기와집 specializes in soy sauce marinated crab, offering a refined dining experience with fresh',
    createdAt: '2024-10-17T02:39:31.103Z',
    updatedAt: '2024-10-17T02:39:31.103Z',
  },
  'taste-the-tradition-of-bossam-at-jeongdabeun-bossam': {
    id: 'taste-the-tradition-of-bossam-at-jeongdabeun-bossam',
    slug: 'taste-the-tradition-of-bossam-at-jeongdabeun-bossam',
    url: '/discovery/place/taste-the-tradition-of-bossam-at-jeongdabeun-bossam',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbb3b0752-d763-4aa5-91de-935a6f20d7d1?alt=media&token=af2242a4-59ba-4bcb-b680-697e86822cad',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd1b5b3ed-f1ac-4329-a68e-0f1abfd31d1c?alt=media&token=6f496021-23eb-4a77-9206-2225dfdb6816',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc5be3044-6b2b-48ba-bcbe-f1da446ebd2c?alt=media&token=59b76336-427c-4f13-899b-b6ee92580279',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb0cf2dac-b242-49f1-84b4-f762b5073a10?alt=media&token=d7c08381-c10a-4857-b2fc-9b880ffb63e3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F58d30413-603b-4172-853a-27d34a7c4b64?alt=media&token=6a7b51bd-259b-4aa9-b793-b87b376abae3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faee55503-c9e4-4879-9d1d-bd3c0e788f65?alt=media&token=2d384083-7119-415e-95ab-28fab960f949',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F50c9e1df-c162-408e-80c0-5195f11aca9e?alt=media&token=cc97163f-9682-4e63-9519-c1313fcee757',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F855ef2da-d7ff-409b-a218-a9e3a18252a0?alt=media&token=37e0393a-ec95-4fa0-bf6c-22929e527381',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F33d118b8-6872-4830-95f0-663c717ec879?alt=media&token=e1d55325-683e-40e3-b54a-4a4212551533',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2c5d6822-fc95-4d91-969f-079fe4f6f18b?alt=media&token=68cf9515-a130-44ac-bf7e-e5fb65e33b17',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F59ee87e2-f9d9-4da4-80b9-bffa7eb4bb55?alt=media&token=60fc0a54-8216-4ad3-9e69-4a1edec1484e',
    ],
    name: 'Jungdamun Bossam',
    priceLevel: 4,
    tags: ['Bossa', 'SteamedPork'],
    location: {
      address: '33-9, Gyedong-gil, Jongno-gu, Seoul',
      area: 'Bukchon Hanok Village',
      latlng: [37.578946, 126.986176],
      subway: 'Line 3',
      nearBy: 'Anguk Station',
      googleMap: 'https://maps.app.goo.gl/9zNbRggmBiLdEvgr7',
    },
    address: '33-9, Gyedong-gil, Jongno-gu, Seoul',
    latlng: [37.578946, 126.986176],
    information: [
      {
        label: 'Phone Number',
        value: '02-763-8401',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '보쌈, 회소쌈, 문어보쌈, 오리보쌈',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F33d118b8-6872-4830-95f0-663c717ec879?alt=media&token=e1d55325-683e-40e3-b54a-4a4212551533',
        name: '보쌈',
        subheader: 'Steamed Pork',
        description:
          'A traditional Korean dish consisting of boiled pork, served with various side dishes and wrapped in lettuce or perilla leaves.',
        price: 'KRW32,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F855ef2da-d7ff-409b-a218-a9e3a18252a0?alt=media&token=37e0393a-ec95-4fa0-bf6c-22929e527381',
        name: '회소쌈',
        subheader: 'Steamed Pork and Raw ',
        description:
          'A Korean dish that features fresh raw fish, typically sashimi-grade, wrapped in lettuce or perilla leaves.',
        price: 'KRW40,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2c5d6822-fc95-4d91-969f-079fe4f6f18b?alt=media&token=68cf9515-a130-44ac-bf7e-e5fb65e33b17',
        name: '문어보쌈',
        subheader: 'Steamed Octopus',
        description:
          'A Korean dish that features boiled octopus served similarly to traditional bossam.',
        price: 'KRW50,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F59ee87e2-f9d9-4da4-80b9-bffa7eb4bb55?alt=media&token=60fc0a54-8216-4ad3-9e69-4a1edec1484e',
        name: '오리보쌈',
        subheader: 'Steaned Duck',
        description:
          'A Korean dish that features boiled or steamed duck served in a style similar to traditional bossam.',
        price: 'KRW32,000',
      },
    ],
    html: '<h1>Jungdamun Bossam 정답은 보쌈</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">정답은 보쌈 (Jeongdabeun Bossam) is a restaurant known for its mouthwatering bossam, a traditional Korean dish of steamed pork belly served with various sides. Located in a vibrant area, this spot has gained popularity for its tender, flavorful pork that melts in your mouth. </span></p><p><br></p><p><strong>Highlight: </strong><span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">The pork is typically accompanied by fresh napa cabbage leaves, garlic, and ssamjang (a savory dipping sauce), allowing diners to create their own wraps. Whether you’re a bossam enthusiast or trying it for the first time, 정답은 보쌈 promises a delightful culinary experience that showcases the best of Korean comfort food!</span></p><p><br></p><p><strong>Location: </strong>Approximately 268 meters from Exit 3 of Anguk Station.</p>',
    description:
      'Specializes in traditional bossam, featuring tender steamed pork belly served with fresh sides for an authentic Korean dining experience.',
    createdAt: '2024-10-17T04:43:04.864Z',
    updatedAt: '2024-10-17T04:43:04.864Z',
  },
  'taste-the-mastery-of-anams-pork-rice-soup': {
    id: 'taste-the-mastery-of-anams-pork-rice-soup',
    slug: 'taste-the-mastery-of-anams-pork-rice-soup',
    url: '/discovery/place/taste-the-mastery-of-anams-pork-rice-soup',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8da8fa82-5404-41e9-bf96-3b3dfa3bcbfe?alt=media&token=cdfefdd2-ab63-4383-b5f5-2266b2552624',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F03a3d22f-d5cc-483d-863e-901545563382?alt=media&token=6dba9c40-e58a-41e7-998a-9941881d3647',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c6125ef-601c-4529-8e58-17f4bcb53c09?alt=media&token=b97acce6-75ce-41bd-883d-d8243f317d50',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffe5f0f61-2665-4313-be52-72b702e866d1?alt=media&token=89053620-25b4-4cb3-8d0b-198587520b8f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa93b4c2b-1bec-4cbf-8d8a-b9e60e6f768e?alt=media&token=50cd4748-b7ee-4218-9186-613f3513de2e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faa53963f-62b5-414d-890c-3164774a6162?alt=media&token=3f9537bb-8622-4d90-9861-a997355f283d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F51d049dc-fb16-4161-a36e-a8a6792be8bb?alt=media&token=2e88f433-5bed-423f-bcc2-396219674de2',
    ],
    name: 'Anam',
    priceLevel: 2,
    tags: ['KoreanPorkRiceSoup'],
    location: {
      address: '10, Bukchon-ro 5-gil, Jongno-gu, Seoul',
      area: 'Anguk',
      latlng: [37.581109, 126.982609],
      subway: 'Line 3',
      nearBy: 'Anguk Station',
      googleMap: 'https://maps.app.goo.gl/1F8141pBKSnGePNg7',
    },
    address: '10, Bukchon-ro 5-gil, Jongno-gu, Seoul',
    latlng: [37.581109, 126.982609],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1463-8189',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:00',
      },
      {
        label: 'Day Off',
        value: 'Monday',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '돼지국밥 ',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F03a3d22f-d5cc-483d-863e-901545563382?alt=media&token=6dba9c40-e58a-41e7-998a-9941881d3647',
        name: '돼지국밥 Gukbap',
        subheader: 'Korean Pork Rice Soup',
        description:
          'A hearty Korean dish featuring tender pork in a rich, flavorful broth with rice, garnished with green onions and served with side dishes like kimchi.',
        price: 'KRW12,000',
      },
    ],
    html: '<h1>Anam 안암</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Experience the simplicity and joy of </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Anam</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, Pork Rice Soup (돼지국), where every bowl is packed with delicious flavors, crafted from the freshest ingredients. This restaurant delights the senses with its star attraction: exquisite green chili oil, a harmonious blend of Qingyang peppers and kale that adds gentle heat and a refreshing finish to every dish. </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">The pork is a true masterpiece, featuring succulent ribs and tender slices slow-cooked to retain their rich flavor and melt-in-your-mouth texture. The broth is extraordinary—clear and light, capturing the essence of meat without a hint of greasiness for a pure and satisfying experience. Complementing it all is the unparalleled freshness of the ingredients; from vibrant cilantro to tangy pickled vegetables and crisp mixed greens, each bite feels like a harvest straight from the field, allowing you to savor the true flavors of nature. Dining here is more than just a meal; it’s an unforgettable culinary journey that will linger in your memory.</span></p><p><br></p><p><strong>Location: </strong>Approximately 313 meters from Exit 2 of Anguk Station.</p>',
    description:
      'Anam specializes exclusively in its Pork Rice Soup, featuring succulent slow-cooked pork, a light and flavorful broth, and a unique green chili oil that elevates every bite.',
    createdAt: '2024-10-17T02:17:14.294Z',
    updatedAt: '2024-10-17T02:17:14.294Z',
  },
  'gwanghwamun-rice-soup-taste-the-best-rice-soup-in-town': {
    id: 'gwanghwamun-rice-soup-taste-the-best-rice-soup-in-town',
    slug: 'gwanghwamun-rice-soup-taste-the-best-rice-soup-in-town',
    url: '/discovery/place/gwanghwamun-rice-soup-taste-the-best-rice-soup-in-town',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd360f0be-5dba-4dac-b368-15410421cd02?alt=media&token=b1d49621-d463-415f-b743-9d77292a61d1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F75181562-75f5-4318-b584-60282e12aa2a?alt=media&token=c9b74d64-94a8-4687-a503-687bd099824f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4cb37794-00f8-4058-9f81-4a16d22aab57?alt=media&token=9162b2c8-59f4-4f98-b242-59cc1ba04b95',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff59aec8d-4c48-4d5e-a7c3-f4207e77fbd8?alt=media&token=f4c81834-78a3-4162-96c1-766f78589086',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F45cb242d-85e0-4783-aebe-186f6f2fa769?alt=media&token=930ac874-dcb2-41a8-9b2a-4042dc536350',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F10fc4400-ff59-42dd-a225-4cec64cd2df5?alt=media&token=d2ed9151-7fa9-40e2-98b1-670b1083ad2e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F015b52ae-a463-49c7-be6a-ee48bdf3c294?alt=media&token=b1b5d586-ad98-43f5-af4a-31104d7fbfec',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fceaebe34-63c3-46ff-9d37-57c0ce9d5309?alt=media&token=5504d74d-ede9-40d6-b812-7b9e647c6aae',
    ],
    name: 'Gwanghwamun Rice Soup',
    priceLevel: 1,
    tags: ['KoreanRiceSoup', 'PorkRiceSoup'],
    location: {
      address: '53, Sejong-daero 21-gil, Jung-gu, Seoul',
      area: 'Gwanghwamun',
      latlng: [37.569237, 126.975378],
      subway: 'Line 5',
      nearBy: 'Gwanghwamun Station',
      googleMap: 'https://maps.app.goo.gl/VFwf3ttpTm2T8AVD8',
    },
    address: '53, Sejong-daero 21-gil, Jung-gu, Seoul',
    latlng: [37.569237, 126.975378],
    information: [
      {
        label: 'Phone Number',
        value: '02-738-5688',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 21:40',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: '14:30 - 17:30',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '돼지국밥, 돼지수육, 저염명란오이무침, 피순대',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F45cb242d-85e0-4783-aebe-186f6f2fa769?alt=media&token=930ac874-dcb2-41a8-9b2a-4042dc536350',
        name: '돼지국밥',
        subheader: 'Sliced Pork Rice Soup',
        description:
          'A hearty Korean dish featuring tender pork in a rich, flavorful broth with rice, garnished with green onions and served with side dishes like kimchi.',
        price: 'KRW10,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fceaebe34-63c3-46ff-9d37-57c0ce9d5309?alt=media&token=5504d74d-ede9-40d6-b812-7b9e647c6aae',
        name: '저염명란오이무침',
        subheader: 'Cucumbers, Cod Roe',
        description:
          'A refreshing Korean side dish made with crunchy cucumbers and low-sodium cod roe, lightly seasoned for a savory and tangy taste.',
        price: 'KRW12,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff59aec8d-4c48-4d5e-a7c3-f4207e77fbd8?alt=media&token=f4c81834-78a3-4162-96c1-766f78589086',
        name: '피순대',
        subheader: 'Stuffed Intestine',
        description:
          "A traditional Korean dish made from pig intestines stuffed with a mixture of pig's blood, rice, and various spices, creating a rich and savory flavor.",
        price: 'KRW17,000',
      },
    ],
    html: '<h1><strong>Gwanghwamun Rice Soup 광화문국밥</strong></h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Korea is full of hidden </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Michelin-recommended spots</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, and </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Gwanghwamun Soup Rice</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is a true gem tucked away in an alley! Even though it opened less than 10 years, it has already snagged </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Michelin recommendations for six years in a row</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. The clean white sign reflects the quality of the tasty dishes inside. </span></p><p><br></p><p><strong>Highlight: </strong><span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Their pork soup rice is made with top-notch black pork loin and shoulder, creating a broth that\'s refreshing and packed with rich flavor and a hint of aroma. The soup and rice are served separately to keep the rice fresh and delicious. Dining here isn’t just a meal; it’s a flavorful experience you won\'t forget!</span></p><p><br></p><p><strong>Location: </strong>Approximately 174 meters from Exit 6 of Gwanghwamun Station.</p><p><br></p>',
    description:
      'Michelin-recommended Gwanghwamun Soup Rice serves premium black pork in a refreshing broth with fresh rice.',
    createdAt: '2024-10-17T02:05:37.721Z',
    updatedAt: '2024-10-17T02:05:37.721Z',
  },

  //강남
  'sinsajeon-honeycomb-infused-korean-pancakes': {
    id: 'sinsajeon-honeycomb-infused-korean-pancakes',
    slug: 'sinsajeon-honeycomb-infused-korean-pancakes',
    url: '/discovery/place/sinsajeon-honeycomb-infused-korean-pancakes',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7ce53326-e589-4bea-9a55-bc8547e4149a?alt=media&token=4d16df3b-2040-4d12-b5f0-5b3fd32a9a08',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1465795c-8d64-4030-8972-a65d5c460d55?alt=media&token=471a2416-2e6d-4648-bd3a-7918c92bc320',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F67b70a65-efde-4532-84ba-6f27db016e38?alt=media&token=b5248990-3d3c-48ce-ad6d-e68088ea8ccf',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb9bbd1c6-7209-4cc2-8ae8-dbc401c2654d?alt=media&token=77b21ad7-ca97-497d-8d59-728441a1b507',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe82617a8-7397-48c3-b0fc-b026f8f74853?alt=media&token=9996114a-e86b-431d-9ffb-e6e42e7f747e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb009045b-04fa-4ca4-ac52-8369b370c436?alt=media&token=cdf05dbc-619b-471c-8f87-192dbe6736dc',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F62b4d218-7e1b-42d2-b1c8-05205f20ccdb?alt=media&token=8ec4bc35-2ee7-434b-8962-9e108d42ccc7',
    ],
    name: 'Sinsajeon Korean Pancake ',
    priceLevel: 4,
    tags: ['KoreanPancakes', 'HoneyComb', 'KoreanRiceAlcohol'],
    location: {
      address: '18, Dosan-daero 11-gil, Gangnam-gu, Seoul',
      area: 'Sinsa',
      latlng: [37.518892, 127.022781],
      subway: 'Line 3, SINBUNDANG Line',
      nearBy: 'Sinsa Station',
      googleMap: 'https://maps.app.goo.gl/8aw7JSvtKzqzQTqT8',
    },
    address: '18, Dosan-daero 11-gil, Gangnam-gu, Seoul',
    latlng: [37.518892, 127.022781],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1337-9993',
      },
      {
        label: 'Business Hours',
        value: '10:30 - 01:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '벌집꿀, 모듬전, 치즈감자전',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7ce53326-e589-4bea-9a55-bc8547e4149a?alt=media&token=4d16df3b-2040-4d12-b5f0-5b3fd32a9a08',
        name: '벌집꿀',
        subheader: 'Honey Comb',
        description:
          'A traditional Korean rice wine infused with honeycomb, offering a naturally sweet and aromatic flavor, complemented by its creamy texture and slightly fizzy effervescence',
        price: 'KRW11,000++',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F62b4d218-7e1b-42d2-b1c8-05205f20ccdb?alt=media&token=8ec4bc35-2ee7-434b-8962-9e108d42ccc7',
        name: '모듬전',
        subheader: 'Platter of Korean Pancakes',
        description:
          'A Korean platter of assorted savory pancakes made with a variety of ingredients like vegetables, seafood, and meat, pan-fried to a crispy golden-brown and served with a soy-based dipping sauce.',
        price: 'KRW43,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb009045b-04fa-4ca4-ac52-8369b370c436?alt=media&token=cdf05dbc-619b-471c-8f87-192dbe6736dc',
        name: '치즈감자전',
        subheader: 'Cheesy Potato Korean Pancakes',
        description:
          'A Korean potato pancake infused with melted cheese, creating a deliciously gooey and savory treat, pan-fried until crispy and golden Korean potato pancake infused with melted cheese, creating a deliciously gooey and savory treat, pan-fried until crispy and golden',
        price: 'KRW30,000',
      },
    ],
    html: '<h1>Sinsajeon Korean Pancake 신사전 </h1><p><br></p><p><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">If you’re looking for an authentic experience of Korean drinking culture, you’ve come to the right place. </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Sinsa Jeon Korean Pancakes</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> is located in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Sinsa</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, Seoul. If you ask what pairs perfectly with traditional Korean rice alcohol, the answer is definitely </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Korean pancakes</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">! </span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">This place specializes in offering the perfect pancakes, with a variety to choose from, including potato cheese jeon, 모듬전 (assorted pancakes), seafood chives jeon, 육전 (beef pancakes), and more for you to discover. Moreover, their rice alcohol is special as well; they add honeycomb, elevating the already delicious drink to a whole new level!</span></p><p><br></p><p><strong>Location:</strong> Approximately 307 meters from Exit 8 of Sinsa Station.</p><p><br></p><p><strong>Note:</strong> Reservations are only accepted via Naver Smart Place to avoid wait times. </p>',
    description:
      'Specializing in a tempting array of authentic Korean pancakes served alongside honeycomb-infused rice alcohol',
    createdAt: '2024-10-17T01:45:55.404Z',
    updatedAt: '2024-10-17T01:45:55.404Z',
  },
  'sinsa-man-eel-savor-the-flavor-of-korean-tradition': {
    id: 'sinsa-man-eel-savor-the-flavor-of-korean-tradition',
    slug: 'sinsa-man-eel-savor-the-flavor-of-korean-tradition',
    url: '/discovery/place/sinsa-man-eel-savor-the-flavor-of-korean-tradition',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5bc7b3e1-f95e-4fc6-bafb-0367c7fe6f07?alt=media&token=4e51d85f-c2e8-4056-a95d-30b3583a3849',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2b9edd69-b1a9-4545-98ed-02e92b1552d2?alt=media&token=d4865231-e425-4441-8d25-ec2664d02d0f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F49221f4c-1d6b-4c2f-af79-279fa4caa34a?alt=media&token=d9cd33c8-950f-45de-9c10-4f5ee709a4a0',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F930f9eb9-1714-486b-b86c-fa1eca3b0236?alt=media&token=3a08eaae-cecc-40ea-86b7-186f6256de6e',
    ],
    name: 'Sinsa Man Eel',
    priceLevel: 4,
    tags: ['Eel', 'Korean'],
    location: {
      address: '10, Dosan-daero 1-gil, Gangnam-gu, Seoul',
      area: 'Sinsa',
      latlng: [37.517548, 127.020132],
      subway: 'Line 3, SINBUNDANG LINE',
      nearBy: 'Sinsa Station',
      googleMap: 'https://maps.app.goo.gl/zvk9GunQgY9Lneuj6',
    },
    address: '10, Dosan-daero 1-gil, Gangnam-gu, Seoul',
    latlng: [37.517548, 127.020132],
    information: [
      {
        label: 'Phone Number',
        value: '0507-1355-9302',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW30,000 ~ KRW60,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '장어덮밥',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5bc7b3e1-f95e-4fc6-bafb-0367c7fe6f07?alt=media&token=4e51d85f-c2e8-4056-a95d-30b3583a3849',
        name: '장어덮밥',
        subheader: 'Eel',
        description:
          'a Korean dish featuring grilled eel glazed with a savory-sweet sauce served over a bed of warm, fluffy rice.',
        price: 'KRW42,000',
      },
    ],
    html: '<h1 class="ql-align-justify">Sinsa Man Eel 산사만장어</h1><p class="ql-align-justify"><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">If you’re a fan of eel, Sinsa Man Eel (신사만장어) is the place to be! This popular restaurant is renowned for its mouthwatering grilled eel dishes, or "장어," which are not only rich in flavor but also packed with health benefits. </span></p><p><br></p><p><strong>Highlight:</strong> The skilled chef prepares tender, juicy eel perfectly grilled and served alongside fluffy rice and a selection of dipping sauces that enhance every bite. The cozy, inviting atmosphere creates an ideal setting to relax and enjoy an authentic Korean meal. Whether you’re a seafood lover or eager to try something new, 신사만장어 promises a culinary adventure you won’t want to miss!</p><p><br></p><p><strong>Location:</strong> Approximately 112 meters from Exit 8 of Sinsa Station.</p>',
    description:
      'Not a Japanese-style eel rice bowl, but a reinterpretation of traditional Korean eel dishes. At 신사만, they strive to ensure their guests are fully satisfied, working hard to provide complete fulfillment.',
    createdAt: '2024-10-16T23:34:06.411Z',
    updatedAt: '2024-10-16T23:34:06.411Z',
  },
  'gangnam-noodles-cool-noodles-savory-ribs': {
    id: 'gangnam-noodles-cool-noodles-savory-ribs',
    slug: 'gangnam-noodles-cool-noodles-savory-ribs',
    url: '/discovery/place/gangnam-noodles-cool-noodles-savory-ribs',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd04a5bb5-41db-4cc2-b6cb-77b7867fd3de?alt=media&token=96a3782c-ba3c-4096-b65f-885a2fd376a3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4223ce5a-94f9-4786-89aa-5c70588f00fe?alt=media&token=8127952f-fd3a-4f63-9fdb-f62b0090df63',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbe6b3fed-316b-4c73-8bc0-eb15ba35cb4a?alt=media&token=08a72cff-f779-4110-b5cd-161fe1de18a7',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F97388e21-504e-4d41-a271-6f6c3578e8e2?alt=media&token=7d733bb4-94c9-4868-a73d-dd1d5fc3b2a3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb9af169d-47ec-4a40-a629-807d28e85b5f?alt=media&token=5a70f54d-8e13-4bf0-904f-484a97a47748',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5d5874b3-b304-4bf3-a629-783ee8b59f07?alt=media&token=2db81096-cb7d-4cdc-97a3-77870e76232a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F36756f3f-a550-4e12-93d4-96985277dfdc?alt=media&token=b0283b4c-3be6-427f-8384-a00a5c0f43ec',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F60ae4ed2-2f27-4041-93f7-ed5715040c7f?alt=media&token=ae3bae72-8db6-4307-9b5f-a4f27ab2a965',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffcaf62f5-b958-4a27-9b4d-2ef011ae7588?alt=media&token=744f6433-6d22-466f-a8ba-783c64d5f09d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F998c7122-ac7b-4359-91d9-4853eea14d8e?alt=media&token=d532a5c0-8cc1-4d4c-b510-ad2d0e805003',
    ],
    name: 'Gangnam Noodles ',
    priceLevel: 3,
    tags: ['Korean', 'BeefShortRibs'],
    location: {
      address: '34, Nonhyeon-ro 152-gil, Gangnam-gu, Seoul',
      area: 'Apgujeong, Gangnam ',
      latlng: [37.526429, 127.031608],
      subway: 'Line 3',
      nearBy: 'Apgujeong Station',
      googleMap: 'https://maps.app.goo.gl/RyRikWXhQHhxjtif6',
    },
    address: '34, Nonhyeon-ro 152-gil, Gangnam-gu, Seoul',
    latlng: [37.526429, 127.031608],
    information: [
      {
        label: 'Phone Number',
        value: '02-3446-5539',
      },
      {
        label: 'Business Hours',
        value: '10:30 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '갈비찜, 회냉면, 갈비탕',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbe6b3fed-316b-4c73-8bc0-eb15ba35cb4a?alt=media&token=08a72cff-f779-4110-b5cd-161fe1de18a7',
        name: '갈비찜 ',
        subheader: 'Braised Beef Short Ribs',
        description:
          'Galbijjim is a Korean dish of braised beef short ribs, simmered with soy sauce, garlic, and various vegetables, creating tender, flavorful meat often served with rice.',
        price: 'KRW52,000 ~ KRW82,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd04a5bb5-41db-4cc2-b6cb-77b7867fd3de?alt=media&token=96a3782c-ba3c-4096-b65f-885a2fd376a3',
        name: '회냉면 ',
        subheader: 'Cold Noodles ',
        description:
          'A Korean cold noodle dish served with thinly sliced raw fish, typically accompanied by a tangy, chilled broth and various toppings like cucumber, radish, and sesame seeds.',
        price: 'KRW13,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F97388e21-504e-4d41-a271-6f6c3578e8e2?alt=media&token=7d733bb4-94c9-4868-a73d-dd1d5fc3b2a3',
        name: '갈비탕',
        subheader: 'Beef Short Ribes with Soup',
        description:
          'A Korean soup made with beef short ribs, simmered for hours with radish, garlic, and green onions, resulting in a rich, savory broth that is often enjoyed with rice.',
        price: 'KRW16,000',
      },
    ],
    html: '<h1>Gangnam Noodles 강남면옥 </h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Craving cold noodles and meat? I know just the place for you! Gangnam Noodles is located in Gangnam, Seoul. This spot is famous for its delicious, chewy cold noodles served in a refreshing broth. </span></p><p><br></p><p><strong>Highlight:</strong> O<span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">ne of the standout menu items is their braised ribs (갈비찜). This dish features tender, succulent beef short ribs slowly cooked in a rich, savory sauce made from soy sauce, garlic, and a hint of sweetness. I assure you that you will regret not trying out this place while you’re in Korea!</span></p><p><br></p><p><strong>Location:</strong> Approximately 654 meters from Exit 3 of Apgujeong Station. </p>',
    description: 'Specializes in Galbijjim and Hamhung cold noodle. ',
    createdAt: '2024-10-16T07:45:48.561Z',
    updatedAt: '2024-10-16T07:45:48.561Z',
  },
  'one-degree-north-authentic-singaporean-flavors-in-gangnam': {
    id: 'one-degree-north-authentic-singaporean-flavors-in-gangnam',
    slug: 'one-degree-north-authentic-singaporean-flavors-in-gangnam',
    url: '/discovery/place/one-degree-north-authentic-singaporean-flavors-in-gangnam',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2705b633-b807-4893-8519-4d83d199d13b?alt=media&token=9f893646-9d26-466e-9c12-67564e3d2511',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F514ccb01-c61a-4fda-a626-52467ed93808?alt=media&token=4e2b4642-2df9-4e43-b85a-003e66831210',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F06eadc40-67da-4356-ac52-fefc26686c5d?alt=media&token=20b72856-4f7f-4183-b968-0ba25da55cd4',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3369eb6e-5e2a-4af3-8dc8-ade1d4a6f3a4?alt=media&token=eadb519c-0277-46ec-8fdc-27dcd7973648',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7f67e527-8cb4-442d-afe6-91a6f2313ee7?alt=media&token=9b2d225d-7235-4ab8-96ca-0f89571b24a3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe6398b68-b821-4986-8736-cb7139f413f4?alt=media&token=d684a360-9d1a-427c-9e6f-7736003c1d16',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F99481e38-a461-4d80-a38f-a21ffffee85b?alt=media&token=b2d61f0a-24d4-44cb-819b-709f8dc73223',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fca06cc96-49f0-4115-8df2-e3aaf5dd08a8?alt=media&token=6b12dc16-86a8-4864-8813-ab8b5e5d24e8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F22564178-3d6c-4284-9f60-ab70898adca7?alt=media&token=fcd6d82d-750f-418f-b014-61a1824fc50f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F351062f3-1a2a-4e80-967c-7c13a1a03b59?alt=media&token=4da38be3-5b13-4356-a632-4062efff8fe5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F68b28f6c-52ee-42a7-b518-602739b80bde?alt=media&token=0445987e-36c3-4994-9f12-5888bfb8a6eb',
    ],
    name: 'One Degree North',
    priceLevel: 2,
    tags: ['Singaporean', 'Chicken', 'Hainanese'],
    location: {
      address: '8, Hakdong-ro 43-gil, Gangnam-gu, Seoul',
      area: 'Gangnam',
      latlng: [37.516911, 127.037444],
      subway: 'Line 7, SUIN-BUNDANG LINE',
      nearBy: 'Gangnam-gu Office Station',
      googleMap: 'https://maps.app.goo.gl/bp1Sv8nUkHgGpx52A',
    },
    address: '8, Hakdong-ro 43-gil, Gangnam-gu, Seoul',
    latlng: [37.516911, 127.037444],
    information: [
      {
        label: 'Phone Number',
        value: '070-4333-8884',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: '15:00 - 17:30',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '싱가포르 치킨라이스, 로스트 포크 라이스, 광둥 챠슈 라이스, 광둥 오리 라이스 ',
      },
    ],
    recommendations: [
      {
        category: 'Singaporean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fca06cc96-49f0-4115-8df2-e3aaf5dd08a8?alt=media&token=6b12dc16-86a8-4864-8813-ab8b5e5d24e8',
        name: '싱가포르 치킨라이스',
        subheader: 'Chicken Rice',
        description:
          'A perfect combination of tender chicken, slow-cooked in chicken broth, and rice cooked in the same flavorful broth.',
        price: 'KRW9,800',
      },
      {
        category: 'Singaporean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F68b28f6c-52ee-42a7-b518-602739b80bde?alt=media&token=0445987e-36c3-4994-9f12-5888bfb8a6eb',
        name: '로스트 포크 라이스',
        subheader: 'Roasted Pork Rice',
        description:
          "Grilled pork belly with a crispy skin and juicy meat, coated in One Degree North's secret seasoning and finished in a high-temperature oven.",
        price: 'KRW12,800',
      },
      {
        category: 'Singaporean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F22564178-3d6c-4284-9f60-ab70898adca7?alt=media&token=fcd6d82d-750f-418f-b014-61a1824fc50f',
        name: '광둥 챠슈 라이스',
        subheader: 'Charsiew Rice',
        description:
          'Pork belly marinated for 24 hours, coated in a special sauce, and grilled over charcoal for a rich flavor.',
        price: 'KRW12,800',
      },
      {
        category: 'Singaporean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F351062f3-1a2a-4e80-967c-7c13a1a03b59?alt=media&token=4da38be3-5b13-4356-a632-4062efff8fe5',
        name: '광둥 오리 라이스',
        subheader: 'Roasted Duck Rice',
        description:
          'Duck roasted in a clay oven, carefully marinated for half a day with a special sauce and rare herbs for a rich flavor.',
        price: 'KRW15,800',
      },
    ],
    html: '<h1>One Degree North 원 디그리 노스 </h1><p><br></p><p><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">One Degree North</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">, a proud recipient of a Michelin Guide selection, is located in the vibrant and exclusive district of </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Gangnam</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">. This Singaporean restaurant specializes in iconic dishes like Hainanese chicken rice, roast pork rice, char-siew rice, and roasted duck rice. Whether you\'re a longtime fan of Singaporean cuisine or trying it for the first time, One Degree North promises an unforgettable dining adventure.</span></p><p><br></p><p><strong>Highlight:</strong> <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">Each dish is meticulously prepared, capturing the true essence of Singaporean flavors that will transport you to the bustling streets of the city with just one bite. The welcoming atmosphere and elegant presentation make it an ideal spot for food enthusiasts seeking a genuine culinary experience. </span></p><p><br></p><p><strong>Location:</strong> Approximately 346 meters from Exit 3 of Gangnam-gu Office Station.</p><p><br></p><p><br></p>',
    description:
      'Specializes in Singaporean signature dishes, the most authentic taste of Singapore in Seoul.',
    createdAt: '2024-10-16T07:27:39.433Z',
    updatedAt: '2024-10-16T07:27:39.433Z',
  },
  'ttam-ttam-pho-with-a-twist-flavor-in-every-bite': {
    id: 'ttam-ttam-pho-with-a-twist-flavor-in-every-bite',
    slug: 'ttam-ttam-pho-with-a-twist-flavor-in-every-bite',
    url: '/discovery/place/ttam-ttam-pho-with-a-twist-flavor-in-every-bite',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe0a157c7-7929-4572-bb64-32c45f0fb75c?alt=media&token=878fa5d4-5efd-46e2-8f7c-994f89f9a0dc',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F38b297ec-eaea-4d52-abb8-bc0f187591b2?alt=media&token=eae90623-2308-4c71-9703-779b660da282',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1d47706a-1335-4303-9a36-c6f16c0860b9?alt=media&token=e1d9c285-381f-490e-be2e-2c9be91edce5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe86b2365-fb86-4bc3-aba3-fd3a4bad6f57?alt=media&token=3e029595-4bd4-42ca-a765-ed23316f1927',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F404d30e7-f090-4134-9124-53d8429d197e?alt=media&token=ea2f6323-5b59-4ed7-8539-5a6e7d91ebd2',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe491589f-be8d-4a73-91e6-1676de3a16bd?alt=media&token=b9e62954-1a19-4f07-9c8e-82d653e3f00e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5396bd82-1ccf-43fd-b707-bf2a2079851f?alt=media&token=e0ac89de-78e9-4772-aaf5-053937a931c3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c3acb31-3531-4592-b0fd-a61ec9ef8d38?alt=media&token=910b73f7-f5a1-4760-8895-926313c3c3c7',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8d615325-fbee-4525-bdf4-54203e99d9f7?alt=media&token=3f5e1f1a-4c7b-4631-904b-944ca21af80e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F63f676a3-08e8-479c-b032-e20c47d0d6de?alt=media&token=ebfa99cd-fcd2-4c87-a5c3-391b09ecd9ed',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2656bdf1-b4fb-4050-9367-c54d75ccfaf7?alt=media&token=85b8924e-6cb8-4b26-bfe5-3f7bfa6d563d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5cc3a72f-f1b4-4c39-af4a-ac631298d52a?alt=media&token=dc8e8a1c-86c9-485c-8d79-ecad55e19fb0',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb5ab829e-91d3-4acb-b991-69218acb26d0?alt=media&token=06269343-63a2-4476-a926-1ce962fb5869',
    ],
    name: 'Ttam Ttam',
    priceLevel: 2,
    tags: ['Pho', 'Vietnamese'],
    location: {
      address: '12-5, Gangnam-daero 98-gil, Gangnam-gu, Seoul',
      area: 'Gangnam',
      latlng: [37.50375, 127.02937],
      subway: 'Line 2, SINBUNDANG LINE',
      nearBy: 'Gangnam Station',
      googleMap: 'https://maps.app.goo.gl/V4uYdSzfYmGH5T6o7',
    },
    address: '12-5, Gangnam-daero 98-gil, Gangnam-gu, Seoul',
    latlng: [37.50375, 127.02937],
    information: [
      {
        label: 'Phone Number',
        value: '02-554-8892',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 22:00',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '프리미엄 보양 싸국수, 매운 소곱창 쌀국수, 양지쌀국수, 바쿠테 보양쌀국수',
      },
    ],
    recommendations: [
      {
        category: 'Vietnamese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb5ab829e-91d3-4acb-b991-69218acb26d0?alt=media&token=06269343-63a2-4476-a926-1ce962fb5869',
        name: '프리미엄 보양 싸국수',
        subheader: 'Premium Nutritious Pho',
        description: 'Tam Tam Signature Nourishing Pho',
        price: 'KRW17,000',
      },
      {
        category: 'Vietnamese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5cc3a72f-f1b4-4c39-af4a-ac631298d52a?alt=media&token=dc8e8a1c-86c9-485c-8d79-ecad55e19fb0',
        name: '매운 소곱창 쌀국수',
        subheader: 'Spicy Soup Pho ',
        description: 'Tam Tam Signature Spicy Beef Intestine Pho',
        price: 'KRW16,000',
      },
      {
        category: 'Vietnamese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F63f676a3-08e8-479c-b032-e20c47d0d6de?alt=media&token=ebfa99cd-fcd2-4c87-a5c3-391b09ecd9ed',
        name: '양지쌀국수',
        subheader: 'Brisket Pho ',
        description: 'Vietnamese Brisket Pho',
        price: 'KRW12,000',
      },
      {
        category: 'Vietnamese',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2656bdf1-b4fb-4050-9367-c54d75ccfaf7?alt=media&token=85b8924e-6cb8-4b26-bfe5-3f7bfa6d563d',
        name: '바쿠테 보양쌀국수',
        subheader: 'Bak Kut Teh Pho ',
        description: 'Singapore Bak Kut Teh Rib Pho',
        price: 'KRW16,000',
      },
    ],
    html: '<h1>Ttam Ttam 땀땀</h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">A long line of eager diners is a sure sign of something special, and </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Ttam Ttam</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> definitely delivers. This spot in Seoul specializes in </span><strong style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">Vietnamese pho</strong><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);"> but adds a unique twist to cater to local tastes. </span></p><p><br></p><p><strong>Highlight</strong>: <span style="color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">One standout feature is the grilled cow\'s intestines (곱창), which bring a smoky richness that perfectly complements the aromatic broth. You can choose from various options like 양지쌀국수 (brisket pho), 우삼겹 쌀국수 (chuck flap pho), and the Singaporean-style 바쿠테 보양쌀국수. Each bowl is generously packed with tender meat and fresh herbs, making every bite satisfying. The rich, flavorful broth and perfectly chewy noodles elevate the experience, making Ttam Ttam a must-visit for anyone craving a comforting meal that’s sure to keep you coming back for more!</span></p><p><br></p><p><strong>Location</strong>: Approximately 261 meters from Exit 11 of Gangnam Station.</p>',
    description:
      'At Ttam Ttam, pho is made with carefully selected beef and a 24-hour simmered bone broth, based on traditional Vietnamese royal recipes, along with a variety of newly introduced nourishing Vietnamese dishes.',
    createdAt: '2024-10-16T23:17:15.485Z',
    updatedAt: '2024-10-16T23:17:15.485Z',
  },

  //가이드 top 10
  'discover-tradition-in-every-bite-at-gyerim-restaurant': {
    id: 'discover-tradition-in-every-bite-at-gyerim-restaurant',
    slug: 'discover-tradition-in-every-bite-at-gyerim-restaurant',
    url: '/discovery/place/discover-tradition-in-every-bite-at-gyerim-restaurant',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F34aacd70-d2eb-4ecc-a0bb-91d97ceb0363?alt=media&token=05132d99-6461-4353-a91e-b24a6d23ef9e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff3dd0215-44cf-4953-9c3d-a3bc48cb6748?alt=media&token=82312532-29c3-46ba-9b26-c3bfebcea756',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3f21b93f-40b3-44e2-8ec0-0003977efce2?alt=media&token=c0c68060-b180-4214-8e6f-e9f54b6bd8c8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F37bba826-c458-46f8-a7ca-518e0b0d22af?alt=media&token=612deca9-43d7-4d3b-9549-316116f6db1b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc6bb73e8-7fd9-4797-b423-587d01ce5772?alt=media&token=6905cd2b-65ce-4370-b73d-1e4414159995',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc8efea9b-f6d1-47f0-a2ee-04fa20ca4920?alt=media&token=015f334a-5a59-4bfd-aef0-759cb8138dbb',
    ],
    name: 'Gyerim ',
    priceLevel: 2,
    tags: ['Korean', 'SpicyStewedChickenSoup'],
    location: {
      address: '39, Donhwamun-ro 4-gil, Jongno-gu, Seoul',
      area: 'Jongno3(sam)-ga',
      latlng: [37.57138, 126.995104],
      subway: 'Line 1, Line 3, Line 5',
      nearBy: 'Jongno3(sam)-ga Station',
      googleMap: 'https://maps.app.goo.gl/369Tq5k5bsVuiEWU7',
    },
    address: '39, Donhwamun-ro 4-gil, Jongno-gu, Seoul',
    latlng: [37.57138, 126.995104],
    information: [
      {
        label: 'Phone Number',
        value: '02-2263-6658',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21-45',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: '15:30 - 16:30',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '닭도리탕',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F34aacd70-d2eb-4ecc-a0bb-91d97ceb0363?alt=media&token=05132d99-6461-4353-a91e-b24a6d23ef9e',
        name: '닭도리탕 (Big)',
        subheader: 'Stewed Chicken Soup',
        description:
          'A flavorful Korean stew made with chicken, potatoes, and vegetables, simmered in a spicy sauce with gochugaru, garlic, and soy sauce, creating a comforting and hearty meal.',
        price: 'KRW53,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F34aacd70-d2eb-4ecc-a0bb-91d97ceb0363?alt=media&token=05132d99-6461-4353-a91e-b24a6d23ef9e',
        name: '닭도리탕 (Medium)',
        subheader: 'Stewed Chicken Soup',
        description:
          'A flavorful Korean stew made with chicken, potatoes, and vegetables, simmered in a spicy sauce with gochugaru, garlic, and soy sauce, creating a comforting and hearty meal.',
        price: 'KRW40,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F34aacd70-d2eb-4ecc-a0bb-91d97ceb0363?alt=media&token=05132d99-6461-4353-a91e-b24a6d23ef9e',
        name: '닭도리탕 (Small)',
        subheader: 'Stewed Chicken Soup',
        description:
          'A flavorful Korean stew made with chicken, potatoes, and vegetables, simmered in a spicy sauce with gochugaru, garlic, and soy sauce, creating a comforting and hearty meal.',
        price: 'KRW28,000',
      },
    ],
    html: '<h1>Gyerim 계림식당</h1><p><br></p><p class="ql-align-justify">The Jongno area in Seoul boasts many incredible traditional restaurants, and one popular spot locals adore is a <strong>spicy stewed chicken soup</strong> place that has been around for over 50 years, evident in its rich history reflected in the exterior. Serving only one dish—spicy stewed chicken soup, which has earned high praise after being featured on <strong>"Three Great Emperors"</strong> with <strong>Baek Jong-won</strong>—you can choose the portion size based on your dining party, with a small size being perfect for two. </p><p><br></p><p><strong>Highlight:</strong> A standout feature is the generous amount of garlic paste in the soup, enhancing the broth\'s aroma and making you want more, while the chicken is firm and flavorful with a tender texture that’s far from dry. The rice cakes are exceptionally soft and chewy, and the sweet, tasty potatoes make every ingredient delightful. Don’t forget to add some knife-cut noodles at the end; the noodles soaked in the broth create the perfect finishing touch!</p><p><br></p><p><strong>Location:</strong> Approximately 176 meters from Exit 12 of Jongno3(sam)-ga Station</p>',
    description:
      'Gyerim Restaurant, a cherished Jongno spot for over 50 years, specializes in spicy stewed chicken soup with tender chicken, generous garlic paste, and soft rice cakes.',
    createdAt: '2024-10-17T06:43:51.487Z',
    updatedAt: '2024-10-17T06:43:51.487Z',
  },
  'daeryeon-house-sip-slurp-savor': {
    id: 'daeryeon-house-sip-slurp-savor',
    slug: 'daeryeon-house-sip-slurp-savor',
    url: '/discovery/place/daeryeon-house-sip-slurp-savor',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2c57ff1c-9235-4b40-8903-199024188f56?alt=media&token=a3aa6e56-767a-4109-a59d-5bc8cccec79c',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5ef330e3-b24c-45c5-8b79-716119243f43?alt=media&token=025c3934-23bf-4799-825f-efb36ad9a215',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4a3d82b8-4052-428c-9bc9-0b5a02ab69d0?alt=media&token=63322a6d-1bba-4edc-982f-b9943d27827d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3af7bfe0-4c77-44dc-918e-ece75228e9bd?alt=media&token=155b35ea-7084-478c-b49e-7b0231a976bf',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F908279e0-606e-476b-89b8-495e8cc83c19?alt=media&token=d703596d-4b82-43da-b6ed-3a196de07630',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F06fe04cb-84a0-47b1-ade5-e00a18b24246?alt=media&token=e93145da-1512-4755-abb3-a78e48a16b77',
    ],
    name: 'Daeryeon House',
    priceLevel: 2,
    tags: ['Korean', 'NoodleSoup', 'SteamedPork'],
    location: {
      address: '37, Jong-ro 16-gil, Jongno-gu, Seoul',
      area: 'Euljiro 3(sam)-ga',
      latlng: [37.568591, 126.98914],
      subway: 'Line 2, Line 3',
      nearBy: 'Euljiro 3(sam)-ga Station',
      googleMap: 'https://maps.app.goo.gl/NGe9dkkRRspZDCgd9',
    },
    address: '37, Jong-ro 16-gil, Jongno-gu, Seoul',
    latlng: [37.568591, 126.98914],
    information: [
      {
        label: 'Phone Number',
        value: '02-2265-5349',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 21:30',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '14:30 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '사골칼국수, 생배추보쌈, 파전',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4a3d82b8-4052-428c-9bc9-0b5a02ab69d0?alt=media&token=63322a6d-1bba-4edc-982f-b9943d27827d',
        name: '사골칼국수',
        subheader: 'Korean Noodle Soup',
        description:
          'A Korean noodle soup made with handmade wheat noodles served in a rich, hearty broth derived from simmered beef bones',
        price: 'KRW9,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2c57ff1c-9235-4b40-8903-199024188f56?alt=media&token=a3aa6e56-767a-4109-a59d-5bc8cccec79c',
        name: '생배추보쌈 (Small)',
        subheader: 'Korean Steamed Pork',
        description:
          'A Korean dish featuring fresh napa cabbage leaves used to wrap a variety of fillings, such as seasoned rice, grilled meats, and condiments, creating a refreshing and crunchy bite',
        price: 'KRW19,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2c57ff1c-9235-4b40-8903-199024188f56?alt=media&token=a3aa6e56-767a-4109-a59d-5bc8cccec79c',
        name: '생배추보쌈 (Large)',
        subheader: 'Korean Steamed Pork',
        description:
          'A Korean dish featuring fresh napa cabbage leaves used to wrap a variety of fillings, such as seasoned rice, grilled meats, and condiments, creating a refreshing and crunchy bite',
        price: 'KRW29,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F06fe04cb-84a0-47b1-ade5-e00a18b24246?alt=media&token=e93145da-1512-4755-abb3-a78e48a16b77',
        name: '파전',
        subheader: 'Korean Green Onion Pancakes',
        description:
          'A Korean pancake made primarily with green onions, mixed with a batter of flour and water, often including seafood or vegetables, and pan-fried until crispy and golden',
        price: 'KRW15,000',
      },
    ],
    html: '<h1>Daeryeon House 대련집 </h1><p><br></p><p class="ql-align-justify"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">The entrance to the restaurant is quite small, but the interior is surprisingly spacious and inviting. This hidden gem is tucked away in a bustling area, making it a perfect spot for those seeking a cozy dining experience.</span></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Highlight:</strong> <span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51);">The menu features soft and chewy noodles in a delicious broth that warms the stomach without being overly chewy. Notably, even if two people order only one bowl of noodle soup, the staff will nicely separate the portion into two different bowls, making it easier for customers to dine together. A standout dish is the flavorful pork belly, which pairs perfectly with sauce and kimchi, creating a delightful combination. A large plate of cabbage is provided to balance the richness. The smallest portion of pork belly is available, as shown in the picture, with larger sizes offered as well. Additionally, the scallion pancakes are rich and aromatic, and the squid served is plentiful and very crispy!</span></p><p><br></p><p><strong>Location:</strong> Approximately 405 meters from Exit 2 of Euljiro 3(sam)-ga Station.</p>',
    description:
      'Daeryeon House features delectable bowls of soft, chewy noodles in a savory broth, with standout dishes like flavorful pork belly and crispy scallion pancakes, all in a cozy setting perfect for sharing.',
    createdAt: '2024-10-17T23:17:19.034Z',
    updatedAt: '2024-10-17T23:17:19.034Z',
  },
  'ttosuns-restaurant-where-every-bite-is-a-k-drama-delight': {
    id: 'ttosuns-restaurant-where-every-bite-is-a-k-drama-delight',
    slug: 'ttosuns-restaurant-where-every-bite-is-a-k-drama-delight',
    url: '/discovery/place/ttosuns-restaurant-where-every-bite-is-a-k-drama-delight',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9bb8f88d-0253-4b26-b112-2cce02f934ed?alt=media&token=5f9c5a61-a010-48bb-bc1f-9f6db6af3007',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5624e4d8-fd41-4f24-8f3a-1716458cf495?alt=media&token=f7ac7f63-cccb-46fa-89a4-fdbbc381dd96',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4b2b7919-d499-4dec-adbb-c633b6f6e7ef?alt=media&token=293858ca-ecd0-4356-b390-774f68e40963',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F110c90dc-ed1c-47f6-9d19-c3b8e0cfb57a?alt=media&token=f2eb2558-6440-4847-8a95-9fe96bcd9df8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8de38d30-3480-455c-9a0f-b4e13a7a352a?alt=media&token=fc41aeae-2a9b-472a-8579-e6659692206a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5cc44896-026f-4d92-b7e3-c00ab238cd87?alt=media&token=6d008e1b-f759-4575-8a3f-85abe7b33b24',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F37a58e02-ffb2-4740-b32c-22b2e000f414?alt=media&token=3f457a06-3877-4474-b848-110b9a1e15c2',
    ],
    name: "Ttosun's Restaurant",
    priceLevel: 3,
    tags: ['Korean', 'BBQ'],
    location: {
      address: '16, Seonyu-ro 47-gil, Yeongdeungpo-gu, Seoul (오오1004빌딩)',
      area: 'Yeongdeungpo',
      latlng: [37.536064, 126.895199],
      subway: 'Line 9',
      nearBy: 'Seonyudo Station',
      googleMap: 'https://maps.app.goo.gl/yg4wSchvr7FptHjs8',
    },
    address: '16, Seonyu-ro 47-gil, Yeongdeungpo-gu, Seoul (오오1004빌딩)',
    latlng: [37.536064, 126.895199],
    information: [
      {
        label: 'Phone Number',
        value: '02-2672-2255',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 21:30 ',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '16:00 - 17:00',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '토시살, 등심, 된장찌개',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8de38d30-3480-455c-9a0f-b4e13a7a352a?alt=media&token=fc41aeae-2a9b-472a-8579-e6659692206a',
        name: '토시살',
        subheader: 'Korean BBQ',
        description: 'A cut of beef from the neck area, known for its tenderness and rich flavor.',
        price: 'KRW33,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F37a58e02-ffb2-4740-b32c-22b2e000f414?alt=media&token=3f457a06-3877-4474-b848-110b9a1e15c2',
        name: '등심',
        subheader: 'BBQ',
        description: 'Refers to the sirloin cut of beef, known for its tenderness and rich flavor.',
        price: 'KRW33,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5cc44896-026f-4d92-b7e3-c00ab238cd87?alt=media&token=6d008e1b-f759-4575-8a3f-85abe7b33b24',
        name: '된장찌개',
        subheader: 'Korean Doenjang Stew',
        description:
          'A traditional Korean stew made with doenjang (fermented soybean paste), tofu, vegetables.',
        price: 'KRW7,000',
      },
    ],
    html: "<h1>Ttosun's Restaurant 또순이네집</h1><p><br></p><p>If you're craving an <strong>authentic Korean BBQ</strong> experience, 또순이네집 is the place to be. The restaurant boasts a clean, tidy, and spacious interior that feels like it’s straight out of a <strong>K-drama</strong>, creating an inviting atmosphere perfect for both casual meals and special gatherings.</p><p><br></p><p><strong>Highlight:</strong> Specializing in mouthwatering cuts like <strong>토시살 (toshi sal)</strong>, <strong>등심 (deungsim)</strong>, and <strong>생등심 (saeng deungsim)</strong>, the quality and freshness of the meat are truly exceptional. Each cut is sourced from high-quality suppliers, ensuring tenderness and rich marbling that enhances its juiciness when grilled.</p><p><br></p><p>Don’t miss their <strong>된장찌개 (doenjang jjigae)</strong>, a hearty stew full of flavor, but be sure to arrive before 13:30 to enjoy it, as it’s only available during lunch hours. Overall, 또순이네집 offers a delightful dining experience that showcases the best of Korean BBQ, making it a must-visit for BBQ lovers!</p><p><br></p><p><strong>Location: </strong>Approximately 324 meters from Exit 5 of Seonyudo Station.</p>",
    description:
      '또순이네집 is a cozy Korean BBQ spot known for its high-quality meats and inviting K-drama-like atmosphere.',
    createdAt: '2024-10-17T23:51:33.281Z',
    updatedAt: '2024-10-17T23:51:33.281Z',
  },
  'mokmyeoksanbang-discover-michelin-star-bibimbap': {
    id: 'mokmyeoksanbang-discover-michelin-star-bibimbap',
    slug: 'mokmyeoksanbang-discover-michelin-star-bibimbap',
    url: '/discovery/place/mokmyeoksanbang-discover-michelin-star-bibimbap',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F73b75554-89c2-4a01-a253-36abca4f0507?alt=media&token=2fa6904d-7424-4a40-aa74-8e9c45311bad',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fce20ba8f-8e30-4597-88c7-855f271c96d7?alt=media&token=64aed120-22a9-4c6e-92ae-e72875f9ae6b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb215ab03-05ef-4e18-9846-fb06990f5bf1?alt=media&token=53ca624f-54a6-447d-9c29-4d7c21b6db42',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F38d84b8f-3e44-4ea6-b2cf-bd5ff1b5e33d?alt=media&token=c0671fd8-f007-4afb-a1c4-baa04cbfd66d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F128a8848-ba6c-4a77-9f74-ffd72aeccf14?alt=media&token=86111f25-f08d-49ee-b2d9-dbe02f58f9a6',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F87c43acb-c3dc-45a0-92c3-3446a387d70b?alt=media&token=e3796b99-75b5-4b5b-adfd-c25636c38917',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffe8514a3-9208-4e1b-98a1-cd716255a4a5?alt=media&token=b42d85e7-d211-4f97-b9d4-3dc4a98531cd',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc2a806c4-5be8-4d5e-9833-186866db9b57?alt=media&token=4a579827-531c-4c91-8835-a82ca7765428',
    ],
    name: 'MOKMYEOKSANBANG',
    priceLevel: 2,
    tags: ['Korean', 'Michelin', 'Bibimbap'],
    location: {
      address: '71, Toegye-ro 20-gil (1st Floor), Jung-gu, Seoul ',
      area: 'Myeongdong ',
      latlng: [37.558196, 126.986727],
      subway: 'Line 4',
      nearBy: "Myeong-dong Station, Soongeui Women's University",
      googleMap: 'https://maps.app.goo.gl/jD18CenNd9BDJDSN6',
    },
    address: '71, Toegye-ro 20-gil (1st Floor), Jung-gu, Seoul ',
    latlng: [37.558196, 126.986727],
    information: [
      {
        label: 'Phone Number',
        value: '02-318-4790',
      },
      {
        label: 'Business Hours',
        value: '11:00 - 20:00 ',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '투뿔 한우 육회 비빔밥, 치즈김치, 산방비빔밥, 곤드레 간장비빔밥 ',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fce20ba8f-8e30-4597-88c7-855f271c96d7?alt=media&token=64aed120-22a9-4c6e-92ae-e72875f9ae6b',
        name: '투뿔 한우 육회 비빔밥',
        subheader: 'Korean Raw Beef',
        description:
          'A Korean dish that combines premium two-star Hanwoo beef tartare with rice, mixed vegetables, and a spicy sauce, creating a rich and flavorful meal that showcases the quality of the beef.',
        price: 'KRW14,500',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F73b75554-89c2-4a01-a253-36abca4f0507?alt=media&token=2fa6904d-7424-4a40-aa74-8e9c45311bad',
        name: '치즈김치',
        subheader: 'Korean Cheese Potato Pancakes',
        description:
          'A meeting of mozzarella cheese and kimchi. A steady seller at Mokmyeoksanbang.',
        price: 'KRW13,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F38d84b8f-3e44-4ea6-b2cf-bd5ff1b5e33d?alt=media&token=c0671fd8-f007-4afb-a1c4-baa04cbfd66d',
        name: '산방비빔밥',
        subheader: 'Signature Bibimbap',
        description:
          'A vibrant Korean dish featuring a colorful mix of fresh vegetables, rice, and often topped with a fried egg and a spicy gochujang sauce.',
        price: 'KRW9,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb215ab03-05ef-4e18-9846-fb06990f5bf1?alt=media&token=53ca624f-54a6-447d-9c29-4d7c21b6db42',
        name: '곤드레 간장비빔밥 ',
        subheader: 'Gondeure Soy Sauce Bibimbap',
        description:
          'A Korean dish featuring a bed of rice topped with seasoned gondeure (edible mountain herbs) and mixed with soy sauce, offering a delightful combination of flavors and textures.',
        price: 'KRW9,500',
      },
    ],
    html: "<h1>MOKMYEOKSANBANG 목멱산방</h1><p><br></p><p><strong>Mokmyeoksanbang</strong> is a celebrated <strong>Korean bibimbap</strong> restaurant that has earned <strong>Michelin recognition</strong> for three consecutive years, from 2017 to 2019. Conveniently located in the middle of <strong>Myeongdong</strong> and <strong>Seoul Tower</strong>, it’s the perfect spot for tourists looking to enjoy a delicious meal before taking a leisurely walk to the tower. The restaurant's warm ambiance and attentive service create an inviting atmosphere, making it a delightful place to savor authentic Korean flavors.</p><p><br></p><p><strong>Highlight:</strong> Mokmyeoksanbang takes great care in selecting and sourcing its ingredients to ensure the highest quality. They prioritize locally sourced produce, often from nearby farms, to guarantee freshness and flavor in every dish. For example, their <strong>투뿔한우 육회 비빔밥 (Two-Pul Hanwoo Yukhoe Bibimbap)</strong> features premium Hanwoo beef, carefully chosen for its tenderness and marbling, making it a standout on the menu. The <strong>치즈김치전 (Cheese Kimchi Pancake)</strong> uses house-made kimchi, prepared with fresh vegetables that are picked at their peak ripeness, ensuring a robust flavor. </p><p><br></p><p><strong>Location:</strong> Approximately 427 meters from Exit 1 of Myeongdong Station.</p>",
    description:
      'Mokmyeoksanbang is a Michelin-recognized restaurant specializing in bibimbap, known for its vibrant flavors and fresh, locally sourced ingredients, all served in a cozy atmosphere near Seoul Tower.',
    createdAt: '2024-10-18T00:33:31.362Z',
    updatedAt: '2024-10-18T00:33:31.362Z',
  },
  'bornga-dak-hanmari-taste-tradition-dakbokkeumtang-and-dakhanmari-done-right': {
    id: 'bornga-dak-hanmari-taste-tradition-dakbokkeumtang-and-dakhanmari-done-right',
    slug: 'bornga-dak-hanmari-taste-tradition-dakbokkeumtang-and-dakhanmari-done-right',
    url: '/discovery/place/bornga-dak-hanmari-taste-tradition-dakbokkeumtang-and-dakhanmari-done-right',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8e46cee5-b183-4d7b-95b5-23c22793c4c4?alt=media&token=4d6eeccc-a892-43d0-9207-e45a68bdae58',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6dc3e136-8244-4699-be86-fe53c77343e6?alt=media&token=06dca7d5-74fc-4934-9009-a47563e2ab70',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Feda6cb08-617a-4d62-81db-65e607a603ed?alt=media&token=bc1514e3-1984-461e-b794-12b84153008b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9adbaaa4-ff23-4444-b7c2-53435a57a17c?alt=media&token=5c01c42c-f8fc-4df8-9123-45a9d2d32f2d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F462d7d95-488e-47b5-a23c-c6751f094a29?alt=media&token=5a841aef-1d50-4abe-88fd-6f9df17378b3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc0644fea-0c93-4a91-b996-9a9f7e15f742?alt=media&token=0be38678-9808-4fec-86f6-3de8ca1c6973',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff7f80a8f-daf1-4559-8d70-fb31816c7679?alt=media&token=0cfe15b2-76b7-4f46-b3be-d5347d954d8f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fcf98dc82-a21c-4d64-b33b-abb39cbb34f5?alt=media&token=c5daf667-1498-4622-ae03-39c205dcca12',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa370e187-9095-4003-9546-dc1455d09280?alt=media&token=3974c744-e9d6-41cb-88a5-2393efbbd9a5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5c4fd9ad-b207-4775-bee0-3e783d5f6259?alt=media&token=643c0279-7cb8-4d06-a8cb-b63f70db9fe9',
    ],
    name: 'Bornga Dak Hanmari',
    priceLevel: 2,
    tags: ['Korean', 'DakHanmari', 'Chicken'],
    location: {
      address: '19, Mareunnae-ro 2-gil, Jung-gu, Seoul',
      area: 'Euljiro 3(sam)-ga',
      latlng: [37.563558, 126.99192],
      subway: 'Line 2, Line 3',
      nearBy: 'Euljiro 3(sam)-ga Station',
      googleMap: 'https://maps.app.goo.gl/Kt8ABSwbnoqGixMX9',
    },
    address: '19, Mareunnae-ro 2-gil, Jung-gu, Seoul',
    latlng: [37.563558, 126.99192],
    information: [
      {
        label: 'Phone Number',
        value: '02-2274-2986',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 23:00',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '닭한마리, 닭볶음탕, 삼계탕',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6dc3e136-8244-4699-be86-fe53c77343e6?alt=media&token=06dca7d5-74fc-4934-9009-a47563e2ab70',
        name: '닭한마리',
        subheader: 'Boiled Whole Chicken',
        description:
          'A traditional Korean dish featuring a whole chicken boiled with vegetables in a flavorful broth, typically served with dipping sauces and accompanied by rice or noodles.',
        price: 'KRW22,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc0644fea-0c93-4a91-b996-9a9f7e15f742?alt=media&token=0be38678-9808-4fec-86f6-3de8ca1c6973',
        name: '닭볶음탕',
        subheader: 'Spicy Korean Chicken Stew',
        description:
          'A spicy Korean chicken stew made with chunks of chicken, potatoes, carrots, and onions, all simmered in a rich, flavorful sauce that combines gochugaru (Korean red pepper flakes) and soy sauce.',
        price: 'KRW24,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa370e187-9095-4003-9546-dc1455d09280?alt=media&token=3974c744-e9d6-41cb-88a5-2393efbbd9a5',
        name: '삼계탕',
        subheader: 'Korean Ginseng Chicken ',
        description:
          'A traditional Korean ginseng chicken soup that features a whole young chicken stuffed with glutinous rice, ginseng, garlic, and jujubes (Korean dates), all simmered to perfection in a flavorful broth.',
        price: 'KRW15,000',
      },
    ],
    html: "<h1>Bornga Dak Hanmari 본가닭한마리</h1><p><br></p><p>This traditional Korean restaurant has been a beloved local spot for years, frequented by nearby families who come to enjoy hearty meals together. The warm and inviting atmosphere reflects the essence of community dining, making it a great choice for anyone seeking an authentic experience. Conveniently located not far from <strong>Myeongdong</strong>, it’s an ideal stop for both locals and tourists looking to indulge in comforting <strong>Korean cuisine</strong>.</p><p><br></p><p><strong>Highlight:</strong> The restaurant specializes in two standout dishes: <strong>닭한마리 (Dakhanmari)</strong>, featuring a whole chicken boiled to tender perfection in a flavorful broth with vegetables, and <strong>닭볶음탕 (Dakbokkeumtang)</strong>, a spicy stew with tender chicken, potatoes, and carrots simmered in a rich sauce. Both dishes highlight the restaurant's commitment to quality ingredients. A unique dining tradition here encourages guests to leave about a quarter of their main dish untouched, after which they can order fried rice or porridge, with the staff preparing the fried rice right at the table using the leftover broth. This interactive experience not only enhances the meal but is essential for a complete dining experience, making your visit truly memorable.</p><p><br></p><p><strong>Location:</strong> Approximately 218 meters from Exit 9 of Euljiro 3(sam)-ga Station.</p>",
    description:
      'Specializes in comforting dishes like Dakhanmari and Dakbokkeumtang, offering a warm atmosphere that invites families and friends to gather and enjoy authentic flavors.',
    createdAt: '2024-10-18T01:16:15.788Z',
    updatedAt: '2024-10-18T01:16:15.788Z',
  },
  'sindonggung-taste-korea-24-hours': {
    id: 'sindonggung-taste-korea-24-hours',
    slug: 'sindonggung-taste-korea-24-hours',
    url: '/discovery/place/sindonggung-taste-korea-24-hours',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fedb0929a-72a6-4548-9dc5-ff7d8c44b95e?alt=media&token=d3c2f4aa-b869-41f2-92f8-78eefd33a215',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9ca8527e-30f7-44df-b41f-c50aa68bea65?alt=media&token=def3ed9f-f80e-4ab3-8245-f6dba7e0a7da',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd1822d63-55a9-403e-9a57-ee62187bcfcd?alt=media&token=76d16a40-b9a8-4876-92d7-3e2763d3b949',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4eb1d253-b22f-49db-9183-af8cccb891e1?alt=media&token=70fa3af7-14e5-449c-b237-71cf61f693bc',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c489bb4-1fe7-4181-b296-f635e9fb58f4?alt=media&token=ae6e1851-dac9-4f66-abcc-a7b6c65860ec',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb877a3ce-c885-40fa-9292-64b003c79025?alt=media&token=3dd04152-3ccd-4852-9afe-73f07ef5d867',
    ],
    name: 'Sindonggung Pork Back-bone Stew Myeongdong Branch',
    priceLevel: 2,
    tags: ['Korean', 'PorkBackBoneSoup', 'Gamjatang'],
    location: {
      address: '43, Myeongdong 9-gil, Jung-gu, Seoul',
      area: 'Myeongdong, Euljiro1 (il)-ga ',
      latlng: [37.565738, 126.983901],
      subway: 'Line 2',
      nearBy: 'Euljiro1 (il)-ga Station',
      googleMap: 'https://maps.app.goo.gl/RGiSVwG3WGDp1PNN6',
    },
    address: '43, Myeongdong 9-gil, Jung-gu, Seoul',
    latlng: [37.565738, 126.983901],
    information: [
      {
        label: 'Phone Number',
        value: '02-318-4222',
      },
      {
        label: 'Business Hours',
        value: '24 Hours',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '뼈해장국, 감자탕, 뼈숯불구이',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9ca8527e-30f7-44df-b41f-c50aa68bea65?alt=media&token=def3ed9f-f80e-4ab3-8245-f6dba7e0a7da',
        name: '뼈해장국',
        subheader: 'Pork Bones Soup',
        description:
          'A traditional Korean soup made with beef bones, often featuring brisket or other cuts, simmered for hours to create a rich, flavorful broth.',
        price: 'KRW10,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb877a3ce-c885-40fa-9292-64b003c79025?alt=media&token=3dd04152-3ccd-4852-9afe-73f07ef5d867',
        name: '감자탕 (Small)',
        subheader: 'Pork Back Bones Soup',
        description:
          'A hearty Korean stew made with pork spine and tender potatoes, simmered in a spicy, flavorful broth.',
        price: 'KRW35,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0c489bb4-1fe7-4181-b296-f635e9fb58f4?alt=media&token=ae6e1851-dac9-4f66-abcc-a7b6c65860ec',
        name: ' 뼈숯불구이 (Small)',
        subheader: 'Pork Bones',
        description:
          'Grilled pork bones, often marinated and cooked over charcoal for a smoky flavor.',
        price: 'KRW38,000',
      },
    ],
    html: '<h1>Sindonggung Pork Back-bone Stew Myeongdong Branch 신동궁감자탕 뼈숯불구이 </h1><p><br></p><p><strong>Sindonggung Pork Back-bone Stew</strong> is a beloved restaurant <strong>located near the lively Myeongdong district</strong>, renowned for its vibrant shopping and nightlife. If you happen to be out shopping late into the evening, there’s no need to worry—this restaurant is <strong>open 24 hours</strong>, making it easy for you to enjoy a late-night meal at your convenience. With its welcoming atmosphere, it serves as an excellent choice for experiencing authentic Korean cuisine.</p><p><br></p><p><strong>Highlight:</strong> The restaurant specializes in <strong>Pork Back-bone Stew</strong> and <strong>Charcoal Grilled Ribs</strong>. The spicy charcoal grilled ribs are a standout, marinated in a secret house sauce and grilled to perfection, delivering a delightful smoky aroma. Each order comes with a complimentary soup, enhancing the meal experience. Be sure to leave room for fried rice afterward, as it’s highly recommended! The pork back-bone stew is generous in portion, packed with quality ingredients, making it a comforting choice for anyone craving hearty Korean flavors. </p><p><br></p><p><strong>Just a note:</strong> the grilled ribs can be quite spicy, so those who prefer milder dishes should take caution!</p><p><br></p><p><strong>Location:</strong> Approximately 120 meters from Exit 5 of Euljiro1 (il)-ga Station</p>',
    description:
      'Sindonggung is a 24-hour restaurant near Myeongdong, specializing in authentic Korean pork back-bone stew and spicy charcoal grilled ribs.',
    createdAt: '2024-10-18T02:13:26.286Z',
    updatedAt: '2024-10-18T02:13:26.286Z',
  },
  'inamjang-over-50-years-of-flavor': {
    id: 'inamjang-over-50-years-of-flavor',
    slug: 'inamjang-over-50-years-of-flavor',
    url: '/discovery/place/inamjang-over-50-years-of-flavor',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffbcab46e-35fe-4b4e-baa2-5c910ee9cefa?alt=media&token=f5bdec44-4190-476a-beb4-8509c93c1a0f',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fdd57651a-a285-4221-8565-95e0a047d8b5?alt=media&token=a531242c-1569-421f-aa9e-e9c73b5dc6aa',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe22b2714-d280-4f3c-9fe0-2e5df0f2f3e0?alt=media&token=2bc47c76-b0cc-42a3-a948-b6818d94436b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe42fcf5c-feef-4d28-a2d3-21392002aa54?alt=media&token=18b67aac-c627-465d-bfc1-7828eaa69e71',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F65beae85-0c41-4f0a-8eb0-5a339e3c3a6d?alt=media&token=7f3b8490-6d91-4882-9b81-1f7f8aaff5c3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F11427ec5-6394-4d40-87a3-828e65798030?alt=media&token=777a546f-bfd0-45eb-aedb-249a5bcbfa40',
    ],
    name: 'Inamjang Euljiro Main Branch',
    priceLevel: 2,
    tags: ['Korean', 'Seolnongtang'],
    location: {
      address: '16, Samil-daero 12-gil, Jung-gu, Seoul',
      area: 'Euljiro 3(sam)-ga',
      latlng: [37.567074, 126.988775],
      subway: 'Line 2, Line 3',
      nearBy: 'Euljiro 3(sam)-ga Station, Cheonggyecheon',
      googleMap: 'https://maps.app.goo.gl/v3xikAsx6Dz5ts5x6',
    },
    address: '16, Samil-daero 12-gil, Jung-gu, Seoul',
    latlng: [37.567074, 126.988775],
    information: [
      {
        label: 'Phone Number',
        value: '02-2267-4081',
      },
      {
        label: 'Business Hours',
        value: '10:00 - 22:00 ',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '설렁탕, 족탕, 내장탕',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe22b2714-d280-4f3c-9fe0-2e5df0f2f3e0?alt=media&token=2bc47c76-b0cc-42a3-a948-b6818d94436b',
        name: '설렁탕',
        subheader: 'Beef Soup ',
        description:
          'A traditional Korean beef soup made from simmering beef bones, meat, and various seasonings for an extended period, resulting in a rich, milky broth.',
        price: 'KRW12,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fdd57651a-a285-4221-8565-95e0a047d8b5?alt=media&token=a531242c-1569-421f-aa9e-e9c73b5dc6aa',
        name: '족탕 ',
        subheader: "Pig's Feet Soup",
        description:
          "A Korean dish made from simmering pig's feet or trotters in a flavorful broth, often seasoned with various spices and ingredients.",
        price: 'KRW27,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffbcab46e-35fe-4b4e-baa2-5c910ee9cefa?alt=media&token=f5bdec44-4190-476a-beb4-8509c93c1a0f',
        name: '내장탕',
        subheader: 'Organ Meat Soup',
        description:
          'A traditional Korean soup made with various organ meats, typically from beef or pork.',
        price: 'KRW13,000',
      },
    ],
    html: "<h1>Inamjang Euljiro Main Branch 이남장 을지로본점</h1><p><br></p><p>This hidden gem offers authentic flavors and features a traditional Korean decor. With <strong>over 50 years </strong>of service, it has become a beloved spot for locals and visitors alike.  If you don't speak Korean,<strong> the menu is available in Korean, Chinese, English, and Japanese</strong>, making it easy for everyone to enjoy their meal. The welcoming atmosphere makes it a perfect place to enjoy a comforting meal any time.</p><p><br></p><p><strong>Highlight:</strong> The standout dish is <strong>설렁탕 (Seolnongtang)</strong>, and it's highly recommended to order the large portion, as it features fresh meat both on top and throughout the broth. Made by simmering beef bones for <strong>48 hours</strong> without any additives, the soup results in a pure, thick, white broth that’s rich in flavor. Rice and side dishes are complimentary and refillable, ensuring you won’t leave hungry. The beef tendons are particularly chewy and delicious, especially when paired with a spicy dipping sauce. You can customize the soup’s flavor with pepper, salt, and green onions, making for an incredibly satisfying meal.</p><p><br></p><p><strong>Location:</strong> Approximately 154 meters from Exit 1 of Euljiro 3(sam)-ga Station.</p>",
    description:
      'Inamjang specializes in 설렁탕 (Seolnongtang), offering this traditional Korean beef soup with rich, authentic flavors for over 50 years in a welcoming atmosphere.',
    createdAt: '2024-10-18T04:05:16.798Z',
    updatedAt: '2024-10-18T04:05:16.798Z',
  },
  'hannam-pig-house-joy-in-every-bite': {
    id: 'hannam-pig-house-joy-in-every-bite',
    slug: 'hannam-pig-house-joy-in-every-bite',
    url: '/discovery/place/hannam-pig-house-joy-in-every-bite',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe2053c9f-eb13-428e-9b29-404cefa65860?alt=media&token=139826cf-4e63-4e75-8655-0f9b6e9e6bb3',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5f2f049b-e428-4309-82f5-638c3a04c3ac?alt=media&token=68e31089-2d95-484f-ada9-34d139749e6a',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1aed97c5-ca22-410d-be2b-f2ebb8beb607?alt=media&token=d4af5376-02a0-402e-99e8-191bb34a305e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F11fc1180-076b-4090-b148-daf7fa1f03e1?alt=media&token=954bd093-3609-41cd-8c56-6a4c942d6249',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F73a0d576-703f-448a-8e59-bd32ee602255?alt=media&token=99fa544e-d469-4fcf-98f3-68535a1b64ce',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5cdcdd03-bc64-4d5c-8378-ac4c9ab0699d?alt=media&token=47eaaed2-dff1-4651-a05c-142350bb8992',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F170e7d0d-22a3-4265-a3fd-64027bfc5518?alt=media&token=07e6ba41-3415-4093-84e3-43209208eb3e',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7314edd5-ac97-418e-af8e-bb4aa7b2baf0?alt=media&token=96c64fec-70fa-4a41-be94-b6ebd1394c5b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F898c45b4-acf2-4899-8c47-fc828b6427f6?alt=media&token=a55a9f66-83d0-42ef-acfb-2ef0147f0b25',
    ],
    name: 'Hanam Pig Myeongdong No. 1 Branch',
    priceLevel: 3,
    tags: ['KoreanBBQ', 'PorkBelly'],
    location: {
      address: '12, Myeongdong 9ga-gil, Jung-gu, Seoul',
      area: 'Myeongdong ',
      latlng: [37.565208, 126.983877],
      subway: 'Line 2',
      nearBy: 'Euljiro1 (il)-ga Station',
      googleMap: 'https://maps.app.goo.gl/peUjMxEKZuW22AyUA',
    },
    address: '12, Myeongdong 9ga-gil, Jung-gu, Seoul',
    latlng: [37.565208, 126.983877],
    information: [
      {
        label: 'Phone Number',
        value: '02-772-9995',
      },
      {
        label: 'Business Hours',
        value: '11:30 - 24:00 (Thu,Fri 16:30 - 24:00)',
      },
      {
        label: 'Day Off',
        value: 'No Days Off',
      },
      {
        label: 'Break Time',
        value: '15:00 - 16:00',
      },
      {
        label: 'Budget',
        value: 'KRW20,000 ~ KRW30,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '생삼겹살',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5f2f049b-e428-4309-82f5-638c3a04c3ac?alt=media&token=68e31089-2d95-484f-ada9-34d139749e6a',
        name: '생삼겹살 (180g)',
        subheader: 'BBQ',
        description:
          ' Fresh, uncooked and thick-cut pork belly, which is a popular dish in Korean barbecue.',
        price: 'KRW18,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1aed97c5-ca22-410d-be2b-f2ebb8beb607?alt=media&token=d4af5376-02a0-402e-99e8-191bb34a305e',
        name: '모둠한판',
        subheader: 'Korean BBQ',
        description:
          'This is a set, which includes grilled meat platter with pork belly, pork ribs, and pork neck, accompanied by Korean steamed egg (gyeran-jjim).',
        price: 'KRW52,000',
      },
    ],
    html: '<h1>Hanam Pig Myeongdong No. 1 Branch 하남돼지 명동 1호</h1><p><br></p><p>This <strong>Korean barbecue</strong> restaurant is a popular choice among locals and visitors, frequently featured in Korean dramas. It has become a go-to spot for celebrities, including <strong>EXO\'s Sehun and Baekhyun</strong>, as well as <strong>(G)I-DLE</strong>, with scenes from popular shows like "<strong>Transit Love 2</strong>" and "<strong>Hospital Playlist</strong>" being filmed at the restaurant. The inviting atmosphere and attentive service make it a convenient and enjoyable dining experience.</p><p><br></p><p><strong>Highlight:</strong> The restaurant offers a variety of pork cuts, including premium options from the pork belly, available as both individual dishes and sets. The grilling process begins over charcoal until the meat reaches medium-rare, and then the staff continues cooking it at your table, ensuring perfect results without any hassle. This hands-on approach allows diners to savor the rich flavors of the perfectly grilled meat in a delightful and interactive manner.</p><p><br></p><p><strong>Location:</strong> Approximately 188 meters from Exit 6 of Euljiro 1(il)-ga Station.</p>',
    description:
      'A beloved family restaurant, famous for its carefully crafted pork belly (삼겹살), offering a delightful dining experience for all.',
    createdAt: '2024-10-18T04:48:03.867Z',
    updatedAt: '2024-10-18T04:48:03.867Z',
  },
  'hadongkwan-timeless-taste-of-hanwoo-beef-soup': {
    id: 'hadongkwan-timeless-taste-of-hanwoo-beef-soup',
    slug: 'hadongkwan-timeless-taste-of-hanwoo-beef-soup',
    url: '/discovery/place/hadongkwan-timeless-taste-of-hanwoo-beef-soup',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F859536b0-5b7f-4c2b-af3c-4221244060db?alt=media&token=01a89589-a37b-426f-8a19-49f22b727619',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F459231ab-3e44-4b89-bafe-ec8e316c913c?alt=media&token=01e83f52-4d87-4dde-bffa-3bba1603cbb1',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5341abeb-6d4e-4bd4-b656-83bb19d1de1d?alt=media&token=a134eeea-ac45-41f3-bde1-47adadc17537',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8e6cef7d-139a-4d0b-a856-3fd0ac575c44?alt=media&token=aad777ff-87ba-4a66-90ae-b579a72adbc7',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd8f124d8-0c17-46d0-879f-412b038fb4a7?alt=media&token=b2f19946-a086-44e6-b127-af7fc80ef033',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc9fa50d0-33b0-48a3-ba5c-d5ffae2ecd73?alt=media&token=4dea697a-8ae5-4882-98b3-41331b3a5ef5',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0f737f67-e0de-4138-942b-73a6d48a5f74?alt=media&token=bb654704-8c18-47b5-8c14-442667554fec',
    ],
    name: 'Hadongkwan',
    priceLevel: 3,
    tags: ['KoreanBeefSoup', 'Michelin', 'HanwooBeef'],
    location: {
      address: '12, Myeongdong 9-gil, Jung-gu, Seoul',
      area: 'Myeongdong ',
      latlng: [37.565284, 126.984618],
      subway: 'Line 2',
      nearBy: 'Euljiro1 (il)-ga Station',
      googleMap: 'https://maps.app.goo.gl/6CjphwFpYzSz3NKV8',
    },
    address: '12, Myeongdong 9-gil, Jung-gu, Seoul',
    latlng: [37.565284, 126.984618],
    information: [
      {
        label: 'Phone Number',
        value: '02-776-5656',
      },
      {
        label: 'Business Hours',
        value: '07:00 - 16:00',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '곰탕, 수육',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F859536b0-5b7f-4c2b-af3c-4221244060db?alt=media&token=01a89589-a37b-426f-8a19-49f22b727619',
        name: '곰탕 (Original)',
        subheader: 'Korean Beef Bone Soup',
        description:
          'A traditional Korean soup made primarily from beef bones, brisket, and other cuts, simmered for several hours to create a rich, flavorful broth.',
        price: 'KRW18,000',
      },
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5341abeb-6d4e-4bd4-b656-83bb19d1de1d?alt=media&token=a134eeea-ac45-41f3-bde1-47adadc17537',
        name: '수육 (Small)',
        subheader: 'Korean Boiled Pork',
        description: 'A Korean dish made from boiled pork, usually served in thin slices.',
        price: 'KRW40,000',
      },
    ],
    html: "<h1>Hadongkwan 하동관</h1><p><br></p><p> For 80 years, <strong>하동관 곰탕 (Hadongkwan Gomtang)</strong>, has preserved the authentic flavors of Korean traditional soup culture, crafted by three generations of grandmothers from Bukchon. The meticulous recipe, passed down with care, relies on the finest Hanwoo beef, ensuring consistent quality thanks to owner Kim Hee-young, who has overseen the restaurant's signature broth for over 50 years. Today, it continues to attract a steady stream of patrons seeking its beloved taste. It has been recognized by the Michelin Guide Seoul for three years, from 2022 to 2024.</p><p><br></p><p><strong>Highlight:</strong> Hadongkwan specializes in <strong>beef soup</strong> made from carefully selected <strong>Hanwoo beef</strong>, simmered for more than 6 hours to create a rich, flavorful broth that is both light and nutritious, making it an excellent choice for nourishment. The soup is available with or without beef tripe, allowing diners to choose based on their preferences. You can also enhance the flavor with green onions, salt, and kimchi to suit your taste.</p><p><br></p><p><strong>Location: </strong>Approximately 278 meters from Exit 5 of Euljiro 1(il)-ga Station.</p><p><br></p><p><br></p>",
    description:
      'For 80 years, Hadongkwan has upheld authentic Korean soup flavors with premium Hanwoo beef and a time-honored recipe.',
    createdAt: '2024-10-18T05:22:41.768Z',
    updatedAt: '2024-10-18T05:22:41.768Z',
  },
  'hannamdong-hanbang-tongdak-seouls-finest-roasted-chicken': {
    id: 'hannamdong-hanbang-tongdak-seouls-finest-roasted-chicken',
    slug: 'hannamdong-hanbang-tongdak-seouls-finest-roasted-chicken',
    url: '/discovery/place/hannamdong-hanbang-tongdak-seouls-finest-roasted-chicken',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff42bc99e-6920-4a07-965c-c8c22ea844f4?alt=media&token=05554250-2f96-478a-8f15-5a4d88b1b05d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F03728196-3d27-4dc5-886c-4d5741bff854?alt=media&token=5b305405-5d9d-4f20-9910-1218bbfaecea',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F28e4f459-7e98-4994-9c5c-f5f4c006f1a5?alt=media&token=3afa3ac4-bea4-4ede-bb42-88f34afeaf36',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F753a2b4c-16c9-4f0f-850b-bbeab9d2bed9?alt=media&token=a14cce66-d728-4d8c-9811-31a8f72dba5b',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fafb06acd-ddee-407c-982f-1bfb02f72e05?alt=media&token=0506fbaf-6730-4bc1-97a7-b3e46f3004f8',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F196c5c54-9bc0-42c8-9f5f-f0790c2a2ccc?alt=media&token=7065ecdc-c7c6-481a-82de-072d4e79ec51',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd0f29d23-bcfe-44c1-86ab-ee51d87f9abe?alt=media&token=0f053c3e-c957-4194-b396-9d5ea7e9322c',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb911df0b-2707-4007-9d69-65a69bad2995?alt=media&token=d14d8a3f-a0bd-417e-b2a6-720fbf5f2b0d',
      'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe2287642-ed75-4867-9109-cd83f9d5b1d0?alt=media&token=c9076477-8bf5-4df6-97e4-d835231aee2d',
    ],
    name: 'Hannamdong Hanbang Tongdak',
    priceLevel: 2,
    tags: ['RoastedChicken', 'Korean'],
    location: {
      address: '38, Daesagwan-ro 34-gil, Yongsan-gu, Seoul',
      area: 'Hannam',
      latlng: [37.531572, 127.005563],
      subway: 'GYEONGUI-JOUNGANG LINE',
      nearBy: 'Hannam Station',
      googleMap: 'https://maps.app.goo.gl/DvbyicrGutXHVBGn9',
    },
    address: '38, Daesagwan-ro 34-gil, Yongsan-gu, Seoul',
    latlng: [37.531572, 127.005563],
    information: [
      {
        label: 'Phone Number',
        value: '02-797-8677',
      },
      {
        label: 'Business Hours',
        value: '16:10 - 00:30 (Fri, Sat 16:10 - 01:30)',
      },
      {
        label: 'Day Off',
        value: 'Sunday',
      },
      {
        label: 'Break Time',
        value: 'No Break Time ',
      },
      {
        label: 'Budget',
        value: 'KRW10,000 ~ KRW20,000/ Person',
      },
      {
        label: 'Signature Menu',
        value: '한방통닭',
      },
    ],
    recommendations: [
      {
        category: 'Korean',
        image:
          'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd0f29d23-bcfe-44c1-86ab-ee51d87f9abe?alt=media&token=0f053c3e-c957-4194-b396-9d5ea7e9322c',
        name: '한방통닭',
        subheader: 'Roastet Whole Chicken',
        description:
          'Inside the chicken, there is a savory filling of glutinous rice, ginseng, red dates, and angelica, capturing the essence of traditional samgyetang.',
        price: 'KRW21,000',
      },
    ],
    html: "<h1>Hannamdong Hanbang Tongdak 한남동 한방통닭</h1><p><br></p><p>This renowned chicken restaurant in Seoul is famous for its perfectly roasted chicken, beloved by locals and celebrities alike. <strong>Each chicken is slow-roasted for at least two hours at low temperature</strong>, ensuring that even the most easily dried-out chicken breast remains exceptionally tender. The decor is filled with signatures from stars who have visited, like Hwasa, Gong Yoo, Lee Jong-suk， making it a must-try spot for fans and food lovers.</p><p><br></p><p><strong>Highlight:</strong> The chicken is served with three sauces: sweet and spicy fried chicken sauce, honey mustard, and pepper salt, though the traditional pepper salt is particularly delightful. Inside the chicken, you'll find a flavorful stuffing of glutinous rice, ginseng, red dates, and angelica, reminiscent of samgyetang. The rice is chewy with herbal notes, and the accompanying pickled radish and kimchi help balance the richness. The oak wood used in the roasting adds a unique depth of flavor, making every bite a memorable experience.</p><p><br></p><p><strong>Location:</strong> Approximately 414 meters from Exit 1 of Hannam Station.</p>",
    description:
      'This is the best tongdak (roasted whole chicken), in Seoul, renowned for its tender meat, flavorful herbal stuffing.',
    createdAt: '2024-10-18T06:07:24.340Z',
    updatedAt: '2024-10-18T06:07:24.340Z',
  },
};

// Discovery data for Hongdae with updated descriptions
export const DISCOVERIES: { [category: string]: DiscoveryResponse[] } = {
  'discovery-beauty': [
    {
      id: 'glow-like-a-k-drama-star-the-top-3-serums-from-south-korea',
      slug: 'glow-like-a-k-drama-star-the-top-3-serums-from-south-korea',
      category: 'discovery-beauty',
      title: 'Glow Like a K-Drama Star: The Top 3 Serums from South Korea!',
      description:
        'Discover the ultimate skincare secrets from Korea with these top three serums that promise to elevate your beauty routine and give you radiant, healthy skin.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fcd09d48b-682e-4b4e-b21b-101c1f07b30b?alt=media&token=360c8b58-4775-4a87-b9d9-a18608e4c3e2',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd8019db1-95b4-41ea-b85d-c5fbe539e4cf?alt=media&token=ada3af19-2c1d-4545-86f9-5230c6e6e5e5',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff3472f17-88d9-4b19-8375-ac7a09ba5299?alt=media&token=9a7f6b95-6d09-4818-a456-94f151713384',
      ],
      order: 0,
      html: '<h1><strong style="background-color: transparent; color: rgb(0, 0, 0);">KUP\'s TOP PICKS FOR SERUMS</strong></h1><p><span style="background-color: transparent; color: rgb(0, 0, 0);">Korean skincare has set the gold standard in beauty, and these top three serums are your ticket to radiant, healthy skin. Not only are they top sellers at</span><strong style="background-color: transparent; color: rgb(0, 0, 0);"> Olive Young</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">, but they also rank highly on </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">hwahae</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">, a popular app among Korean locals for skincare recommendations. Here’s why you simply can’t miss out on adding these to your routine:</span></p><h2><strong style="background-color: transparent; color: rgb(0, 0, 0);">TOP 1 [Wellage] Real Hyaluronic Blue 100 Ampoule</strong></h2><p><strong style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7a9cc10c-5c6f-4d84-881f-dc6ab58f44eb?alt=media&token=3a119d0b-db2e-47d7-b715-c3b892e9131b" ></strong></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">Inspired by the words "well" and "age," Korean brand WELLAGE offers a diverse range of anti-aging products free from harmful chemicals. Utilizing EWG-verified ingredients and advanced technology, the brand develops safe and effective skincare and cosmetics for its users. Notably, </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">Jisoo from BLACKPINK</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> has expressed her fondness for this product, often highlighting it as a staple in her skincare routine on social media.</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fcd09d48b-682e-4b4e-b21b-101c1f07b30b?alt=media&token=360c8b58-4775-4a87-b9d9-a18608e4c3e2" ></span></p><p><strong style="background-color: transparent; color: rgb(0, 0, 0);">Is your super dry skin causing discomfort and irritation? Frustrated when your dryness sabotages your makeup?</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> The Wellage Real Hyaluronic Blue 100 Ampoule is the solution you’ve been looking for! Packed with </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">100% pure hyaluronic acid</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">, this ampoule delivers deep hydration and instantly plumps your skin, giving you that sought-after dewy glow. Everyone wants to look fresh and revitalized, and with this essential addition to your routine, you can finally</span><strong style="background-color: transparent; color: rgb(0, 0, 0);"> say goodbye to dryness and dullness</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">!</span></p><p><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F51cf8f0f-9c22-4b3f-8e9d-dfc41764c5bb?alt=media&token=2cfed4fa-8d60-4e34-acfa-8c7930b1ddac"></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">This ultra-lightweight ampoule absorbs instantly, delivering deep hydration for a plumper, more youthful complexion while enhancing elasticity, smoothing fine lines and wrinkles, and improving overall texture—perfect for all skin types, even sensitive skin!</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F3bfc577c-438b-4cb2-a1f9-5f9e3239a59d?alt=media&token=686395b3-77d8-4024-a525-17dd32fc7a90" ></span></p><h2><strong style="background-color: transparent; color: rgb(0, 0, 0);">TOP 2 [VT COSMETICS] Reedle Shot 100 Essence</strong></h2><p><strong style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbd958fcf-a9e4-4298-9fb8-1cf0476ba017?alt=media&token=a5cba065-fb4b-40ab-8c23-21ccb333795d" ></strong></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">Introducing the Cica Reedle line by VT Cosmetics—a revolutionary addition to your skincare routine! Featuring purified hydrolyzed sponges infused with the healing power of Centella Asiatica (Cica), this collection soothes irritation and promotes healing. With five tailored concentrations ranging from 50 to 1,000, it caters to all skin types and unique needs. Elevate your skincare game and unlock your skin’s natural beauty! Renowned </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">YouTubers </strong><span style="background-color: transparent; color: rgb(0, 0, 0);">like </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">Beauty Within</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> and </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">dermatologist Dr. Dray</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> have praised this set for its effectiveness in achieving clearer, healthier skin—it\'s </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">sold over 11.7 million units</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> globally!</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd8019db1-95b4-41ea-b85d-c5fbe539e4cf?alt=media&token=ada3af19-2c1d-4545-86f9-5230c6e6e5e5" ></span></p><p><strong style="background-color: transparent; color: rgb(0, 0, 0);">Are enlarged pores holding you back from achieving flawless skin?</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> Discover the secret with VT Cosmetics\' Reedle Shot Set! Experience the transformative benefits of this powerful serum specifically designed to tackle enlarged pores and enhance overall skin texture.</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">We know what you are thinking,</span><strong style="background-color: transparent; color: rgb(0, 0, 0);"> "What exactly are spicules? Are they safe? Do they really work?"</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> Spicules are tiny, needle-like structures derived from natural ingredients that penetrate the skin to deliver active ingredients more effectively. They help stimulate collagen production and improve skin elasticity, resulting in a smoother, firmer complexion.</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">Rest assured, these spicules are safe and meticulously formulated to ensure a gentle yet effective experience. As the serum works its magic, you’ll notice a remarkable reduction in the appearance of enlarged pores, revealing a refined texture and a radiant glow. Don’t just dream of flawless skin—make it a reality with the VT Reedle Shot Essence!</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8d99f946-cdda-462f-b18a-42b756f44c0f?alt=media&token=e8e995e4-2277-4e13-8fad-d83677a766b5" ></span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">The VT Reedle Essence is a standout addition to any skincare routine, expertly designed to target enlarged pores and enhance overall skin texture. With its unique formulation featuring spicules and the soothing power of Centella Asiatica, it effectively promotes collagen production and improves skin elasticity. As many users have discovered, this essence not only helps reduce the appearance of pores but also revitalizes the complexion for a smoother, more radiant look. If you\'re ready to transform your skin and achieve that coveted flawless finish, the VT Reedle Essence is definitely worth trying!</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe88545d0-6ca1-4236-8459-209a63329f09?alt=media&token=fa4d75ad-122e-48e2-b26e-69b412fee5bb" ></span></p><h2><strong style="background-color: transparent; color: rgb(0, 0, 0);">TOP 3 [TORRIDEN] Dive In Serum</strong></h2><p><strong style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F431c6a20-2364-4b4e-9e80-721f6eb7c00e?alt=media&token=4fd76211-250d-4c40-a858-0d6ef20c9a7d" ></strong></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">The Torriden DIVE IN Serum is a must-try, having topped the charts on Korea\'s popular Hwahae app and Olive Young!This lightweight serum dives deep into your skin, providing hydration while strengthening the skin barrier. Want to lock in moisture and keep your skin looking youthful? This serum is a game changer, ensuring your skin feels hydrated and healthy all day long. </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">Hyram Yarbro</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">, a well-known American</span><strong style="background-color: transparent; color: rgb(0, 0, 0);"> beauty YouTuber</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">, mentioned the Torriden Dive In Serum in one of his YouTube videos, highlighting its hydrating properties and effectiveness for improving skin texture.</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff3472f17-88d9-4b19-8375-ac7a09ba5299?alt=media&token=9a7f6b95-6d09-4818-a456-94f151713384" ></span></p><p><strong style="background-color: transparent; color: rgb(0, 0, 0);">Tired of thick, greasy serums?</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> We, KUP, want you to meet Torriden DIVE IN serum, a new kind of hydration! Lightweight and non-greasy, these serums absorb quickly, leaving your skin feeling refreshed and moisturized all day. Elevate your skincare routine with a formula that hydrates without the heaviness!</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd848ba99-1a0b-4c43-aa13-87ccac2a0f29?alt=media&token=46b67e96-0b79-4c01-9bae-8b708842a1b2" ></span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">This serum promises to transform your skin </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">in just 5 seconds</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">—barely enough time to brew a cup of instant coffee! The secret? Low molecular hyaluronic acid, which hydrates and soothes from within. Its lightweight texture absorbs almost instantly, leaving no stickiness—it\'s like your skin is drinking it in! Plus, it tackles the root cause of dehydration, which is a major plus unless you\'re aiming for a Sahara-like dryness.</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);"><img src="https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea0a6cef-db3a-4646-b5f8-2cdffc41aeb2?alt=media&token=884ea0f2-ccdd-4031-aee8-6ef17c0815f1" ></span></p><h2><strong style="background-color: transparent; color: rgb(0, 0, 0);">KUP\'s Review:</strong></h2><p><span style="background-color: transparent; color: rgb(0, 0, 0);">Korean skincare has set the gold standard in beauty, and these </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">top 3 serums</strong><span style="background-color: transparent; color: rgb(0, 0, 0);"> are your key to achieving radiant, healthy skin. Each product has been thoughtfully selected for its effectiveness and popularity, cherished by beauty enthusiasts who understand the importance of a nurturing routine.</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">Incorporating these serums into your daily regimen means prioritizing your skin\'s health and well-being. They offer more than just results—they provide a moment of self-care, inviting you to take time for yourself.</span></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">At </span><strong style="background-color: transparent; color: rgb(0, 0, 0);">KUP</strong><span style="background-color: transparent; color: rgb(0, 0, 0);">, we\'re dedicated to your skincare journey. We aim to provide the support and guidance you need as you explore the best products for your skin. By choosing these top serums, you’re investing in quality and becoming part of a community that values your well-being. Discover how these products can enhance your routine.</span></p>',
      products: [
        {
          type: 'product',
          id: '7bbdd23b-6b49-4841-8a7d-3471ae20483f',
          slug: 'vtcosmetics-riddleshot-miniature-compact-set',
          url: '/shop/product/7bbdd23b-6b49-4841-8a7d-3471ae20483f',
          images: [
            'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F4124b2e0-29a5-494c-8f86-6cf21c38766c?alt=media&token=3668b152-bf42-455a-a5e7-e5f489b6f612',
          ],
          name: 'Riddle Shot Miniature 10ml x 3P Compact Set',
          tags: ['Riddle', 'Compact Set'],
          price: '34,400₩',
          description:
            'Reedle Shot is a lightweight, fast-absorbing formula that improves skin texture and renewal with CICA REEDLE.',
        },
      ],
      createdAt: '2024-10-23T00:37:36.760Z',
      updatedAt: '2024-10-23T00:37:36.760Z',
    },
  ],

  'discovery-food': [
    {
      id: 'guide-top-10-recommendations',
      slug: 'guide-top-10-recommendations',
      category: 'discovery-food',
      title: "Guide's Top 10 Recommended in Seoul",
      description:
        'Explore the top 10 famous Korean cuisines in Seoul with KUP, ranging from chicken dishes and Korean BBQ to the most traditional Korean soup-based cuisines!',
      mapZoom: 11,
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F34aacd70-d2eb-4ecc-a0bb-91d97ceb0363?alt=media&token=05132d99-6461-4353-a91e-b24a6d23ef9e',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2c57ff1c-9235-4b40-8903-199024188f56?alt=media&token=a3aa6e56-767a-4109-a59d-5bc8cccec79c',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F9bb8f88d-0253-4b26-b112-2cce02f934ed?alt=media&token=5f9c5a61-a010-48bb-bc1f-9f6db6af3007',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F73b75554-89c2-4a01-a253-36abca4f0507?alt=media&token=2fa6904d-7424-4a40-aa74-8e9c45311bad',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8e46cee5-b183-4d7b-95b5-23c22793c4c4?alt=media&token=4d6eeccc-a892-43d0-9207-e45a68bdae58',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fedb0929a-72a6-4548-9dc5-ff7d8c44b95e?alt=media&token=d3c2f4aa-b869-41f2-92f8-78eefd33a215',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ffbcab46e-35fe-4b4e-baa2-5c910ee9cefa?alt=media&token=f5bdec44-4190-476a-beb4-8509c93c1a0f',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe2053c9f-eb13-428e-9b29-404cefa65860?alt=media&token=139826cf-4e63-4e75-8655-0f9b6e9e6bb3',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F859536b0-5b7f-4c2b-af3c-4221244060db?alt=media&token=01a89589-a37b-426f-8a19-49f22b727619',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff42bc99e-6920-4a07-965c-c8c22ea844f4?alt=media&token=05554250-2f96-478a-8f15-5a4d88b1b05d',
      ],
      createdAt: '2024-10-17T09:01:54.084Z',
      updatedAt: '2024-10-17T09:01:54.084Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['discover-tradition-in-every-bite-at-gyerim-restaurant'],
        PLACE_DETAILS['daeryeon-house-sip-slurp-savor'],
        PLACE_DETAILS['ttosuns-restaurant-where-every-bite-is-a-k-drama-delight'],
        PLACE_DETAILS['mokmyeoksanbang-discover-michelin-star-bibimbap'],
        PLACE_DETAILS[
          'bornga-dak-hanmari-taste-tradition-dakbokkeumtang-and-dakhanmari-done-right'
        ],
        PLACE_DETAILS['sindonggung-taste-korea-24-hours'],
        PLACE_DETAILS['inamjang-over-50-years-of-flavor'],
        PLACE_DETAILS['hannam-pig-house-joy-in-every-bite'],
        PLACE_DETAILS['hadongkwan-timeless-taste-of-hanwoo-beef-soup'],
        PLACE_DETAILS['hannamdong-hanbang-tongdak-seouls-finest-roasted-chicken'],
      ],
    },
    {
      id: 'seoul-hongdae-top-5-recommendations',
      slug: 'seoul-hongdae-top-5-recommendations',
      category: 'discovery-food',
      title: 'Hongik Univ. Station Top 5 Recommendations',
      description:
        'Explore five top-rated restaurants in Hongik Univ. Station, ranging from Korean barbecue to authentic Thai cuisine.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F72fe9b2b-ddb9-4c2a-a327-9d3d7f6f83fd?alt=media&token=966c3e78-ba28-4717-85b7-37414511baa5',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Faf3f3bb8-4ccb-4802-9904-a8ece3632901?alt=media&token=dde19bdd-a0e0-48cb-9d85-fc38794f022e',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F34458718-c625-4f5c-8674-adfb7f13fc3d?alt=media&token=6af21b3f-5193-4af3-a8c4-690cef7455d5',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F90df9029-1506-47a5-86b7-69505df25677?alt=media&token=cb69c887-2c0c-4a6e-ab62-5681786d6674',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F222541ac-fdae-4b68-85b4-232bda485cc7?alt=media&token=1377ddc9-d8ec-4a04-85aa-2189f9dc5c9a',
      ], // Replace with actual image URLs
      createdAt: '2024-10-02T08:58:50.301Z',
      updatedAt: '2024-10-02T08:58:50.301Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['fried-pigs-feet-a-crunch-above-the-rest'],
        PLACE_DETAILS['suragan-home-cooked-korean-comfort-taste-the-love'],
        PLACE_DETAILS[
          'pul-tteunneun-pig-redefines-bbq-experience-the-freshness-of-pork-and-minari'
        ],
        PLACE_DETAILS['solsot-where-traditional-korean-flavors-come-to-life'],
        PLACE_DETAILS['amazing-nongkhai-authentic-thai-flavors-straight-from-thailand'],
      ],
    },
    {
      id: 'seoul-myeongdong-top-5-recommendations',
      slug: 'seoul-myeongdong-top-5-recommendations',
      category: 'discovery-food',
      title: 'Myeongdong Top 5 Recommendations',
      description:
        'Explore five top-rated restaurants in Myeongdong, ranging from Korean-style Chinese cuisine to cold noodles and spicy stir-fried chicken.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fb43b2b84-fab7-44c1-b484-920c5168e037?alt=media&token=0c44f869-a6a4-46a5-b6b1-2ed4eb7dab0f',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2b2cb3b1-029d-401e-8c90-3a1c573ef2e0?alt=media&token=2b638a55-4069-49ad-9345-faa3509f3ede',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fae0a1b00-19fd-4b69-bb16-a12e1410a0f7?alt=media&token=71e03721-b544-4f9f-80d6-a091f127a0fa',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc034c5e0-ef60-460c-923f-721c4562b189?alt=media&token=00a3d18d-5305-448c-9e0e-92bbb6da46e2',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F27dc73ee-334f-4e54-9bb9-e1089a6675b1?alt=media&token=bf0680a4-8369-4266-8b23-08c3230b36e6',
      ], // Replace with actual image URLs
      createdAt: '2024-10-11T08:58:50.301Z',
      updatedAt: '2024-10-11T08:58:50.301Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['michelin-seoul-cold-noodle'],
        PLACE_DETAILS['bantienyao-kaowi-chinese-fried-fish-hotpot'],
        PLACE_DETAILS['chinese-lanzhou-ramen'],
        PLACE_DETAILS['donugak-korean-beef-bbq'],
        PLACE_DETAILS['jangin-spicy-stir-fried-chicken'],
      ],
    },
    {
      id: 'seoul-seongsu-top-5-recommendations',
      slug: 'seoul-seongsu-top-5-recommendations',
      category: 'discovery-food',
      title: 'Seongsu Top 5 Recommendations',
      description:
        'Explore five top-rated restaurants in Seongsu, ranging from the traditional Korean Pork Spine Soup to the famous American Hamburger.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F1ca57bd4-3eba-444d-aae0-3459efc50827?alt=media&token=4152cb67-9108-4821-b0d9-737550be38c1',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F164aebad-f601-4a23-97e7-f864bb03228d?alt=media&token=51417bfe-6ba6-4e5b-9716-76e46e97e0de',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F84e2d53d-a6b6-4c11-bac6-0f71b8182210?alt=media&token=208e8244-1640-40e4-a1e7-f7cb82103922',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0a254d5a-f1d0-4d77-bf3a-5ea6afb54a3d?alt=media&token=74ba5e77-ea2f-4dc0-a492-252c7e6b856f',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F066d510a-59f3-4492-b5c6-ef67ea762007?alt=media&token=fe80ee7a-e05c-48dd-afe9-2652bb47ac18',
      ], // Replace with actual image URLs
      createdAt: '2024-10-11T08:58:50.301Z',
      updatedAt: '2024-10-11T08:58:50.301Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['seongsu-darak-the-expert-in-pasta-and-omurice'],
        PLACE_DETAILS['somun-nan-seongsu-gamjatang-pork-spine-soup'],
        PLACE_DETAILS['jojo-noodle-soup-with-fresh-clams-and-noodles'],
        PLACE_DETAILS['elder-burger-the-best-burger-in-seoungsu'],
        PLACE_DETAILS['salladaeng-a-taste-of-french-and-thai'],
      ],
    },
    {
      id: 'seoul-kondae-top-5-recommendations',
      slug: 'seoul-kondae-top-5-recommendations',
      category: 'discovery-food',
      title: 'Konkuk Univ.  Top 5 Recommendations',
      description:
        'Explore five top-rated restaurants in the Konkuk University area, offering a diverse range of Asian cuisines like authentic noodles, Vietnamese pho, and grilled intestines, alongside delicious Italian pizza.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2e3ac065-5706-4db0-a6a3-347ea1ce8d21?alt=media&token=44c76ab7-8bb4-471a-83d1-515864c28c53',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc13ac82c-486c-4850-859f-e126dbcaf063?alt=media&token=c20973a2-cb97-4d07-870f-b9d3124b9993',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea5c1738-a011-4adf-b3f1-963b4345c9d3?alt=media&token=ca188847-c8d6-44d5-beb5-fc95ee85f8b5',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fc1ac7b42-1288-4cc6-ada2-668d3cb695c1?alt=media&token=bd56c3f3-5131-4708-b9c6-0f3c1aea92f0',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7eae9518-40d4-4836-932f-e040ea73aa56?alt=media&token=4aed61d6-7ab3-4c24-a96e-12c146cf2d58',
      ],
      createdAt: '2024-10-16T07:01:54.084Z',
      updatedAt: '2024-10-16T07:01:54.084Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['jungmyeon-noodles-from-the-heart'],
        PLACE_DETAILS['songhwa-sansi-dosangmyeon-brings-the-taste-shanxi-to-you'],
        PLACE_DETAILS['drawing-recipe-the-authentic-homemade-pizza'],
        PLACE_DETAILS['dodo-grilled-tripe-discover-the-best-in-grilled-tripe-flavors'],
        PLACE_DETAILS['qua-the-taste-of-hanoi'],
      ],
    },
    {
      id: 'itaewon-top-5-recommendations',
      slug: 'itaewon-top-5-recommendations',
      category: 'discovery-food',
      title: 'Itaewon Top 5 Recommendations',
      description:
        'Explore five top-rated restaurants in the Itaewon area, offering a diverse range of international and fusion cuisine, from authentic Russian and Thai dishes to creative Korean-Italian fusions.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F6eeb6386-93b6-4e96-95b8-e83ca6a5e735?alt=media&token=2225dc7b-2ec2-408e-9043-41f25e8e8b6b',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F62c272a7-986a-4fba-b57f-5649de0e6fd1?alt=media&token=27a3d53c-d335-4bb8-838e-6b9eb892ba63',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F0cf1ec9f-4556-4df3-a1c5-35df9ffa2731?alt=media&token=80af059c-0749-4756-a147-4952d176a1fd',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Ff09a5c22-be1b-4ead-8f08-bee0657abb95?alt=media&token=0e5c5d44-ffda-4ce5-a288-a843e5e69fc6',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fa15562c0-49cc-4e6c-b053-4b20d4a2f238?alt=media&token=69d0d34b-9fb1-4036-a851-8c48ce1ce455',
      ],
      createdAt: '2024-10-16T07:01:54.084Z',
      updatedAt: '2024-10-16T07:01:54.084Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['troika-the-taste-of-russia'],
        PLACE_DETAILS['osteria-orzo-the-italian-korean-fusion-restaurant'],
        PLACE_DETAILS['sulkkoma-the-perfect-drinking-spot-in-itaewon'],
        PLACE_DETAILS['buddhas-belly-your-thai-food-destination'],
        PLACE_DETAILS['little-neck-brings-new-york-to-you'],
      ],
    },
    {
      id: 'gwanghwamun-top-5-recommendations',
      slug: 'gwanghwamun-top-5-recommendations',
      category: 'discovery-food',
      title: 'Gwanghwamun Top 5 Recommendations',
      description:
        'Discover the top five must-visit restaurants in Gwanghwamun, from Michelin-starred seafood delicacies to comforting Korean pork rice soups, all offering authentic Korean culinary experiences.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F438e46cf-0dbb-4724-b0a2-310e3ee9198c?alt=media&token=ad49966f-e263-48a8-925d-9818e0307dc7',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fea2f5b23-9119-4fd0-8506-93702504b102?alt=media&token=eb68c1e8-9295-4e4c-a6ef-dbdb0ec49e5f',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fbb3b0752-d763-4aa5-91de-935a6f20d7d1?alt=media&token=af2242a4-59ba-4bcb-b680-697e86822cad',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F8da8fa82-5404-41e9-bf96-3b3dfa3bcbfe?alt=media&token=cdfefdd2-ab63-4383-b5f5-2266b2552624',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd360f0be-5dba-4dac-b368-15410421cd02?alt=media&token=b1d49621-d463-415f-b743-9d77292a61d1',
      ],
      createdAt: '2024-10-17T07:01:54.084Z',
      updatedAt: '2024-10-17T07:01:54.084Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['taste-the-best-traditional-samgyetang-at-tosokchon'],
        PLACE_DETAILS['savor-the-seas-best-at-keunkiwajip'],
        PLACE_DETAILS['taste-the-tradition-of-bossam-at-jeongdabeun-bossam'],
        PLACE_DETAILS['taste-the-mastery-of-anams-pork-rice-soup'],
        PLACE_DETAILS['gwanghwamun-rice-soup-taste-the-best-rice-soup-in-town'],
      ],
    },
    {
      id: 'gangnam-top-5-recommendations',
      slug: 'gangnam-top-5-recommendations',
      category: 'discovery-food',
      title: 'Gangnam Top 5 Recommendations',
      description:
        'Discover the top five must-visit restaurants in Gangnam, from authentic Korean pancakes to unique Vietnamese pho and traditional Singaporean dishes, all offering diverse culinary experiences in the bustling district of Seoul.',
      images: [
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F7ce53326-e589-4bea-9a55-bc8547e4149a?alt=media&token=4d16df3b-2040-4d12-b5f0-5b3fd32a9a08',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F5bc7b3e1-f95e-4fc6-bafb-0367c7fe6f07?alt=media&token=4e51d85f-c2e8-4056-a95d-30b3583a3849',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fd04a5bb5-41db-4cc2-b6cb-77b7867fd3de?alt=media&token=96a3782c-ba3c-4096-b65f-885a2fd376a3',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2F2705b633-b807-4893-8519-4d83d199d13b?alt=media&token=9f893646-9d26-466e-9c12-67564e3d2511',
        'https://firebasestorage.googleapis.com/v0/b/kup-prod-d0e8f.appspot.com/o/discovery%2Fe0a157c7-7929-4572-bb64-32c45f0fb75c?alt=media&token=878fa5d4-5efd-46e2-8f7c-994f89f9a0dc',
      ],
      createdAt: '2024-10-17T09:01:54.084Z',
      updatedAt: '2024-10-17T09:01:54.084Z',
      order: 0,
      html: '',
      places: [
        PLACE_DETAILS['sinsajeon-honeycomb-infused-korean-pancakes'],
        PLACE_DETAILS['sinsa-man-eel-savor-the-flavor-of-korean-tradition'],
        PLACE_DETAILS['gangnam-noodles-cool-noodles-savory-ribs'],
        PLACE_DETAILS['one-degree-north-authentic-singaporean-flavors-in-gangnam'],
        PLACE_DETAILS['ttam-ttam-pho-with-a-twist-flavor-in-every-bite'],
      ],
    },
  ],
};

// Function to return specific Discovery with updated HTML
export const DISCOVERY = (id: string): DiscoveryResponse | undefined => {
  const allDiscoveries = Object.values(DISCOVERIES).flat();
  const discovery = allDiscoveries.find((d) => d.id === id);

  if (discovery) {
    return {
      ...discovery,
    };
  }
  return undefined;
};

// Function to return place details with updated descriptions and HTML
export const DISCOVERY_PLACE = (id: string): DiscoveryPlaceResponse | undefined => {
  const allPlaces = Object.values(DISCOVERIES)
    .flat()
    .flatMap((discovery) => discovery.places || []);
  const placeSimple = allPlaces.find((place) => place.id === id);

  if (placeSimple && PLACE_DETAILS[id]) {
    return PLACE_DETAILS[id];
  }

  return undefined;
};
